export const countriesData = [
  {
    "id": "3",
    "name": "Albania",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Kategoria Superiore",
        "slug": "kategoria-superiore",
        "id": "ALB1"
      },
      {
        "name": "Kategoria e Parë",
        "slug": "kategoria-e-pare",
        "id": "ALB2"
      },
      {
        "name": "Kupa e Shqipërisë",
        "slug": "kupa-e-shqiperise",
        "id": "ALBP"
      },
      {
        "name": "Superkupa e Shqipërisë",
        "slug": "superkupa-e-shqiperise",
        "id": "ALBS"
      },
      {
        "name": "Kategoria Superiore U21",
        "slug": "kategoria-superiore-u21",
        "id": "AL21"
      },
      {
        "name": "Kategoria Superiore Final Four",
        "slug": "kategoria-superiore-final-four",
        "id": "ALP3"
      },
      {
        "name": "Kategoria e Parë Final",
        "slug": "kategoria-e-pare-final",
        "id": "ALP5"
      },
      {
        "name": "Kategoria e Parë Promotion round",
        "slug": "kategoria-e-pare-promotion-round",
        "id": "ALP1"
      },
      {
        "name": "Kategoria e Parë Relegation round",
        "slug": "kategoria-e-pare-relegation-round",
        "id": "ALP2"
      },
      {
        "name": "Relegation Kategoria Superiore",
        "slug": "relegation-kategoria-superiore",
        "id": "ALPO"
      },
      {
        "name": "Relegation Kategoria e Parë",
        "slug": "relegation-kategoria-e-pare",
        "id": "ALP4"
      }
    ]
  },
  {
    "id": "4",
    "name": "Algeria",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Ligue 1",
        "slug": "ligue-1",
        "id": "ALG1"
      },
      {
        "name": "Coupe d'Algerie",
        "slug": "coupe-dalgerie",
        "id": "ALGP"
      },
      {
        "name": "Supercoupe d'Algérie",
        "slug": "supercoupe-dalgerie",
        "id": "AGSC"
      },
      {
        "name": "Coupe de la Ligue d'Algérie",
        "slug": "coupe-de-la-ligue-dalgerie",
        "id": "ALLP"
      },
      {
        "name": "Supercoupe d'Algérie U21",
        "slug": "supercoupe-dalgerie-u21",
        "id": "AGS2"
      }
    ]
  },
  {
    "id": "5",
    "name": "Andorra",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Primera Divisió",
        "slug": "primera-divisio",
        "id": "AND1"
      },
      {
        "name": "Segona Divisió",
        "slug": "segona-divisio",
        "id": "AND2"
      },
      {
        "name": "Copa Constitució",
        "slug": "copa-constitucio",
        "id": "ANDP"
      },
      {
        "name": "Andorran Supercup",
        "slug": "andorran-supercup",
        "id": "ANSC"
      },
      {
        "name": "Championship Round",
        "slug": "championship-round",
        "id": "ANCR"
      },
      {
        "name": "Primera Divisió Playoffs",
        "slug": "primera-divisio-playoffs",
        "id": "ANPO"
      },
      {
        "name": "Relegation Round",
        "slug": "relegation-round",
        "id": "ANRR"
      },
      {
        "name": "Segona Divisió Playoff",
        "slug": "segona-divisio-playoff",
        "id": "AN2P"
      }
    ]
  },
  {
    "id": "9",
    "name": "Argentina",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Torneo Apertura",
        "slug": "torneo-apertura",
        "id": "ARG1"
      },
      {
        "name": "Primera Nacional",
        "slug": "primera-nacional",
        "id": "ARG2"
      },
      {
        "name": "Primera B Metropolitana",
        "slug": "primera-b-metropolitana",
        "id": "URL3"
      },
      {
        "name": "Torneo Federal A",
        "slug": "torneo-federal-a",
        "id": "ARG3"
      },
      {
        "name": "Copa Proyección Apertura",
        "slug": "copa-lpf-proyeccion-apertura",
        "id": "CLPI"
      },
      {
        "name": "Copa Argentina",
        "slug": "copa-argentina",
        "id": "ARCA"
      },
      {
        "name": "Supercopa Internacional",
        "slug": "supercopa-internacional",
        "id": "SCIN"
      },
      {
        "name": "Copa de la Liga Profesional de Fútbol (- 23/24)",
        "slug": "copa-de-la-liga-profesional-de-futbol-23-24-",
        "id": "CDLP"
      },
      {
        "name": "Professional Football League (- 23/24)",
        "slug": "professional-football-league-23-24-",
        "id": "AR1N"
      },
      {
        "name": "Torneo Clausura",
        "slug": "torneo-clausura",
        "id": "ARGC"
      },
      {
        "name": "Federal A - Fase Campeonato",
        "slug": "federal-a-fase-campeonato",
        "id": "AR3F"
      },
      {
        "name": "Federal A - Fase Reválida",
        "slug": "federal-a-fase-revalida",
        "id": "AR3R"
      },
      {
        "name": "Primera División B Apertura",
        "slug": "primera-division-b-apertura",
        "id": "AR3C"
      },
      {
        "name": "Primera División B Clausura",
        "slug": "primera-division-b-clausura",
        "id": "AR3D"
      },
      {
        "name": "Copa LPF Proyección Clausura",
        "slug": "copa-lpf-proyeccion-clausura",
        "id": "CLPF"
      },
      {
        "name": "Torneo Proyección",
        "slug": "torneo-proyeccion",
        "id": "ARY3"
      },
      {
        "name": "Copa Centenario de la AFA",
        "slug": "copa-centenario-de-la-afa",
        "id": "ARC1"
      },
      {
        "name": "Recopa de Campeones",
        "slug": "recopa-de-campeones",
        "id": "ARP2"
      },
      {
        "name": "Copa Bicentenario de la Independencia",
        "slug": "copa-bicentenario-de-la-independencia",
        "id": "CBII"
      },
      {
        "name": "Copa Campeonato",
        "slug": "copa-campeonato",
        "id": "ACO1"
      },
      {
        "name": "Supercopa Argentina",
        "slug": "supercopa-argentina",
        "id": "SCAG"
      },
      {
        "name": "Trofeo de Campeones Superliga",
        "slug": "trofeo-de-campeones-superliga",
        "id": "TDCS"
      },
      {
        "name": "Copa LPF Proyección Apertura Playoff",
        "slug": "copa-lpf-proyeccion-apertura-playoff",
        "id": "CPP1"
      },
      {
        "name": "Copa LPF Proyección Clausura Playoff",
        "slug": "copa-lpf-proyeccion-clausura-playoff",
        "id": "CPP2"
      },
      {
        "name": "Copa Maradona - Fase Complementación",
        "slug": "copa-maradona-fase-complementacion",
        "id": "CDCO"
      },
      {
        "name": "Copa de la Liga Profesional - Playoffs",
        "slug": "copa-de-la-liga-profesional-playoffs",
        "id": "CDCA"
      },
      {
        "name": "Federal A - Fase Reválida Playoff",
        "slug": "federal-a-fase-revalida-playoff",
        "id": "A3RP"
      },
      {
        "name": "First Division Promotion (-11/12)",
        "slug": "first-division-promotion-11-12-",
        "id": "POAR"
      },
      {
        "name": "Liguilla Pre-Libertadores (-14/15)",
        "slug": "liguilla-pre-libertadores-14-15-",
        "id": "ALPL"
      },
      {
        "name": "Liguilla Pre-Sudamericana (-14/15)",
        "slug": "liguilla-pre-sudamericana-14-15-",
        "id": "ALPS"
      },
      {
        "name": "Partidos definición",
        "slug": "partidos-definicion",
        "id": "MARG"
      },
      {
        "name": "Playoff Torneo Apertura",
        "slug": "playoff-torneo-apertura",
        "id": "A1P1"
      },
      {
        "name": "Playoff Torneo Clausura",
        "slug": "playoff-torneo-clausura",
        "id": "A1P2"
      },
      {
        "name": "Primera División B Reducido",
        "slug": "primera-division-b-reducido",
        "id": "AR3B"
      },
      {
        "name": "Primera Nacional - Reducido",
        "slug": "primera-nacional-reducido",
        "id": "A2TP"
      },
      {
        "name": "Promoción Primera B Nacional (-11/12)",
        "slug": "promocion-primera-b-nacional-11-12-",
        "id": "P2AR"
      },
      {
        "name": "Tercer Ascenso Federal A & Primera B Metro",
        "slug": "tercer-ascenso-federal-a-amp-primera-b-metro",
        "id": "AR3A"
      },
      {
        "name": "Torneo Federal A Playoff",
        "slug": "torneo-federal-a-playoff",
        "id": "AR3P"
      },
      {
        "name": "Copa Superliga (-19/20)",
        "slug": "copa-superliga-19-20-",
        "id": "ARLC"
      },
      {
        "name": "Transición Primera Nacional",
        "slug": "transicion-primera-nacional",
        "id": "AR2T"
      },
      {
        "name": "Trofeo de Campeones Proyección",
        "slug": "trofeo-de-campeones-proyeccion",
        "id": "AJSC"
      }
    ]
  },
  {
    "id": "10",
    "name": "Armenia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier League",
        "slug": "premier-league",
        "id": "ARM1"
      },
      {
        "name": "First League",
        "slug": "armenian-first-league",
        "id": "ARM2"
      },
      {
        "name": "Armenian Independence Cup",
        "slug": "armenian-independence-cup",
        "id": "ARPO"
      },
      {
        "name": "Armenian Supercup",
        "slug": "armenian-supercup",
        "id": "ARSC"
      },
      {
        "name": "U18 Patanekan Arajnutyun",
        "slug": "u18-patanekan-arajnutyun",
        "id": "AR18"
      }
    ]
  },
  {
    "id": "12",
    "name": "Australia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "A-League Men",
        "slug": "a-league-men",
        "id": "AUS1"
      },
      {
        "name": "NPL Victoria",
        "slug": "national-premier-league-victoria",
        "id": "A2VI"
      },
      {
        "name": "NPL New South Wales",
        "slug": "national-premier-league-new-south-wales",
        "id": "A2SW"
      },
      {
        "name": "Australia Cup",
        "slug": "australia-cup",
        "id": "FFAC"
      },
      {
        "name": "A-League Men Finals Series",
        "slug": "a-league-men-finals-series",
        "id": "AUSF"
      },
      {
        "name": "NPL - New South Wales Finals",
        "slug": "npl-new-south-wales-finals",
        "id": "NPWF"
      },
      {
        "name": "NPL - Victoria Finals",
        "slug": "npl-victoria-finals",
        "id": "NPVF"
      },
      {
        "name": "Australian Championship",
        "slug": "australian-championship",
        "id": "AU3C"
      }
    ]
  },
  {
    "id": "127",
    "name": "Austria",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Bundesliga",
        "slug": "bundesliga",
        "id": "A1"
      },
      {
        "name": "2. Liga",
        "slug": "2-liga",
        "id": "A2"
      },
      {
        "name": "Regional League Central",
        "slug": "regional-league-central",
        "id": "ATRM"
      },
      {
        "name": "Regionalliga West",
        "slug": "regionalliga-west",
        "id": "ATRW"
      },
      {
        "name": "Regional League East",
        "slug": "regional-league-east",
        "id": "ATRO"
      },
      {
        "name": "LL Niederösterreich",
        "slug": "1-landesliga-niederosterreich",
        "id": "A4N"
      },
      {
        "name": "Wiener Stadtliga",
        "slug": "wiener-stadtliga",
        "id": "A4W"
      },
      {
        "name": "Kärntner Liga",
        "slug": "karntner-liga",
        "id": "A4K"
      },
      {
        "name": "Regionalliga Tirol",
        "slug": "regionalliga-tirol",
        "id": "A4T"
      },
      {
        "name": "Eliteliga Vorarlberg",
        "slug": "eliteliga-vorarlberg",
        "id": "A4V"
      },
      {
        "name": "LL Steiermark",
        "slug": "landesliga-steiermark",
        "id": "A4ST"
      },
      {
        "name": "Burgenlandliga",
        "slug": "burgenlandliga",
        "id": "A4B"
      },
      {
        "name": "OÖ Liga",
        "slug": "oberosterreich-liga",
        "id": "A4O"
      },
      {
        "name": "Salzburger Liga",
        "slug": "salzburger-liga",
        "id": "A4S"
      },
      {
        "name": "ÖFB Jugendliga U18",
        "slug": "ofb-jugendliga-u18",
        "id": "JGD2"
      },
      {
        "name": "ÖFB Jugendliga U16",
        "slug": "ofb-jugendliga-u16",
        "id": "JGD3"
      },
      {
        "name": "ÖFB-Cup",
        "slug": "ofb-cup",
        "id": "ofb"
      },
      {
        "name": "Nationalliga (- 1974)",
        "slug": "nationalliga-1974-",
        "id": "A1H1"
      },
      {
        "name": "Wiener Liga (- 1949)",
        "slug": "wiener-liga-1949-",
        "id": "A1H2"
      },
      {
        "name": "Eliteliga Vorarlberg (- 2023)",
        "slug": "eliteliga-vorarlberg-2023-",
        "id": "ELVA"
      },
      {
        "name": "Eliteliga Vorarlberg Abstiegsrunde (- 2023)",
        "slug": "eliteliga-vorarlberg-abstiegsrunde-2023-",
        "id": "EVAA"
      },
      {
        "name": "Regionalliga Salzburg (- 2023)",
        "slug": "regionalliga-salzburg-2023-",
        "id": "ELSA"
      },
      {
        "name": "Regionalliga Salzburg Abstiegsrunde (- 2023)",
        "slug": "regionalliga-salzburg-abstiegsrunde-2023-",
        "id": "RLSA"
      },
      {
        "name": "Regionalliga Tirol (- 2023)",
        "slug": "regionalliga-tirol-2023-",
        "id": "ELTI"
      },
      {
        "name": "Regionalliga Tirol Abstiegsrunde (- 2023)",
        "slug": "regionalliga-tirol-abstiegsrunde-2023-",
        "id": "ELTA"
      },
      {
        "name": "ÖFB Jugendliga U17 (- 2010)",
        "slug": "ofb-jugendliga-u17-2010-",
        "id": "AJ17"
      },
      {
        "name": "ÖFB Jugendliga U19 (- 2010)",
        "slug": "ofb-jugendliga-u19-2010-",
        "id": "JGD"
      },
      {
        "name": "Austrian Amateur State Championship (- 1937)",
        "slug": "austrian-amateur-state-championship-1937-",
        "id": "ATAC"
      },
      {
        "name": "ÖFB-Supercup (- 2005)",
        "slug": "ofb-supercup-2005-",
        "id": "OFBS"
      },
      {
        "name": "Bundesliga Europacup-Play-off",
        "slug": "bundesliga-europacup-play-off",
        "id": "A1EL"
      },
      {
        "name": "Meister-Playoff LL Niederösterreich (- 1946)",
        "slug": "meister-playoff-ll-niederosterreich-1946-",
        "id": "LN%C3%96P"
      },
      {
        "name": "Mittleres Playoff (- 1993)",
        "slug": "mittleres-playoff-1993-",
        "id": "ATMP"
      },
      {
        "name": "Relegation Bundesliga (- 2021)",
        "slug": "relegation-bundesliga-2021-",
        "id": "A1R"
      },
      {
        "name": "Relegation Erste Liga (- 2015)",
        "slug": "relegation-erste-liga-2015-",
        "id": "A2RE"
      },
      {
        "name": "Relegation Kärntner Liga",
        "slug": "relegation-karntner-liga",
        "id": "A4KR"
      },
      {
        "name": "Relegation Landesliga Steiermark",
        "slug": "relegation-landesliga-steiermark",
        "id": "RLS1"
      },
      {
        "name": "Relegation Oberösterreich Liga",
        "slug": "relegation-oberosterreich-liga",
        "id": "A4OR"
      },
      {
        "name": "Relegation Regionalliga Ost (- 2022)",
        "slug": "relegation-regionalliga-ost-2022-",
        "id": "RRLO"
      },
      {
        "name": "Relegation Regionalliga Tirol",
        "slug": "relegation-regionalliga-tirol",
        "id": "RRLT"
      }
    ]
  },
  {
    "id": "13",
    "name": "Azerbaijan",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premyer Liqa",
        "slug": "premyer-liqa",
        "id": "AZ1"
      },
      {
        "name": "Azerbaycan Kuboku",
        "slug": "azerbaycan-kuboku",
        "id": "ASPK"
      },
      {
        "name": "Premyer Liqasi Abstiegsrunde",
        "slug": "premyer-liqasi-abstiegsrunde",
        "id": "AZ1A"
      },
      {
        "name": "Premyer Liqasi Meisterschaftsrunde",
        "slug": "premyer-liqasi-meisterschaftsrunde",
        "id": "AZ1M"
      }
    ]
  },
  {
    "id": "16",
    "name": "Bangladesh",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "BFL",
        "slug": "bangladesh-football-league",
        "id": "BGD1"
      },
      {
        "name": "Federation Cup",
        "slug": "bangladesh-federation-cup",
        "id": "BGDP"
      },
      {
        "name": "Bangladesh Super Cup",
        "slug": "bangladesh-super-cup",
        "id": "BGSC"
      },
      {
        "name": "Bangladesh Federation Cup (Special)",
        "slug": "bangladesh-federation-cup-special-",
        "id": "BGF2"
      }
    ]
  },
  {
    "id": "18",
    "name": "Belarus",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Vysheyshaya Liga",
        "slug": "vysheyshaya-liga",
        "id": "WER1"
      },
      {
        "name": "Pershaya Liga",
        "slug": "pershaya-liga",
        "id": "WER2"
      },
      {
        "name": "Belarusian Cup",
        "slug": "belarusian-cup",
        "id": "WRPO"
      },
      {
        "name": "Belarusian Super Cup",
        "slug": "belarusian-super-cup",
        "id": "WRSP"
      },
      {
        "name": "Vysheyshaya Liga 1994/95",
        "slug": "vysheyshaya-liga-1994-95",
        "id": "BR94"
      },
      {
        "name": "Relegation Belarus",
        "slug": "relegation-belarus",
        "id": "BELR"
      },
      {
        "name": "Relegation Pershaya Liga",
        "slug": "relegation-pershaya-liga",
        "id": "BLR2"
      },
      {
        "name": "Relegation Pershaya Liga",
        "slug": "relegation-pershaya-liga",
        "id": "BLRR"
      },
      {
        "name": "Wyschejschaja Liha Abstiegsrunde",
        "slug": "wyschejschaja-liha-abstiegsrunde",
        "id": "WERA"
      },
      {
        "name": "Wyschejschaja Liha Meisterrunde",
        "slug": "wyschejschaja-liha-meisterrunde",
        "id": "WERM"
      }
    ]
  },
  {
    "id": "19",
    "name": "Belgium",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Jupiler Pro League",
        "slug": "jupiler-pro-league",
        "id": "BE1"
      },
      {
        "name": "Challenger Pro League",
        "slug": "challenger-pro-league",
        "id": "BE2"
      },
      {
        "name": "1ste Nationale ACFF",
        "slug": "1ste-nationale-acff",
        "id": "BE3A"
      },
      {
        "name": "1ste Nationale VV",
        "slug": "1ste-nationale-vv",
        "id": "BE3V"
      },
      {
        "name": "2de Nationale VV B",
        "slug": "2de-nationale-vv-b",
        "id": "VFVB"
      },
      {
        "name": "2de Nationale VV A",
        "slug": "2de-nationale-vv-a",
        "id": "VFVA"
      },
      {
        "name": "2de Nationale ACFF",
        "slug": "2de-nationale-acff",
        "id": "ACFF"
      },
      {
        "name": "3de Nationale VV A",
        "slug": "3de-nationale-vv-a",
        "id": "BE5A"
      },
      {
        "name": "3de Nationale VV B",
        "slug": "3de-nationale-vv-b",
        "id": "BE5B"
      },
      {
        "name": "U18 Elite 1",
        "slug": "u18-elite-1-belgium",
        "id": "BEY1"
      },
      {
        "name": "U21 Pro League",
        "slug": "u21-pro-league",
        "id": "BE21"
      },
      {
        "name": "Croky Cup",
        "slug": "croky-cup",
        "id": "CCB"
      },
      {
        "name": "Volkswagen Supercup",
        "slug": "volkswagen-supercup",
        "id": "BESC"
      },
      {
        "name": "Jupiler Pro League Champions' Play-Offs",
        "slug": "jupiler-pro-league-champions-play-offs",
        "id": "EJPL"
      },
      {
        "name": "Jupiler Pro League Europe Play-Offs",
        "slug": "jupiler-pro-league-europe-play-offs",
        "id": "POBE"
      },
      {
        "name": "JPL Relegation Play-Offs",
        "slug": "jupiler-pro-league-relegation-play-offs",
        "id": "BPO4"
      },
      {
        "name": "1ste NAT ACFF REL PO",
        "slug": "1ste-nationale-acff-relegation-play-offs",
        "id": "BE3B"
      },
      {
        "name": "1ste Nationale ACFF Promotion Play-Offs",
        "slug": "1ste-nationale-acff-promotion-play-offs",
        "id": "B3AB"
      },
      {
        "name": "1ste Nationale",
        "slug": "1ste-nationale",
        "id": "BEL3"
      },
      {
        "name": "U18 Elite 1 PO A",
        "slug": "u18-elite-1-po-a",
        "id": "BEYP"
      },
      {
        "name": "U18 Elite 1 PO B",
        "slug": "u18-elite-1-po-b",
        "id": "BEYO"
      },
      {
        "name": "U18 Elite 2 - Belgium",
        "slug": "u18-elite-2-belgium",
        "id": "BEY2"
      },
      {
        "name": "2de Nationale Play-Offs Degradatie",
        "slug": "2de-nationale-play-offs-degradatie",
        "id": "2NP2"
      },
      {
        "name": "2de Nationale Play-Offs Promotie",
        "slug": "2de-nationale-play-offs-promotie",
        "id": "2NPP"
      },
      {
        "name": "2de Nationale Titel van Kampioen",
        "slug": "2de-nationale-titel-van-kampioen",
        "id": "BE4P"
      },
      {
        "name": "3de Nationale Play-Offs Degradatie",
        "slug": "3de-nationale-play-offs-degradatie",
        "id": "3NP2"
      },
      {
        "name": "3de Nationale Play-Offs Promotie",
        "slug": "3de-nationale-play-offs-promotie",
        "id": "3NPP"
      },
      {
        "name": "Aufstiegsrunde Eerste Klasse Amateurs",
        "slug": "aufstiegsrunde-eerste-klasse-amateurs",
        "id": "B3AU"
      },
      {
        "name": "Challenger Pro League Promotion-Playoffs",
        "slug": "challenger-pro-league-promotion-playoffs",
        "id": "BE2E"
      },
      {
        "name": "Challenger Pro League Relegation-Playoffs",
        "slug": "challenger-pro-league-relegation-playoffs",
        "id": "BE2A"
      },
      {
        "name": "Endrunde 2.Division",
        "slug": "endrunde-2-division",
        "id": "POB2"
      },
      {
        "name": "Endrunde Jupiler Pro League",
        "slug": "endrunde-jupiler-pro-league",
        "id": "EBEL"
      },
      {
        "name": "Jupiler Pro League Abstiegs-Playoffs",
        "slug": "jupiler-pro-league-abstiegs-playoffs",
        "id": "EJPD"
      },
      {
        "name": "Jupiler Pro League playoff Europa League",
        "slug": "jupiler-pro-league-playoff-europa-league",
        "id": "ESJP"
      },
      {
        "name": "Ligabeker",
        "slug": "ligabeker",
        "id": "BLP1"
      }
    ]
  },
  {
    "id": "22",
    "name": "Bhutan",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Bhutan Premier League",
        "slug": "bhutan-premier-league",
        "id": "BH1L"
      }
    ]
  },
  {
    "id": "23",
    "name": "Bolivia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "División Profesional",
        "slug": "division-profesional",
        "id": "BO1A"
      },
      {
        "name": "División Profesional Apertura",
        "slug": "division-profesional-apertura",
        "id": "B1AP"
      },
      {
        "name": "División Profesional Clausura",
        "slug": "division-profesional-clausura",
        "id": "BO1C"
      },
      {
        "name": "Copa Simón Bolívar (-2024)",
        "slug": "copa-simon-bolivar-2024-",
        "id": "BOL2"
      },
      {
        "name": "Copa Simón Bolívar Playoff",
        "slug": "copa-simon-bolivar-playoff",
        "id": "BOP2"
      },
      {
        "name": "Copa Bolivia",
        "slug": "copa-bolivia",
        "id": "BVC1"
      },
      {
        "name": "División Profesional Apertura Playoff",
        "slug": "division-profesional-apertura-playoff",
        "id": "B1P1"
      },
      {
        "name": "División Profesional Clausura Playoff",
        "slug": "division-profesional-clausura-playoff",
        "id": "B1P2"
      },
      {
        "name": "División Profesional Relegation",
        "slug": "division-profesional-relegation",
        "id": "BO1P"
      },
      {
        "name": "Copa División Profesional",
        "slug": "copa-division-profesional",
        "id": "BO12"
      }
    ]
  },
  {
    "id": "24",
    "name": "Bosnia-Herzegovina",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premijer Liga BiH",
        "slug": "premijer-liga-bosne-i-hercegovine",
        "id": "BOS1"
      },
      {
        "name": "Prva liga FBIH",
        "slug": "prva-liga-fbih",
        "id": "BOS2"
      },
      {
        "name": "Prva Liga RS",
        "slug": "prva-liga-rs",
        "id": "BH2S"
      },
      {
        "name": "Premijer Liga BiH U19",
        "slug": "premijer-liga-bih-u19",
        "id": "BI19"
      },
      {
        "name": "Premijer Liga BiH U17",
        "slug": "premijer-liga-bih-u17",
        "id": "BI17"
      },
      {
        "name": "Kup BiH",
        "slug": "kup-bih",
        "id": "BIHP"
      },
      {
        "name": "Superkup BiH",
        "slug": "superkup-bih",
        "id": "BHSC"
      },
      {
        "name": "Relegation Premijer Liga",
        "slug": "relegation-premijer-liga",
        "id": "BOSR"
      }
    ]
  },
  {
    "id": "26",
    "name": "Brazil",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Série A",
        "slug": "campeonato-brasileiro-serie-a",
        "id": "BRA1"
      },
      {
        "name": "Série B",
        "slug": "campeonato-brasileiro-serie-b",
        "id": "BRA2"
      },
      {
        "name": "Série C",
        "slug": "campeonato-brasileiro-serie-c",
        "id": "BRA3"
      },
      {
        "name": "Série D",
        "slug": "campeonato-brasileiro-serie-d",
        "id": "BRA4"
      },
      {
        "name": "CBF Brasileiro U20",
        "slug": "cbf-brasileiro-u20",
        "id": "CB20"
      },
      {
        "name": "Copa do Brasil",
        "slug": "copa-do-brasil",
        "id": "BRC"
      },
      {
        "name": "Supercopa Rei",
        "slug": "supercopa-rei",
        "id": "SCBR"
      },
      {
        "name": "Camp. Paranaense Play-off",
        "slug": "campeonato-paranaense-quadrangular-de-rebaixamen",
        "id": "BRP1"
      },
      {
        "name": "Camp. Goiano Play-off",
        "slug": "campeonato-goiano-quadrangular-de-rebaixamento",
        "id": "BRP2"
      },
      {
        "name": "Camp. Maranhense Play-off",
        "slug": "campeonato-maranhense-quadrangular-de-rebaixamen",
        "id": "BRP4"
      },
      {
        "name": "Copinha",
        "slug": "copa-sao-paulo-de-futebol-junior",
        "id": "SPjr"
      },
      {
        "name": "Copa do Nordeste",
        "slug": "copa-do-nordeste",
        "id": "BRNE"
      },
      {
        "name": "Copa Verde",
        "slug": "copa-verde",
        "id": "BRVE"
      },
      {
        "name": "Taça Acesc 70 anos",
        "slug": "taca-acesc-70-anos",
        "id": "BRP6"
      },
      {
        "name": "Troféu Farroupilha",
        "slug": "trofeu-farroupilha",
        "id": "BRCC"
      },
      {
        "name": "Campeonato Paulista",
        "slug": "campeonato-paulista",
        "id": "BCP1"
      },
      {
        "name": "Campeonato Carioca",
        "slug": "campeonato-carioca",
        "id": "BRCG"
      },
      {
        "name": "Campeonato Mineiro",
        "slug": "campeonato-mineiro",
        "id": "BRCM"
      },
      {
        "name": "Campeonato Gaúcho",
        "slug": "campeonato-gaucho",
        "id": "BRRS"
      },
      {
        "name": "Campeonato Baiano",
        "slug": "campeonato-baiano",
        "id": "BRCB"
      },
      {
        "name": "Carioca - Taça Rio",
        "slug": "campeonato-carioca-taca-rio",
        "id": "BRCR"
      },
      {
        "name": "Campeonato Paranaense",
        "slug": "campeonato-paranaense",
        "id": "BRPR"
      },
      {
        "name": "Campeonato Cearense",
        "slug": "campeonato-cearense",
        "id": "BRCE"
      },
      {
        "name": "Campeonato Catarinense",
        "slug": "campeonato-catarinense",
        "id": "BRSC"
      },
      {
        "name": "Campeonato Goiano",
        "slug": "campeonato-goiano",
        "id": "BRGO"
      },
      {
        "name": "Campeonato Paraense",
        "slug": "campeonato-paraense",
        "id": "BRPA"
      },
      {
        "name": "Campeonato Pernambucano",
        "slug": "campeonato-pernambucano",
        "id": "BRPE"
      },
      {
        "name": "Campeonato Alagoano",
        "slug": "campeonato-alagoano",
        "id": "BRAL"
      },
      {
        "name": "Campeonato Mato-Grossense",
        "slug": "campeonato-mato-grossense",
        "id": "BRMS"
      },
      {
        "name": "Campeonato Capixaba",
        "slug": "campeonato-capixaba",
        "id": "BRES"
      },
      {
        "name": "Campeonato Sergipano",
        "slug": "campeonato-sergipano",
        "id": "BRSE"
      },
      {
        "name": "Campeonato Brasiliense",
        "slug": "campeonato-brasiliense",
        "id": "BRDF"
      },
      {
        "name": "Campeonato Sul-Mato-Grossense",
        "slug": "campeonato-sul-mato-grossense",
        "id": "BRMT"
      },
      {
        "name": "Camp. Catarinense Play-off",
        "slug": "campeonato-catarinense-quadrangular-de-rebaixame",
        "id": "BRP3"
      },
      {
        "name": "Campeonato Paraibano",
        "slug": "campeonato-paraibano",
        "id": "BRPB"
      },
      {
        "name": "Camp. Carioca - Play-off",
        "slug": "campeonato-carioca-quadrangular-de-rebaixamento",
        "id": "BRP5"
      },
      {
        "name": "Troféu Inconfidência",
        "slug": "trofeu-inconfidencia",
        "id": "brti"
      },
      {
        "name": "Campeonato Maranhense",
        "slug": "campeonato-maranhense",
        "id": "BRMA"
      },
      {
        "name": "Campeonato Piauiense",
        "slug": "campeonato-piauiense",
        "id": "BRPI"
      },
      {
        "name": "Campeonato Acreano",
        "slug": "campeonato-acreano",
        "id": "BRAC"
      },
      {
        "name": "Campeonato Rondoniense",
        "slug": "campeonato-rondoniense",
        "id": "BRRD"
      },
      {
        "name": "Campeonato Potiguar",
        "slug": "campeonato-potiguar",
        "id": "BRRN"
      },
      {
        "name": "Campeonato Tocantinense",
        "slug": "campeonato-tocantinense",
        "id": "BRTO"
      },
      {
        "name": "Campeonato Roraimense",
        "slug": "campeonato-roraimense",
        "id": "BRRR"
      },
      {
        "name": "Camp. Cearense - Releg.",
        "slug": "campeonato-cearense-relegation-round",
        "id": "BCE2"
      },
      {
        "name": "Campeonato Amapaense",
        "slug": "campeonato-amapaense",
        "id": "BRAP"
      },
      {
        "name": "Campeonato Gaúcho - Releg.",
        "slug": "campeonato-gaucho-relegation-round",
        "id": "BRQR"
      },
      {
        "name": "CBF Brasileiro U20 - Finals",
        "slug": "cbf-brasileiro-u20-finals",
        "id": "C20P"
      },
      {
        "name": "Campeonato Mineiro - Relegation",
        "slug": "campeonato-mineiro-relegation",
        "id": "CMR2"
      },
      {
        "name": "Campeonato Potiguar - Finals",
        "slug": "campeonato-potiguar-finals",
        "id": "CPF1"
      },
      {
        "name": "Primeira Liga do Brasil",
        "slug": "primeira-liga-do-brasil",
        "id": "BRC2"
      },
      {
        "name": "Campeonato Paulista - Troféu Independência",
        "slug": "campeonato-paulista-trofeu-independencia",
        "id": "BCP2"
      },
      {
        "name": "Copa FMF - Maranhão",
        "slug": "copa-fmf-maranhao",
        "id": "CFMF"
      },
      {
        "name": "Copa do Nordeste - Fase Final",
        "slug": "copa-do-nordeste-fase-final",
        "id": "BRNF"
      },
      {
        "name": "Copa do Nordeste - Fase Preliminar",
        "slug": "copa-do-nordeste-fase-preliminar",
        "id": "BRNP"
      },
      {
        "name": "Campeonato Amazonense",
        "slug": "campeonato-amazonense",
        "id": "BRAM"
      },
      {
        "name": "Campeonato Carioca - Final",
        "slug": "campeonato-carioca-final",
        "id": "BRCF"
      },
      {
        "name": "Campeonato Cearense - Finals",
        "slug": "campeonato-cearense-finals",
        "id": "BCE1"
      },
      {
        "name": "Campeonato Gaúcho - 2º Turno",
        "slug": "campeonato-gaucho-2-ordm-turno",
        "id": "BRga"
      },
      {
        "name": "Campeonato Gaúcho - Fase Final",
        "slug": "campeonato-gaucho-fase-final",
        "id": "RS2f"
      },
      {
        "name": "Campeonato Gaúcho - Final",
        "slug": "campeonato-gaucho-final",
        "id": "RSFF"
      },
      {
        "name": "Campeonato Paulista - Série A1 - Fase final",
        "slug": "campeonato-paulista-serie-a1-fase-final",
        "id": "BCPF"
      }
    ]
  },
  {
    "id": "28",
    "name": "Bulgaria",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "efbet Liga",
        "slug": "efbet-liga",
        "id": "BU1"
      },
      {
        "name": "Vtora Liga",
        "slug": "vtora-liga",
        "id": "BU2"
      },
      {
        "name": "Bulgarian Cup",
        "slug": "bulgarian-cup",
        "id": "BULP"
      },
      {
        "name": "Bulgarian Super Cup",
        "slug": "bulgarian-super-cup",
        "id": "BULS"
      },
      {
        "name": "Efbet liga - Championship group",
        "slug": "efbet-liga-championship-group",
        "id": "BU1M"
      },
      {
        "name": "Efbet liga - Relegation group",
        "slug": "efbet-liga-relegation-group",
        "id": "BU1A"
      },
      {
        "name": "Parva Liga - Europa League Playoff",
        "slug": "parva-liga-europa-league-playoff",
        "id": "BGEL"
      },
      {
        "name": "Relegation/Promotion Playoff Efbet Liga",
        "slug": "relegation-promotion-playoff-efbet-liga",
        "id": "BURL"
      },
      {
        "name": "UECL Playoffs Efbet Liga",
        "slug": "uecl-playoffs-efbet-liga",
        "id": "BUEL"
      }
    ]
  },
  {
    "id": "79",
    "name": "Cambodia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "C. Premier League",
        "slug": "cambodian-premier-league",
        "id": "KHM1"
      },
      {
        "name": "Cambodian Super Cup",
        "slug": "cambodian-super-cup",
        "id": "CSPC"
      },
      {
        "name": "Cambodian Premier League - Finals",
        "slug": "cambodian-premier-league-finals",
        "id": "CBP1"
      }
    ]
  },
  {
    "id": "80",
    "name": "Canada",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "CanPL",
        "slug": "canadian-premier-league",
        "id": "CDN1"
      },
      {
        "name": "Canadian Premier League Fall Season",
        "slug": "canadian-premier-league-fall-season",
        "id": "CA1F"
      },
      {
        "name": "Canadian Premier League Spring Season",
        "slug": "canadian-premier-league-spring-season",
        "id": "CAN1"
      },
      {
        "name": "Canadian Championship",
        "slug": "canadian-championship",
        "id": "CAN"
      },
      {
        "name": "Canadian Premier League Playoffs",
        "slug": "canadian-premier-league-playoffs",
        "id": "CAPL"
      }
    ]
  },
  {
    "id": "33",
    "name": "Chile",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga Primera",
        "slug": "liga-de-primera",
        "id": "CLPD"
      },
      {
        "name": "Liga de Ascenso",
        "slug": "liga-de-ascenso",
        "id": "CL2B"
      },
      {
        "name": "Segunda División",
        "slug": "segunda-division-profesional",
        "id": "CHI3"
      },
      {
        "name": "Copa Chile",
        "slug": "copa-chile",
        "id": "CH1C"
      },
      {
        "name": "Supercopa de Chile",
        "slug": "supercopa-de-chile",
        "id": "CSUC"
      },
      {
        "name": "Copa de la Liga",
        "slug": "copa-de-la-liga-de-chile",
        "id": "CLLC"
      },
      {
        "name": "Torneo Apertura (-2016)",
        "slug": "torneo-apertura-2016-",
        "id": "CHLA"
      },
      {
        "name": "Torneo Clausura (-2017)",
        "slug": "torneo-clausura-2017-",
        "id": "CHL1"
      },
      {
        "name": "Torneo Transición (-2017)",
        "slug": "torneo-transicion-2017-",
        "id": "CHI%C3%9C"
      },
      {
        "name": "Primera B Apertura (-2015)",
        "slug": "primera-b-apertura-2015-",
        "id": "CHL2"
      },
      {
        "name": "Primera B Clausura (-2016)",
        "slug": "primera-b-clausura-2016-",
        "id": "CH2C"
      },
      {
        "name": "Apertura Final",
        "slug": "apertura-final",
        "id": "CHAF"
      },
      {
        "name": "Copa Sudamericana playoff",
        "slug": "copa-sudamericana-playoff",
        "id": "CHDE"
      },
      {
        "name": "Liguilla Pre Libertadores",
        "slug": "liguilla-pre-libertadores",
        "id": "LCLC"
      },
      {
        "name": "Liguilla de Promoción",
        "slug": "liguilla-de-promocion",
        "id": "CHDP"
      },
      {
        "name": "Liguilla de Promoción Primera B",
        "slug": "liguilla-de-promocion-primera-b",
        "id": "CL2P"
      },
      {
        "name": "Torneo Apertura play-offs",
        "slug": "torneo-apertura-play-offs",
        "id": "CHPL"
      },
      {
        "name": "Torneo Clausura play-offs",
        "slug": "torneo-clausura-play-offs",
        "id": "CHLP"
      }
    ]
  },
  {
    "id": "34",
    "name": "China",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Super League",
        "slug": "chinese-super-league",
        "id": "CSL"
      },
      {
        "name": "League One",
        "slug": "china-league-one",
        "id": "CLO"
      },
      {
        "name": "League Two A",
        "slug": "china-league-two-a",
        "id": "CHL3"
      },
      {
        "name": "League Two B",
        "slug": "china-league-two-b",
        "id": "CL3S"
      },
      {
        "name": "Champions League (Regional)",
        "slug": "chinese-champions-league-regional-stage-",
        "id": "CN41"
      },
      {
        "name": "Chinese FA Cup",
        "slug": "chinese-fa-cup",
        "id": "CHFA"
      },
      {
        "name": "Chinese Super Cup",
        "slug": "chinese-fa-super-cup",
        "id": "CHSC"
      },
      {
        "name": "China League One Promotion Stage",
        "slug": "china-league-one-promotion-stage",
        "id": "CNPS"
      },
      {
        "name": "China League One Relegation Stage",
        "slug": "china-league-one-relegation-stage",
        "id": "CNRS"
      },
      {
        "name": "China League Two C",
        "slug": "china-league-two-c",
        "id": "CL3C"
      },
      {
        "name": "League Two Promotion Stage",
        "slug": "league-two-promotion-stage",
        "id": "CH3P"
      },
      {
        "name": "League Two Relegation Stage",
        "slug": "league-two-relegation-stage",
        "id": "CH3R"
      },
      {
        "name": "Chinese Champions League (Final Stage)",
        "slug": "chinese-champions-league-final-stage-",
        "id": "CN42"
      },
      {
        "name": "Chinese U21 League (Final Stage)",
        "slug": "chinese-u21-league-final-stage-",
        "id": "CN44"
      },
      {
        "name": "Chinese U21 League (Playoff Stage)",
        "slug": "chinese-u21-league-playoff-stage-",
        "id": "CN43"
      },
      {
        "name": "China League One Relegation Playoffs",
        "slug": "china-league-one-relegation-playoffs",
        "id": "CL1P"
      },
      {
        "name": "China League Two Playoffs",
        "slug": "china-league-two-playoffs",
        "id": "CL3P"
      },
      {
        "name": "Chinese CL / U21 League Play-off",
        "slug": "chinese-cl-u21-league-play-off",
        "id": "CUPP"
      },
      {
        "name": "Chinese Super League Championship Play-Offs",
        "slug": "chinese-super-league-championship-play-offs",
        "id": "CSLC"
      },
      {
        "name": "Chinese Super League Relegation Play-Offs",
        "slug": "chinese-super-league-relegation-play-offs",
        "id": "CSLR"
      }
    ]
  },
  {
    "id": "164",
    "name": "Chinese Taipei",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Football Premier League",
        "slug": "taiwan-football-premier-league",
        "id": "TFPL"
      },
      {
        "name": "Football League Div.2",
        "slug": "taiwan-football-league-div-2",
        "id": "TFL2"
      },
      {
        "name": "Taiwan President FA Cup",
        "slug": "taiwan-president-fa-cup",
        "id": "TWC1"
      },
      {
        "name": "TFPL Relegation/Div.2 Qualification",
        "slug": "tfpl-relegation-div-2-qualification",
        "id": "TPRQ"
      }
    ]
  },
  {
    "id": "83",
    "name": "Colombia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga DIMAYOR I",
        "slug": "liga-dimayor-apertura",
        "id": "COLP"
      },
      {
        "name": "Torneo DIMAYOR I",
        "slug": "torneo-dimayor-i",
        "id": "CO2T"
      },
      {
        "name": "Superliga Águila de Campeones",
        "slug": "superliga-aguila-de-campeones",
        "id": "COSP"
      },
      {
        "name": "Liga DIMAYOR Liguilla (2020)",
        "slug": "liga-dimayor-liguilla-2020-",
        "id": "C1P1"
      },
      {
        "name": "Liga Dimayor Finalización",
        "slug": "liga-dimayor-finalizacion",
        "id": "COL1"
      },
      {
        "name": "Torneo DIMAYOR II",
        "slug": "torneo-dimayor-ii",
        "id": "CO22"
      },
      {
        "name": "Copa Colombia",
        "slug": "copa-colombia",
        "id": "COPO"
      },
      {
        "name": "Fase Final Liga DIMAYOR I",
        "slug": "fase-final-liga-dimayor-i",
        "id": "COLF"
      },
      {
        "name": "Fase Final Liga DIMAYOR II",
        "slug": "fase-final-liga-dimayor-ii",
        "id": "COLO"
      },
      {
        "name": "Fase Final Torneo DIMAYOR I",
        "slug": "fase-final-torneo-dimayor-i",
        "id": "CO2P"
      },
      {
        "name": "Fase Final Torneo DIMAYOR II",
        "slug": "fase-final-torneo-dimayor-ii",
        "id": "C2P2"
      },
      {
        "name": "Liga DIMAYOR Copa Sudamericana Playoff",
        "slug": "liga-dimayor-copa-sudamericana-playoff",
        "id": "C1P2"
      }
    ]
  },
  {
    "id": "35",
    "name": "Comoros",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "D1 Comores",
        "slug": "championnat-des-comores-de-d1",
        "id": "COM1"
      }
    ]
  },
  {
    "id": "36",
    "name": "Costa Rica",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Primera División Apertura",
        "slug": "primera-division-apertura",
        "id": "CRPD"
      },
      {
        "name": "Primera División Clausura",
        "slug": "primera-division-clausura",
        "id": "PDV1"
      },
      {
        "name": "Apertura Play-Off",
        "slug": "primera-division-apertura-play-off",
        "id": "CRPV"
      },
      {
        "name": "Copa de Costa Rica",
        "slug": "copa-de-costa-rica",
        "id": "CRPO"
      },
      {
        "name": "Recopa Costa Rica",
        "slug": "recopa-costa-rica",
        "id": "CSC2"
      },
      {
        "name": "Primera División Apertura Finale",
        "slug": "primera-division-apertura-finale",
        "id": "CIF"
      },
      {
        "name": "Primera División Apertura Seg. Fase (- 17/18)",
        "slug": "primera-division-apertura-seg-fase-17-18-",
        "id": "CISP"
      },
      {
        "name": "Primera División Clausura 2. Stage (- 17/18)",
        "slug": "primera-division-clausura-2-stage-17-18-",
        "id": "CVSP"
      },
      {
        "name": "Primera División Clausura Finale",
        "slug": "primera-division-clausura-finale",
        "id": "CVF"
      },
      {
        "name": "Primera División Clausura Play-Off",
        "slug": "primera-division-clausura-play-off",
        "id": "PDV2"
      },
      {
        "name": "Supercopa de Costa Rica",
        "slug": "supercopa-de-costa-rica",
        "id": "SCCR"
      },
      {
        "name": "Primera División Relegation",
        "slug": "primera-division-relegation",
        "id": "PDRL"
      }
    ]
  },
  {
    "id": "37",
    "name": "Croatia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "SuperSport HNL",
        "slug": "supersport-hnl",
        "id": "KR1"
      },
      {
        "name": "Prva NL",
        "slug": "prva-nogometna-liga",
        "id": "KR2"
      },
      {
        "name": "Hrvatski nogometni kup",
        "slug": "hrvatski-nogometni-kup",
        "id": "KRC"
      },
      {
        "name": "Prva HNL - Juniori",
        "slug": "prva-hnl-juniori",
        "id": "CR19"
      },
      {
        "name": "SuperSport Super Cup",
        "slug": "supersport-super-cup",
        "id": "HRSC"
      },
      {
        "name": "Aufstiegsrunde zur 2.HNL",
        "slug": "aufstiegsrunde-zur-2-hnl",
        "id": "KR2R"
      },
      {
        "name": "Relegation 1.HNL",
        "slug": "relegation-1-hnl",
        "id": "REKR"
      },
      {
        "name": "Relegation Prva NL",
        "slug": "relegation-prva-nl",
        "id": "2RHR"
      }
    ]
  },
  {
    "id": "188",
    "name": "Cyprus",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Cyprus League",
        "slug": "cyprus-league",
        "id": "ZYP1"
      },
      {
        "name": "2. Division",
        "slug": "2-division",
        "id": "CYP2"
      },
      {
        "name": "Kypello Kyprou",
        "slug": "kypello-kyprou",
        "id": "CPO1"
      },
      {
        "name": "Cypriot Super Cup",
        "slug": "cypriot-super-cup",
        "id": "CYSC"
      },
      {
        "name": "2. Division Promotion Round",
        "slug": "2-division-promotion-round",
        "id": "1CY2"
      },
      {
        "name": "2. Division Relegation Round",
        "slug": "2-division-relegation-round",
        "id": "2CYP"
      },
      {
        "name": "Cyprus League Championship Round",
        "slug": "cyprus-league-championship-round",
        "id": "ZYPM"
      },
      {
        "name": "Cyprus League Relegation Round",
        "slug": "cyprus-league-relegation-round",
        "id": "ZYPA"
      },
      {
        "name": "Protathlima Marfin Laiki Placement Round",
        "slug": "protathlima-marfin-laiki-placement-round",
        "id": "ZYPP"
      }
    ]
  },
  {
    "id": "172",
    "name": "Czech Republic",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Chance Liga",
        "slug": "chance-liga",
        "id": "TS1"
      },
      {
        "name": "ChNL",
        "slug": "chance-narodni-liga",
        "id": "TS2"
      },
      {
        "name": "CFL",
        "slug": "ceska-fotbalova-liga",
        "id": "CZ3C"
      },
      {
        "name": "MSFL",
        "slug": "moravskoslezska-fotbalova-liga",
        "id": "CZ3M"
      },
      {
        "name": "1. liga U19",
        "slug": "1-dorostenecka-liga",
        "id": "CZ19"
      },
      {
        "name": "MOL Cup",
        "slug": "mol-cup",
        "id": "TSP"
      },
      {
        "name": "Superpohar",
        "slug": "superpohar",
        "id": "CZSC"
      },
      {
        "name": "Ceska fotbalova liga - Promotion Playoff",
        "slug": "ceska-fotbalova-liga-promotion-playoff",
        "id": "3CZP"
      },
      {
        "name": "Chance Liga Championship Group",
        "slug": "chance-liga-championship-group",
        "id": "T1MR"
      },
      {
        "name": "Chance Liga Placement Playoff",
        "slug": "chance-liga-placement-playoff",
        "id": "T1EL"
      },
      {
        "name": "Chance Liga Relegation Group",
        "slug": "chance-liga-relegation-group",
        "id": "T1AR"
      },
      {
        "name": "Chance Liga Relegation Play-offs",
        "slug": "chance-liga-relegation-play-offs",
        "id": "FLAP"
      },
      {
        "name": "Juniorska liga - Championship (- 2019)",
        "slug": "juniorska-liga-championship-2019-",
        "id": "CZJ2"
      },
      {
        "name": "Juniorska liga - Relegation (- 2019)",
        "slug": "juniorska-liga-relegation-2019-",
        "id": "CZJ3"
      },
      {
        "name": "Juniorska liga",
        "slug": "juniorska-liga",
        "id": "CZ21"
      }
    ]
  },
  {
    "id": "39",
    "name": "Denmark",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Superliga",
        "slug": "superliga",
        "id": "DK1"
      },
      {
        "name": "1.Division",
        "slug": "1-division",
        "id": "DK2"
      },
      {
        "name": "2.Division",
        "slug": "2-division",
        "id": "DK3O"
      },
      {
        "name": "3.Division",
        "slug": "3-division",
        "id": "DK4L"
      },
      {
        "name": "U19 Boys League",
        "slug": "u19-boys-league",
        "id": "DKDL"
      },
      {
        "name": "U19 Boys Division",
        "slug": "u19-boys-division",
        "id": "DKDD"
      },
      {
        "name": "Oddset Pokalen",
        "slug": "oddset-pokalen",
        "id": "DKP"
      },
      {
        "name": "Superliga Championship round",
        "slug": "superliga-championship-round",
        "id": "DKMR"
      },
      {
        "name": "Superliga Relegation round",
        "slug": "superliga-relegation-round",
        "id": "DKAR"
      },
      {
        "name": "1.Division Promotion",
        "slug": "1-division-promotion",
        "id": "DK2P"
      },
      {
        "name": "1.Division Relegation",
        "slug": "1-division-relegation",
        "id": "DK2R"
      },
      {
        "name": "Future Cup",
        "slug": "future-cup",
        "id": "DKRE"
      },
      {
        "name": "2.Division Promotion",
        "slug": "2-division-promotion",
        "id": "DK3V"
      },
      {
        "name": "2.Division Relegation",
        "slug": "2-division-relegation",
        "id": "DKDA"
      },
      {
        "name": "3.Division Promotion",
        "slug": "3-division-promotion",
        "id": "D4P1"
      },
      {
        "name": "3.Division Relegation",
        "slug": "3-division-relegation",
        "id": "D4P2"
      },
      {
        "name": "Playoff 2. Division",
        "slug": "playoff-2-division",
        "id": "DK3P"
      },
      {
        "name": "Reserveligaen Spring",
        "slug": "reserveligaen-spring",
        "id": "DKRQ"
      },
      {
        "name": "Superliga Europa Playoff",
        "slug": "superliga-europa-playoff",
        "id": "DKPL"
      },
      {
        "name": "Superliga Relegation play-offs",
        "slug": "superliga-relegation-play-offs",
        "id": "DKRL"
      }
    ]
  },
  {
    "id": "43",
    "name": "Dominican Republic",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga Dominicana - Liguilla",
        "slug": "liga-dominicana-de-futbol-liguilla",
        "id": "DO1P"
      },
      {
        "name": "Liga Dominicana de Fútbol",
        "slug": "liga-dominicana-de-futbol",
        "id": "DOM1"
      },
      {
        "name": "Liga Dominicana de Fútbol - Playoff",
        "slug": "liga-dominicana-de-futbol-playoff",
        "id": "DOMP"
      },
      {
        "name": "Liga Dominicana de Fútbol CONCACAF Qualifikation",
        "slug": "liga-dominicana-de-futbol-concacaf-qualifikation",
        "id": "LDCQ"
      },
      {
        "name": "Copa de la Liga Dominicana de Fútbol",
        "slug": "copa-de-la-liga-dominicana-de-futbol",
        "id": "DOMC"
      }
    ]
  },
  {
    "id": "222",
    "name": "East Germany (GDR)",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "DDR-Oberliga (- 89/90)",
        "slug": "ddr-oberliga-89-90-",
        "id": "DDR"
      },
      {
        "name": "DDR-Oberliga Sonderspielrunde 1955",
        "slug": "ddr-oberliga-sonderspielrunde-1955",
        "id": "GD1S"
      },
      {
        "name": "1.DDR-Liga",
        "slug": "1-ddr-liga",
        "id": "DDR2"
      },
      {
        "name": "1.DDR-Liga Staffel 1",
        "slug": "1-ddr-liga-staffel-1",
        "id": "DD21"
      },
      {
        "name": "1.DDR-Liga Staffel 2",
        "slug": "1-ddr-liga-staffel-2",
        "id": "DD22"
      },
      {
        "name": "1.DDR-Liga Staffel 3",
        "slug": "1-ddr-liga-staffel-3",
        "id": "DD23"
      },
      {
        "name": "1.DDR-Liga Staffel 4",
        "slug": "1-ddr-liga-staffel-4",
        "id": "DD24"
      },
      {
        "name": "1.DDR-Liga Staffel 5",
        "slug": "1-ddr-liga-staffel-5",
        "id": "DD25"
      },
      {
        "name": "1.DDR-Liga Staffel A",
        "slug": "1-ddr-liga-staffel-a",
        "id": "DD2A"
      },
      {
        "name": "1.DDR-Liga Staffel B",
        "slug": "1-ddr-liga-staffel-b",
        "id": "DD2B"
      },
      {
        "name": "1.DDR-Liga Staffel Nord",
        "slug": "1-ddr-liga-staffel-nord",
        "id": "DD1N"
      },
      {
        "name": "1.DDR-Liga Staffel Süd",
        "slug": "1-ddr-liga-staffel-sud",
        "id": "DD1S"
      },
      {
        "name": "FDGB-Pokal",
        "slug": "fdgb-pokal",
        "id": "FDGB"
      },
      {
        "name": "DFV-Supercup",
        "slug": "dfv-supercup",
        "id": "DFVS"
      },
      {
        "name": "Auffstiegsrunde zur DDR-Oberliga",
        "slug": "auffstiegsrunde-zur-ddr-oberliga",
        "id": "DOLR"
      },
      {
        "name": "Entscheidungsspiel Klassenerhalt",
        "slug": "entscheidungsspiel-klassenerhalt",
        "id": "ESKH"
      },
      {
        "name": "Entscheidungsspiel Meisterschaft",
        "slug": "entscheidungsspiel-meisterschaft",
        "id": "ESMS"
      }
    ]
  },
  {
    "id": "44",
    "name": "Ecuador",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "LigaPro Serie A",
        "slug": "ligapro-serie-a",
        "id": "EC1N"
      },
      {
        "name": "Liga Pro Serie B",
        "slug": "liga-pro-serie-b",
        "id": "EC2L"
      },
      {
        "name": "Copa Ecuador",
        "slug": "copa-ecuador",
        "id": "ECUP"
      },
      {
        "name": "LigaPro Serie A Primera Etapa",
        "slug": "ligapro-serie-a-primera-etapa",
        "id": "EL1A"
      },
      {
        "name": "LigaPro Serie A Segunda Etapa",
        "slug": "ligapro-serie-a-segunda-etapa",
        "id": "EL1S"
      },
      {
        "name": "LigaPro Serie A Tercera Etapa",
        "slug": "ligapro-serie-a-tercera-etapa",
        "id": "LPPL"
      },
      {
        "name": "Serie A Primera Etapa",
        "slug": "serie-a-primera-etapa",
        "id": "ECPE"
      },
      {
        "name": "Serie A Segunda Etapa",
        "slug": "serie-a-segunda-etapa",
        "id": "ECSE"
      },
      {
        "name": "Supercopa Ecuador",
        "slug": "supercopa-ecuador",
        "id": "ECSC"
      },
      {
        "name": "Liga Pro Serie A Championship Round",
        "slug": "liga-pro-serie-a-championship-round",
        "id": "ECP1"
      },
      {
        "name": "Liga Pro Serie A Playoff Sudamericana",
        "slug": "liga-pro-serie-a-playoff-sudamericana",
        "id": "ECP2"
      },
      {
        "name": "Liga Pro Serie A Relegation round",
        "slug": "liga-pro-serie-a-relegation-round",
        "id": "ECP3"
      },
      {
        "name": "Serie A Tercera Etapa",
        "slug": "serie-a-tercera-etapa",
        "id": "ECPL"
      },
      {
        "name": "Serie B Promotion round",
        "slug": "serie-b-promotion-round",
        "id": "ECB2"
      },
      {
        "name": "Serie B Relegation round",
        "slug": "serie-b-relegation-round",
        "id": "ECB3"
      }
    ]
  },
  {
    "id": "2",
    "name": "Egypt",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier League",
        "slug": "egyptian-premier-league",
        "id": "EGY1"
      },
      {
        "name": "Egypt Cup",
        "slug": "egypt-cup",
        "id": "EGYP"
      },
      {
        "name": "Egyptian Super Cup",
        "slug": "egyptian-super-cup",
        "id": "ESCU"
      },
      {
        "name": "Championship Playoff",
        "slug": "championship-playoff",
        "id": "EGCP"
      },
      {
        "name": "Relegation Playoff",
        "slug": "relegation-playoff",
        "id": "EGRP"
      },
      {
        "name": "Egyptian League Cup",
        "slug": "egyptian-league-cup",
        "id": "EGLC"
      }
    ]
  },
  {
    "id": "45",
    "name": "El Salvador",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Primera División Apertura",
        "slug": "primera-division-apertura",
        "id": "SL1A"
      },
      {
        "name": "Primera División Clausura",
        "slug": "primera-division-clausura",
        "id": "SL1C"
      },
      {
        "name": "Copa El Salvador",
        "slug": "copa-el-salvador",
        "id": "ELC1"
      },
      {
        "name": "Supercopa de El Salvador",
        "slug": "supercopa-de-el-salvador",
        "id": "ELSC"
      },
      {
        "name": "Apertura Final stages",
        "slug": "primera-division-apertura-final-stages",
        "id": "SLP1"
      },
      {
        "name": "Primera División Clausura Final stages",
        "slug": "primera-division-clausura-final-stages",
        "id": "SLP2"
      }
    ]
  },
  {
    "id": "189",
    "name": "England",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier League",
        "slug": "premier-league",
        "id": "GB1"
      },
      {
        "name": "Championship",
        "slug": "championship",
        "id": "GB2"
      },
      {
        "name": "League One",
        "slug": "league-one",
        "id": "GB3"
      },
      {
        "name": "League Two",
        "slug": "league-two",
        "id": "GB4"
      },
      {
        "name": "National League",
        "slug": "national-league",
        "id": "CNAT"
      },
      {
        "name": "National League South",
        "slug": "national-league-south",
        "id": "NLS6"
      },
      {
        "name": "National League North",
        "slug": "national-league-north",
        "id": "NLN6"
      },
      {
        "name": "U18 Premier League",
        "slug": "u18-premier-league",
        "id": "GB18"
      },
      {
        "name": "FA Cup",
        "slug": "fa-cup",
        "id": "FAC"
      },
      {
        "name": "Community Shield",
        "slug": "community-shield",
        "id": "GBCS"
      },
      {
        "name": "EFL Cup",
        "slug": "efl-cup",
        "id": "CGB"
      },
      {
        "name": "National League Cup",
        "slug": "national-league-cup",
        "id": "NLC"
      },
      {
        "name": "Premier League Cup",
        "slug": "premier-league-cup",
        "id": "21PL"
      },
      {
        "name": "FA Youth Cup",
        "slug": "fa-youth-cup",
        "id": "FAYC"
      },
      {
        "name": "Premier League Int. Cup U21",
        "slug": "premier-league-international-cup-u21",
        "id": "PLIC"
      },
      {
        "name": "Premier League 2",
        "slug": "premier-league-2",
        "id": "GB21"
      },
      {
        "name": "EFL Trophy",
        "slug": "efl-trophy",
        "id": "GBFL"
      },
      {
        "name": "First Division (- 91/92)",
        "slug": "first-division-91-92-",
        "id": "EFD1"
      },
      {
        "name": "First Division (- 03/04)",
        "slug": "first-division-03-04-",
        "id": "EFD2"
      },
      {
        "name": "Second Division (- 03/04)",
        "slug": "second-division-03-04-",
        "id": "ENSD"
      },
      {
        "name": "Premier Academy League",
        "slug": "premier-academy-league",
        "id": "GBJG"
      },
      {
        "name": "Championship Play-Offs",
        "slug": "championship-play-offs",
        "id": "POCC"
      },
      {
        "name": "League One Play-Offs",
        "slug": "league-one-play-offs",
        "id": "POG3"
      },
      {
        "name": "League Two Play-Offs",
        "slug": "league-two-play-offs",
        "id": "POG2"
      },
      {
        "name": "National League North Play-offs",
        "slug": "national-league-north-play-offs",
        "id": "E6NP"
      },
      {
        "name": "National League Playoffs",
        "slug": "national-league-playoffs",
        "id": "POCO"
      },
      {
        "name": "National League South Play-offs",
        "slug": "national-league-south-play-offs",
        "id": "E6SP"
      },
      {
        "name": "Premier League 2 Playoffs",
        "slug": "premier-league-2-playoffs",
        "id": "E21P"
      },
      {
        "name": "Premier Reserve League Play Offs",
        "slug": "premier-reserve-league-play-offs",
        "id": "GBRP"
      },
      {
        "name": "U18 Premier League - Final Stage",
        "slug": "u18-premier-league-final-stage",
        "id": "18GB"
      },
      {
        "name": "U21 Premier League Elite Group",
        "slug": "u21-premier-league-elite-group",
        "id": "GBEG"
      },
      {
        "name": "U21 Premier League Knockout Stage",
        "slug": "u21-premier-league-knockout-stage",
        "id": "GBKN"
      },
      {
        "name": "U21 Premier League Qualificationsgroup 1",
        "slug": "u21-premier-league-qualificationsgroup-1",
        "id": "GBQ1"
      },
      {
        "name": "U21 Premier League Qualificationsgroup 2",
        "slug": "u21-premier-league-qualificationsgroup-2",
        "id": "GBQ2"
      },
      {
        "name": "Premier Reserve League",
        "slug": "premier-reserve-league",
        "id": "GBR"
      },
      {
        "name": "Premier Reserve League North",
        "slug": "premier-reserve-league-north",
        "id": "GBRN"
      },
      {
        "name": "Premier Reserve League South",
        "slug": "premier-reserve-league-south",
        "id": "GBRS"
      }
    ]
  },
  {
    "id": "47",
    "name": "Estonia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premium Liiga",
        "slug": "premium-liiga",
        "id": "EST1"
      },
      {
        "name": "Esiliiga",
        "slug": "esiliiga",
        "id": "EST2"
      },
      {
        "name": "Esiliiga B",
        "slug": "esiliiga-b",
        "id": "EST3"
      },
      {
        "name": "U19 Eliitliiga Meistriliiga",
        "slug": "u19-eliitliiga-meistriliiga",
        "id": "ELME"
      },
      {
        "name": "U17 Eliitliiga Esiliiga",
        "slug": "u17-eliitliiga-esiliiga",
        "id": "ES17"
      },
      {
        "name": "Eesti Karikas",
        "slug": "eesti-karikas",
        "id": "ESTP"
      },
      {
        "name": "Eesti Superkarikas",
        "slug": "eesti-superkarikas",
        "id": "ESTS"
      },
      {
        "name": "U19 Eliitliiga Qualification",
        "slug": "u19-eliitliiga-qualification",
        "id": "QELM"
      },
      {
        "name": "Meistriliiga (92/93 bis 97/98)",
        "slug": "meistriliiga-92-93-bis-97-98-",
        "id": "ES1H"
      },
      {
        "name": "U-17 Eliitliiga",
        "slug": "u-17-eliitliiga",
        "id": "EE17"
      },
      {
        "name": "U17 Eliitliiga Sügisring",
        "slug": "u17-eliitliiga-sugisring",
        "id": "E17S"
      },
      {
        "name": "U19 Eliitliiga Esiliiga",
        "slug": "u19-eliitliiga-esiliiga",
        "id": "EE19"
      },
      {
        "name": "Relegation Estland",
        "slug": "relegation-estland",
        "id": "ESTR"
      },
      {
        "name": "U19 Eliitliiga Meistriliiga Playoffs",
        "slug": "u19-eliitliiga-meistriliiga-playoffs",
        "id": "ELMP"
      }
    ]
  },
  {
    "id": "11",
    "name": "Ethiopia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier League",
        "slug": "ethiopian-premier-league",
        "id": "ETP1"
      }
    ]
  },
  {
    "id": "208",
    "name": "Faroe Islands",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Meistaradeildin",
        "slug": "meistaradeildin",
        "id": "FARO"
      },
      {
        "name": "1. deild",
        "slug": "1-deild",
        "id": "FAR2"
      },
      {
        "name": "Løgmanssteypið",
        "slug": "logmanssteypid",
        "id": "FAPO"
      },
      {
        "name": "Stórsteypadystur",
        "slug": "storsteypadystur",
        "id": "FASC"
      },
      {
        "name": "2. deild",
        "slug": "2-deild",
        "id": "FAR3"
      },
      {
        "name": "3. deild",
        "slug": "3-deild",
        "id": "FAR4"
      },
      {
        "name": "3. deild - Final round",
        "slug": "3-deild-final-round",
        "id": "F4FR"
      },
      {
        "name": "Relegation Betri-Deildin",
        "slug": "relegation-betri-deildin",
        "id": "RBDE"
      }
    ]
  },
  {
    "id": "48",
    "name": "Fiji",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Fiji Premier League",
        "slug": "fiji-premier-league",
        "id": "FIJ1"
      }
    ]
  },
  {
    "id": "49",
    "name": "Finland",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Veikkausliiga",
        "slug": "veikkausliiga",
        "id": "FI1"
      },
      {
        "name": "Ykkösliiga",
        "slug": "ykkosliiga",
        "id": "FI2"
      },
      {
        "name": "Ykkönen",
        "slug": "ykkonen",
        "id": "FIYK"
      },
      {
        "name": "Kakkonen - Group C",
        "slug": "kakkonen-group-c",
        "id": "FI3C"
      },
      {
        "name": "Kakkonen - Group A",
        "slug": "kakkonen-group-a",
        "id": "FI3A"
      },
      {
        "name": "Kakkonen - Group B",
        "slug": "kakkonen-group-b",
        "id": "FI3B"
      },
      {
        "name": "Kolmonen Etelä C",
        "slug": "kolmonen-etela-group-c",
        "id": "KOG3"
      },
      {
        "name": "Kolmonen Itäinen",
        "slug": "kolmonen-itainen",
        "id": "FI4L"
      },
      {
        "name": "Kolmonen Etelä A",
        "slug": "kolmonen-etela-group-a",
        "id": "KOG1"
      },
      {
        "name": "Kolmonen Läntinen",
        "slug": "kolmonen-lantinen",
        "id": "F4LA"
      },
      {
        "name": "Kolmonen Pohjoinen",
        "slug": "kolmonen-pohjoinen",
        "id": "F4KP"
      },
      {
        "name": "Kolmonen Etelä B",
        "slug": "kolmonen-etela-group-b",
        "id": "KOG2"
      },
      {
        "name": "P18 SM Qualifi.",
        "slug": "p18-sm-qualification",
        "id": "F18Q"
      },
      {
        "name": "Suomen Cup",
        "slug": "suomen-cup",
        "id": "FIS"
      },
      {
        "name": "Liigacup",
        "slug": "liigacup",
        "id": "FIL"
      },
      {
        "name": "Ykkösliigacup",
        "slug": "ykkosliigacup",
        "id": "YKCP"
      },
      {
        "name": "Mestaruussarja",
        "slug": "mestaruussarja",
        "id": "FIME"
      },
      {
        "name": "Kakkonen - East",
        "slug": "kakkonen-east",
        "id": "FI3"
      },
      {
        "name": "Kakkonen - North",
        "slug": "kakkonen-north",
        "id": "FI3N"
      },
      {
        "name": "Kakkonen - South",
        "slug": "kakkonen-south",
        "id": "FI3S"
      },
      {
        "name": "Kakkonen - West",
        "slug": "kakkonen-west",
        "id": "FI3W"
      },
      {
        "name": "A-Pojat SM Sarja Endrunde",
        "slug": "a-pojat-sm-sarja-endrunde",
        "id": "FJE"
      },
      {
        "name": "A-pojat SM-sarja Qualification",
        "slug": "a-pojat-sm-sarja-qualification",
        "id": "FINJ"
      },
      {
        "name": "P18 SM",
        "slug": "p18-sm",
        "id": "FI18"
      },
      {
        "name": "Kakkonen Play-off",
        "slug": "kakkonen-play-off",
        "id": "FIKP"
      },
      {
        "name": "Kakkonen Promotion Group A",
        "slug": "kakkonen-promotion-group-a",
        "id": "FP3A"
      },
      {
        "name": "Kakkonen Promotion Group B",
        "slug": "kakkonen-promotion-group-b",
        "id": "KP3B"
      },
      {
        "name": "Kakkonen Promotion Group C",
        "slug": "kakkonen-promotion-group-c",
        "id": "KP3C"
      },
      {
        "name": "Kakkonen Relegation Group A",
        "slug": "kakkonen-relegation-group-a",
        "id": "F3KA"
      },
      {
        "name": "Kakkonen Relegation Group B",
        "slug": "kakkonen-relegation-group-b",
        "id": "F3KB"
      },
      {
        "name": "Kakkonen Relegation Group C",
        "slug": "kakkonen-relegation-group-c",
        "id": "F3KC"
      },
      {
        "name": "Kolmonen Play-off",
        "slug": "kolmonen-play-off",
        "id": "FI4P"
      },
      {
        "name": "Mestaruussarja Abstiegsrunde",
        "slug": "mestaruussarja-abstiegsrunde",
        "id": "F1PD"
      },
      {
        "name": "Mestaruussarja Meisterrunde",
        "slug": "mestaruussarja-meisterrunde",
        "id": "F1MM"
      },
      {
        "name": "Relegation Veikkausliiga",
        "slug": "relegation-veikkausliiga",
        "id": "POFI"
      },
      {
        "name": "Relegation Ykkösliiga",
        "slug": "relegation-ykkosliiga",
        "id": "FI4R"
      },
      {
        "name": "Veikkausliiga Championship Group",
        "slug": "veikkausliiga-championship-group",
        "id": "F1CL"
      },
      {
        "name": "Veikkausliiga Entscheidungsspiel",
        "slug": "veikkausliiga-entscheidungsspiel",
        "id": "FIVE"
      },
      {
        "name": "Veikkausliiga Europa Play-off",
        "slug": "veikkausliiga-europa-play-off",
        "id": "F1CE"
      },
      {
        "name": "Veikkausliiga Relegation Group",
        "slug": "veikkausliiga-relegation-group",
        "id": "F1CC"
      },
      {
        "name": "Ykkönen Promotion Group",
        "slug": "ykkonen-promotion-group",
        "id": "FI3P"
      },
      {
        "name": "Ykkönen Relegation Group",
        "slug": "ykkonen-relegation-group",
        "id": "FI3R"
      },
      {
        "name": "Ykkösliiga Playoff",
        "slug": "ykkosliiga-playoff",
        "id": "FI2P"
      },
      {
        "name": "Ykkösliiga Promotion Group",
        "slug": "ykkosliiga-promotion-group",
        "id": "YKAU"
      },
      {
        "name": "Ykkösliiga Relegation Group",
        "slug": "ykkosliiga-relegation-group",
        "id": "YKAB"
      },
      {
        "name": "Kakkonen Cup",
        "slug": "kakkonen-cup",
        "id": "KCUP"
      },
      {
        "name": "Regions Cup",
        "slug": "regions-cup",
        "id": "FIP1"
      }
    ]
  },
  {
    "id": "50",
    "name": "France",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Ligue 1",
        "slug": "ligue-1",
        "id": "FR1"
      },
      {
        "name": "Ligue 2",
        "slug": "ligue-2",
        "id": "FR2"
      },
      {
        "name": "Championnat National",
        "slug": "championnat-national",
        "id": "FR3"
      },
      {
        "name": "National 2 - Grp. C",
        "slug": "championnat-national-2-groupe-c",
        "id": "CN2C"
      },
      {
        "name": "National 2 - Grp. B",
        "slug": "championnat-national-2-groupe-b",
        "id": "CN2B"
      },
      {
        "name": "National 2 - Grp. A",
        "slug": "championnat-national-2-groupe-a",
        "id": "CN2A"
      },
      {
        "name": "National 3 - Grp. H",
        "slug": "championnat-national-3-groupe-h",
        "id": "C3IF"
      },
      {
        "name": "National 3 - Grp. E",
        "slug": "championnat-national-3-groupe-e",
        "id": "C3BR"
      },
      {
        "name": "National 3 - Grp. G",
        "slug": "championnat-national-3-groupe-g",
        "id": "C3HF"
      },
      {
        "name": "National 3 - Grp. D",
        "slug": "championnat-national-3-groupe-d",
        "id": "C3PL"
      },
      {
        "name": "National 3 - Grp. C",
        "slug": "championnat-national-3-groupe-c",
        "id": "C3VL"
      },
      {
        "name": "National 3 - Grp. B",
        "slug": "championnat-national-3-groupe-b",
        "id": "C3NA"
      },
      {
        "name": "National 3 - Grp. A",
        "slug": "championnat-national-3-groupe-a",
        "id": "C3CM"
      },
      {
        "name": "National 3 - Grp. F",
        "slug": "championnat-national-3-groupe-f",
        "id": "C3NO"
      },
      {
        "name": "National U19 - Grp. D",
        "slug": "championnat-national-u19-groupe-d",
        "id": "F19D"
      },
      {
        "name": "National U19 - Grp. A",
        "slug": "national-u19-championship-group-a",
        "id": "F19A"
      },
      {
        "name": "National U19 - Grp. B",
        "slug": "championnat-national-u19-groupe-b",
        "id": "F19B"
      },
      {
        "name": "National U19 - Grp. C",
        "slug": "championnat-national-u19-groupe-c",
        "id": "F19C"
      },
      {
        "name": "Coupe de France",
        "slug": "coupe-de-france",
        "id": "FRC"
      },
      {
        "name": "Trophée des Champions",
        "slug": "trophee-des-champions",
        "id": "FRCH"
      },
      {
        "name": "Coupe Gambardella",
        "slug": "coupe-gambardella",
        "id": "FRYC"
      },
      {
        "name": "Championnat National 2 - Groupe D",
        "slug": "championnat-national-2-groupe-d",
        "id": "CN2D"
      },
      {
        "name": "Championnat National 3 - Groupe I",
        "slug": "championnat-national-3-groupe-i",
        "id": "C3GE"
      },
      {
        "name": "Championnat National 3 - Groupe J",
        "slug": "championnat-national-3-groupe-j",
        "id": "C3BF"
      },
      {
        "name": "Championnat National 3 - Groupe K",
        "slug": "championnat-national-3-groupe-k",
        "id": "C3AR"
      },
      {
        "name": "National 3 - Occitanie",
        "slug": "national-3-occitanie",
        "id": "C3OC"
      },
      {
        "name": "Championnat National U19 - Phase finale",
        "slug": "championnat-national-u19-phase-finale",
        "id": "F19F"
      },
      {
        "name": "Ligue 1/Ligue 2 Playoffs",
        "slug": "ligue-1-ligue-2-playoffs",
        "id": "FRR1"
      },
      {
        "name": "Ligue 2/National Playoffs",
        "slug": "ligue-2-national-playoffs",
        "id": "FRR2"
      },
      {
        "name": "Coupe de la Ligue",
        "slug": "coupe-de-la-ligue",
        "id": "FRL"
      },
      {
        "name": "Coupe Charles Drago",
        "slug": "coupe-charles-drago",
        "id": "FRCD"
      }
    ]
  },
  {
    "id": "53",
    "name": "Georgia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Erovnuli Liga",
        "slug": "erovnuli-liga",
        "id": "GE1N"
      },
      {
        "name": "Erovnuli Liga 2",
        "slug": "erovnuli-liga-2",
        "id": "GEO2"
      },
      {
        "name": "David Kipiani Cup",
        "slug": "david-kipiani-cup",
        "id": "GEP1"
      },
      {
        "name": "Umaghlesi Liga (until 12/2016)",
        "slug": "umaghlesi-liga-until-12-2016-",
        "id": "GEO1"
      },
      {
        "name": "Pirveli Liga (until 12/2016)",
        "slug": "pirveli-liga-until-12-2016-",
        "id": "GE2H"
      },
      {
        "name": "David Kipiani Cup (bis 15/16)",
        "slug": "david-kipiani-cup-bis-15-16-",
        "id": "GEPO"
      },
      {
        "name": "Georgian Super Cup",
        "slug": "georgian-super-cup",
        "id": "GESC"
      },
      {
        "name": "Erovnuli Liga Playoff",
        "slug": "erovnuli-liga-playoff",
        "id": "GE2P"
      },
      {
        "name": "Umaghlesi Liga - Europa League Playoff",
        "slug": "umaghlesi-liga-europa-league-playoff",
        "id": "GEP3"
      },
      {
        "name": "Umaglesi Liga Championship Round (- 2017)",
        "slug": "umaglesi-liga-championship-round-2017-",
        "id": "GEOM"
      },
      {
        "name": "Umaglesi Liga Relegation Round (- 2017)",
        "slug": "umaglesi-liga-relegation-round-2017-",
        "id": "GEOA"
      }
    ]
  },
  {
    "id": "40",
    "name": "Germany",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Bundesliga",
        "slug": "bundesliga",
        "id": "L1"
      },
      {
        "name": "2. Bundesliga",
        "slug": "2-bundesliga",
        "id": "L2"
      },
      {
        "name": "3. Liga",
        "slug": "3-liga",
        "id": "L3"
      },
      {
        "name": "Regionalliga Bayern",
        "slug": "regionalliga-bayern",
        "id": "RLB3"
      },
      {
        "name": "Regionalliga West",
        "slug": "regionalliga-west",
        "id": "RLW3"
      },
      {
        "name": "Regionalliga Südwest",
        "slug": "regionalliga-sudwest",
        "id": "RLSW"
      },
      {
        "name": "Regionalliga Northeast",
        "slug": "regionalliga-northeast",
        "id": "RLN4"
      },
      {
        "name": "Regionalliga Nord",
        "slug": "regionalliga-nord",
        "id": "RLN3"
      },
      {
        "name": "Hessenliga",
        "slug": "hessenliga",
        "id": "OBLC"
      },
      {
        "name": "Oberliga Baden-Württemberg",
        "slug": "oberliga-baden-wurttemberg",
        "id": "OBLB"
      },
      {
        "name": "Oberliga Schleswig-Holstein",
        "slug": "oberliga-schleswig-holstein",
        "id": "OBLL"
      },
      {
        "name": "OL Niedersachsen",
        "slug": "oberliga-niedersachsen",
        "id": "OBLN"
      },
      {
        "name": "Bayernliga Nord",
        "slug": "bayernliga-nord",
        "id": "OLB1"
      },
      {
        "name": "Bayernliga Süd",
        "slug": "bayernliga-sud",
        "id": "OLB2"
      },
      {
        "name": "Oberliga Westfalen",
        "slug": "oberliga-westfalen",
        "id": "OLW3"
      },
      {
        "name": "OL RP/Saar",
        "slug": "oberliga-rheinland-pfalz-saar",
        "id": "OLRP"
      },
      {
        "name": "Mittelrheinliga",
        "slug": "mittelrheinliga",
        "id": "OLMR"
      },
      {
        "name": "Oberliga Niederrhein",
        "slug": "oberliga-niederrhein",
        "id": "OLNI"
      },
      {
        "name": "NOFV-Oberliga Nord",
        "slug": "nofv-oberliga-nord",
        "id": "OBLF"
      },
      {
        "name": "NOFV-Oberliga Süd",
        "slug": "nofv-oberliga-sud",
        "id": "OBLG"
      },
      {
        "name": "Oberliga Hamburg",
        "slug": "oberliga-hamburg",
        "id": "OBLJ"
      },
      {
        "name": "Bremenliga",
        "slug": "bremenliga",
        "id": "OBLK"
      },
      {
        "name": "Sachsenliga",
        "slug": "sachsenliga",
        "id": "SLI"
      },
      {
        "name": "Saarlandliga",
        "slug": "schroder-liga-saar",
        "id": "LLSA"
      },
      {
        "name": "LL Bayern-S/O",
        "slug": "landesliga-bayern-sudost",
        "id": "LBSO"
      },
      {
        "name": "Landesliga Holstein",
        "slug": "landesliga-holstein",
        "id": "LLHO"
      },
      {
        "name": "VL Hessen-Mitte",
        "slug": "verbandsliga-hessen-mitte",
        "id": "VLHM"
      },
      {
        "name": "Westfalenliga 1",
        "slug": "westfalenliga-1",
        "id": "VLW1"
      },
      {
        "name": "Westfalenliga 2",
        "slug": "westfalenliga-2",
        "id": "VLW2"
      },
      {
        "name": "Rheinlandliga",
        "slug": "rheinlandliga",
        "id": "RHL"
      },
      {
        "name": "LL Bayern-S/W",
        "slug": "landesliga-bayern-sudwest",
        "id": "LBSW"
      },
      {
        "name": "Landesliga Hammonia",
        "slug": "landesliga-hammonia",
        "id": "LLHM"
      },
      {
        "name": "LL Lüneburg",
        "slug": "landesliga-luneburg",
        "id": "LLL"
      },
      {
        "name": "VL Baden",
        "slug": "verbandsliga-baden",
        "id": "VLBA"
      },
      {
        "name": "LL Weser-Ems",
        "slug": "landesliga-weser-ems",
        "id": "LNWE"
      },
      {
        "name": "Landesliga Schleswig",
        "slug": "landesliga-schleswig",
        "id": "LLSL"
      },
      {
        "name": "Brandenburgliga",
        "slug": "brandenburgliga",
        "id": "BRBL"
      },
      {
        "name": "LL Bayern-Mitte",
        "slug": "landesliga-bayern-mitte",
        "id": "LBMI"
      },
      {
        "name": "LL Bayern-N/O",
        "slug": "landesliga-bayern-nordost",
        "id": "LBNO"
      },
      {
        "name": "LL Bayern-N/W",
        "slug": "landesliga-bayern-nordwest",
        "id": "LBNW"
      },
      {
        "name": "Landesliga Hansa",
        "slug": "landesliga-hansa",
        "id": "LLHA"
      },
      {
        "name": "Landesliga Bremen",
        "slug": "landesliga-bremen",
        "id": "LLHB"
      },
      {
        "name": "LL Mittelrhein 1",
        "slug": "landesliga-mittelrhein-staffel-1",
        "id": "LLM1"
      },
      {
        "name": "LL Mittelrhein 2",
        "slug": "landesliga-mittelrhein-staffel-2",
        "id": "LLM2"
      },
      {
        "name": "LL Braunschweig",
        "slug": "landesliga-braunschweig",
        "id": "LNBR"
      },
      {
        "name": "LL Hannover",
        "slug": "landesliga-hannover",
        "id": "LNHA"
      },
      {
        "name": "LL Niederrhein-Gr. 1",
        "slug": "landesliga-niederrhein-gruppe-1",
        "id": "LNR1"
      },
      {
        "name": "LL Niederrhein-Gr. 2",
        "slug": "landesliga-niederrhein-gruppe-2",
        "id": "LNR2"
      },
      {
        "name": "Thüringenliga",
        "slug": "thuringenliga",
        "id": "THLI"
      },
      {
        "name": "Berlin-Liga",
        "slug": "berlin-liga",
        "id": "VLBE"
      },
      {
        "name": "VL Württemberg",
        "slug": "verbandsliga-wurttemberg",
        "id": "VLBW"
      },
      {
        "name": "VL Hessen-Nord",
        "slug": "verbandsliga-hessen-nord",
        "id": "VLHN"
      },
      {
        "name": "VL Hessen-Süd",
        "slug": "verbandsliga-hessen-sud",
        "id": "VLHS"
      },
      {
        "name": "VL Meckl.-Vorpommern",
        "slug": "verbandsliga-mecklenburg-vorpommern",
        "id": "VLMV"
      },
      {
        "name": "VL Sachsen-Anhalt",
        "slug": "verbandsliga-sachsen-anhalt",
        "id": "VLSA"
      },
      {
        "name": "VL Südbaden",
        "slug": "verbandsliga-sudbaden",
        "id": "VLSB"
      },
      {
        "name": "VL Südwest",
        "slug": "verbandsliga-sudwest",
        "id": "VLSW"
      },
      {
        "name": "U19 Nachwuchsliga - Liga A",
        "slug": "u19-dfb-nachwuchsliga-hauptrunde-liga-a",
        "id": "19LA"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. E",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-e",
        "id": "19D5"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. B",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-b",
        "id": "19D2"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. H",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-h",
        "id": "19D8"
      },
      {
        "name": "U19 Nachwuchsliga - Liga B",
        "slug": "u19-dfb-nachwuchsliga-hauptrunde-liga-b",
        "id": "19LB"
      },
      {
        "name": "U17 Nachwuchsliga - Liga A",
        "slug": "u17-dfb-nachwuchsliga-hauptrunde-liga-a",
        "id": "17LA"
      },
      {
        "name": "U17 Nachwuchsliga - Gr. E",
        "slug": "u17-dfb-nachwuchsliga-vorrunde-gruppe-e",
        "id": "17DE"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. F",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-f",
        "id": "19D6"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. I",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-i",
        "id": "19D9"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. D",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-d",
        "id": "19D4"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. G",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-g",
        "id": "19D7"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. C",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-c",
        "id": "19D3"
      },
      {
        "name": "U17 Nachwuchsliga - Gr. D",
        "slug": "u17-dfb-nachwuchsliga-vorrunde-gruppe-d",
        "id": "17DD"
      },
      {
        "name": "U17 Nachwuchsliga - Gr. F",
        "slug": "u17-dfb-nachwuchsliga-vorrunde-gruppe-f",
        "id": "17DF"
      },
      {
        "name": "U19 Nachwuchsliga - Gr. A",
        "slug": "u19-dfb-nachwuchsliga-vorrunde-gruppe-a",
        "id": "19D1"
      },
      {
        "name": "U17 Nachwuchsliga - Gr. H",
        "slug": "u17-dfb-nachwuchsliga-vorrunde-gruppe-h",
        "id": "17DH"
      },
      {
        "name": "U17 Nachwuchsliga - Liga B",
        "slug": "u17-dfb-nachwuchsliga-hauptrunde-liga-b",
        "id": "17LB"
      },
      {
        "name": "U17 Nachwuchsliga - Gr. A",
        "slug": "u17-dfb-nachwuchsliga-vorrunde-gruppe-a",
        "id": "17DA"
      },
      {
        "name": "U17 Nachwuchsliga - Gr. B",
        "slug": "u17-dfb-nachwuchsliga-vorrunde-gruppe-b",
        "id": "17DB"
      },
      {
        "name": "U17 Nachwuchsliga - Gr. C",
        "slug": "u17-dfb-nachwuchsliga-vorrunde-gruppe-c",
        "id": "17DC"
      },
      {
        "name": "U17 Nachwuchsliga - Gr. G",
        "slug": "u17-dfb-nachwuchsliga-vorrunde-gruppe-g",
        "id": "17DG"
      },
      {
        "name": "DFB-Pokal",
        "slug": "dfb-pokal",
        "id": "DFB"
      },
      {
        "name": "DFL-Supercup",
        "slug": "franz-beckenbauer-supercup",
        "id": "DFL"
      },
      {
        "name": "DFB-Pokal der Junioren",
        "slug": "dfb-pokal-der-junioren",
        "id": "DFBJ"
      },
      {
        "name": "Bayernpokal",
        "slug": "landespokal-bayern",
        "id": "BVP"
      },
      {
        "name": "Niedersachsenpokal (3. und 4. Liga)",
        "slug": "landespokal-niedersachsen-3-und-4-liga-",
        "id": "NP34"
      },
      {
        "name": "Niederrheinpokal",
        "slug": "landespokal-niederrhein",
        "id": "NRPO"
      },
      {
        "name": "Hessenpokal",
        "slug": "landespokal-hessen",
        "id": "HEPO"
      },
      {
        "name": "Mittelrheinpokal",
        "slug": "landespokal-mittelrhein",
        "id": "MRPO"
      },
      {
        "name": "Württembergpokal",
        "slug": "landespokal-wurttemberg",
        "id": "WFVP"
      },
      {
        "name": "Westfalenpokal",
        "slug": "landespokal-westfalen",
        "id": "WFPO"
      },
      {
        "name": "Sachsenpokal",
        "slug": "landespokal-sachsen",
        "id": "SAPO"
      },
      {
        "name": "Badenpokal",
        "slug": "landespokal-baden",
        "id": "BVFP"
      },
      {
        "name": "Saarlandpokal",
        "slug": "landespokal-saarland",
        "id": "SRPO"
      },
      {
        "name": "Mecklenburg-Vorpommern-Pokal",
        "slug": "landespokal-mecklenburg-vorpommern",
        "id": "MPPO"
      },
      {
        "name": "Brandenburgpokal",
        "slug": "landespokal-brandenburg",
        "id": "BBPO"
      },
      {
        "name": "Berliner Pokal",
        "slug": "landespokal-berlin",
        "id": "BPP"
      },
      {
        "name": "Thüringenpokal",
        "slug": "landespokal-thuringen",
        "id": "TFVP"
      },
      {
        "name": "Schleswig-Holstein-Pokal",
        "slug": "landespokal-schleswig-holstein",
        "id": "SHPO"
      },
      {
        "name": "Sachsen-Anhalt-Pokal",
        "slug": "landespokal-sachsen-anhalt",
        "id": "SANP"
      },
      {
        "name": "Rheinlandpokal",
        "slug": "landespokal-rheinland",
        "id": "RLP"
      },
      {
        "name": "Hamburgpokal",
        "slug": "landespokal-hamburg",
        "id": "OPHH"
      },
      {
        "name": "SBFV-Rothaus-Pokal",
        "slug": "landespokal-sudbaden",
        "id": "SBP"
      },
      {
        "name": "Oberliga Berlin (- 62/63)",
        "slug": "oberliga-berlin-62-63-",
        "id": "OLSB"
      },
      {
        "name": "Oberliga Nord (47/48 - 62/63)",
        "slug": "oberliga-nord-47-48-62-63-",
        "id": "OLN1"
      },
      {
        "name": "Oberliga Nordost (90/91)",
        "slug": "oberliga-nordost-90-91-",
        "id": "OLNS"
      },
      {
        "name": "Oberliga Süd (- 62/63)",
        "slug": "oberliga-sud-62-63-",
        "id": "OLS1"
      },
      {
        "name": "Oberliga Südwest (1945 - 62/63)",
        "slug": "oberliga-sudwest-1945-62-63-",
        "id": "OSW1"
      },
      {
        "name": "Oberliga West (47/48 - 62/63)",
        "slug": "oberliga-west-47-48-62-63-",
        "id": "OLW1"
      },
      {
        "name": "2. Bundesliga North",
        "slug": "2-bundesliga-north",
        "id": "L2N"
      },
      {
        "name": "2. Bundesliga South",
        "slug": "2-bundesliga-south",
        "id": "L2S"
      },
      {
        "name": "Regionalliga Berlin (63/64 - 73/74)",
        "slug": "regionalliga-berlin-63-64-73-74-",
        "id": "RNB"
      },
      {
        "name": "Regionalliga Nord (63/64 - 73/74)",
        "slug": "regionalliga-nord-63-64-73-74-",
        "id": "RLN"
      },
      {
        "name": "Regionalliga Süd (63/64 - 73/74)",
        "slug": "regionalliga-sud-63-64-73-74-",
        "id": "RLS"
      },
      {
        "name": "Regionalliga Südwest (63/64 - 73/74)",
        "slug": "regionalliga-sudwest-63-64-73-74-",
        "id": "SW63"
      },
      {
        "name": "Regionalliga West (63/64 - 73/74)",
        "slug": "regionalliga-west-63-64-73-74-",
        "id": "RLW"
      },
      {
        "name": "NOFV-Oberliga Mitte (91/92 - 93/94)",
        "slug": "nofv-oberliga-mitte-91-92-93-94-",
        "id": "OBSM"
      },
      {
        "name": "NOFV-Oberliga Nord (91/92 - 93/94)",
        "slug": "nofv-oberliga-nord-91-92-93-94-",
        "id": "OBSN"
      },
      {
        "name": "NOFV-Oberliga Süd (91/92 - 93/94)",
        "slug": "nofv-oberliga-sud-91-92-93-94-",
        "id": "OBSS"
      },
      {
        "name": "Oberliga Baden-Württemberg (- 93/94)",
        "slug": "oberliga-baden-wurttemberg-93-94-",
        "id": "OBW3"
      },
      {
        "name": "Oberliga Bayern (- 93/94)",
        "slug": "oberliga-bayern-93-94-",
        "id": "BA93"
      },
      {
        "name": "Oberliga Berlin (74/75 - 90/91)",
        "slug": "oberliga-berlin-74-75-90-91-",
        "id": "BO91"
      },
      {
        "name": "Oberliga Nord (74/75 - 93/94)",
        "slug": "oberliga-nord-74-75-93-94-",
        "id": "NO93"
      },
      {
        "name": "Oberliga Nord/Nordost (- 90/91)",
        "slug": "oberliga-nord-nordost-90-91-",
        "id": "OLNO"
      },
      {
        "name": "Oberliga Nordrhein (- 93/94)",
        "slug": "oberliga-nordrhein-93-94-",
        "id": "OLNA"
      },
      {
        "name": "Oberliga Südwest (78/79 - 93/94)",
        "slug": "oberliga-sudwest-78-79-93-94-",
        "id": "SW93"
      },
      {
        "name": "Oberliga Westfalen (- 93/94)",
        "slug": "oberliga-westfalen-93-94-",
        "id": "OL6B"
      },
      {
        "name": "Regionalliga Nord (94/95 - 07/08)",
        "slug": "regionalliga-nord-94-95-07-08-",
        "id": "RN"
      },
      {
        "name": "Regionalliga Nord/Ost (94/95 - 99/00)",
        "slug": "regionalliga-nord-ost-94-95-99-00-",
        "id": "RNO"
      },
      {
        "name": "Regionalliga Süd (94/95 - 07/08)",
        "slug": "regionalliga-sud-94-95-07-08-",
        "id": "RS"
      },
      {
        "name": "Regionalliga West-Südwest (94/95 - 99/00)",
        "slug": "regionalliga-west-sudwest-94-95-99-00-",
        "id": "RWS"
      },
      {
        "name": "NOFV-Oberliga Nord (- 07/08)",
        "slug": "nofv-oberliga-nord-07-08-",
        "id": "OL3"
      },
      {
        "name": "NOFV-Oberliga Süd (- 07/08)",
        "slug": "nofv-oberliga-sud-07-08-",
        "id": "OL4"
      },
      {
        "name": "Oberliga Baden-Württemberg (94/95- 07/08)",
        "slug": "oberliga-baden-wurttemberg-94-95-07-08-",
        "id": "OL9"
      },
      {
        "name": "Oberliga Bayern (94/95- 07/08)",
        "slug": "oberliga-bayern-94-95-07-08-",
        "id": "OL0"
      },
      {
        "name": "Oberliga Hamburg / S-H (- 03/04)",
        "slug": "oberliga-hamburg-s-h-03-04-",
        "id": "OL1"
      },
      {
        "name": "Oberliga Hessen (- 07/08)",
        "slug": "oberliga-hessen-07-08-",
        "id": "OL7"
      },
      {
        "name": "Oberliga Niedersachsen/Bremen (- 03/04)",
        "slug": "oberliga-niedersachsen-bremen-03-04-",
        "id": "OL2"
      },
      {
        "name": "Oberliga Nord (- 07/08)",
        "slug": "oberliga-nord-07-08-",
        "id": "OLA"
      },
      {
        "name": "Oberliga Nordrhein (94/95 - 07/08)",
        "slug": "oberliga-nordrhein-94-95-07-08-",
        "id": "OL5"
      },
      {
        "name": "Oberliga Südwest (94/95 - 07/08)",
        "slug": "oberliga-sudwest-94-95-07-08-",
        "id": "OL8"
      },
      {
        "name": "Oberliga Westfalen (94/95 - 07/08)",
        "slug": "oberliga-westfalen-94-95-07-08-",
        "id": "OL6"
      },
      {
        "name": "Regionalliga Nord (- 11/12)",
        "slug": "regionalliga-nord-11-12-",
        "id": "RL1"
      },
      {
        "name": "Regionalliga Süd (- 11/12)",
        "slug": "regionalliga-sud-11-12-",
        "id": "RL2"
      },
      {
        "name": "Regionalliga West (- 11/12)",
        "slug": "regionalliga-west-11-12-",
        "id": "RL3"
      },
      {
        "name": "Bayernliga (- 11/12)",
        "slug": "bayernliga-11-12-",
        "id": "OBLA"
      },
      {
        "name": "NRW-Liga (- 11/12)",
        "slug": "nrw-liga-11-12-",
        "id": "OBLE"
      },
      {
        "name": "Oberliga Niedersachsen-Ost (- 09/10)",
        "slug": "oberliga-niedersachsen-ost-09-10-",
        "id": "OBLI"
      },
      {
        "name": "Oberliga Niedersachsen-West (- 09/10)",
        "slug": "oberliga-niedersachsen-west-09-10-",
        "id": "OBLH"
      },
      {
        "name": "Oberliga Südwest (08/09 - 11/12)",
        "slug": "oberliga-sudwest-08-09-11-12-",
        "id": "OBLD"
      },
      {
        "name": "Landesliga Hamburg (- 2022)",
        "slug": "landesliga-hamburg-2022-",
        "id": "LH21"
      },
      {
        "name": "Landesliga Niederrhein - Gruppe 3 (- 2023)",
        "slug": "landesliga-niederrhein-gruppe-3-2023-",
        "id": "LNR3"
      },
      {
        "name": "Landesliga Schleswig-Holstein Mitte (- 2023)",
        "slug": "landesliga-schleswig-holstein-mitte-2023-",
        "id": "LSHM"
      },
      {
        "name": "Verbandsliga Schleswig-Holstein - Nord-Ost",
        "slug": "verbandsliga-schleswig-holstein-nord-ost",
        "id": "VSNO"
      },
      {
        "name": "Verbandsliga Schleswig-Holstein - Nord-West",
        "slug": "verbandsliga-schleswig-holstein-nord-west",
        "id": "VSNW"
      },
      {
        "name": "Verbandsliga Schleswig-Holstein - Süd-Ost",
        "slug": "verbandsliga-schleswig-holstein-sud-ost",
        "id": "VSHO"
      },
      {
        "name": "Verbandsliga Schleswig-Holstein - Süd-West",
        "slug": "verbandsliga-schleswig-holstein-sud-west",
        "id": "VSSW"
      },
      {
        "name": "A-Junioren Bundesliga North/Northeast (- 23/24)",
        "slug": "a-junioren-bundesliga-north-northeast-23-24-",
        "id": "AJ1"
      },
      {
        "name": "A-Junioren Bundesliga West (- 23/24)",
        "slug": "a-junioren-bundesliga-west-23-24-",
        "id": "AJ2"
      },
      {
        "name": "A-Juniors Bundesliga South/Southwest (- 23/24)",
        "slug": "a-juniors-bundesliga-south-southwest-23-24-",
        "id": "AJ3"
      },
      {
        "name": "B-Junioren Bundesliga Nord/Nordost (- 23/24)",
        "slug": "b-junioren-bundesliga-nord-nordost-23-24-",
        "id": "BJ1"
      },
      {
        "name": "B-Junioren Bundesliga West (- 23/24)",
        "slug": "b-junioren-bundesliga-west-23-24-",
        "id": "BJ2"
      },
      {
        "name": "B-Juniors Bundesliga South/Southwest (- 23/24)",
        "slug": "b-juniors-bundesliga-south-southwest-23-24-",
        "id": "BJ3"
      },
      {
        "name": "U17-Bundesliga Sonderspielrunde Hauptrunde",
        "slug": "u17-bundesliga-sonderspielrunde-hauptrunde",
        "id": "17P2"
      },
      {
        "name": "U17-Bundesliga Sonderspielrunde Vorrunde",
        "slug": "u17-bundesliga-sonderspielrunde-vorrunde",
        "id": "17P1"
      },
      {
        "name": "U19-Bundesliga Sonderspielrunde Hauptrunde",
        "slug": "u19-bundesliga-sonderspielrunde-hauptrunde",
        "id": "19S2"
      },
      {
        "name": "U19-Bundesliga Sonderspielrunde Vorrunde",
        "slug": "u19-bundesliga-sonderspielrunde-vorrunde",
        "id": "19S1"
      },
      {
        "name": "DFB-SuperCup",
        "slug": "dfb-supercup",
        "id": "DSC"
      },
      {
        "name": "2. Bundesliga Nord Abstiegsrunde",
        "slug": "2-bundesliga-nord-abstiegsrunde",
        "id": "L2NB"
      },
      {
        "name": "2. Bundesliga Nord Aufstiegsrunde",
        "slug": "2-bundesliga-nord-aufstiegsrunde",
        "id": "L2NA"
      },
      {
        "name": "2. Bundesliga Süd Abstiegsrunde",
        "slug": "2-bundesliga-sud-abstiegsrunde",
        "id": "L2SB"
      },
      {
        "name": "2. Bundesliga Süd Aufstiegsrunde",
        "slug": "2-bundesliga-sud-aufstiegsrunde",
        "id": "L2SA"
      },
      {
        "name": "A-Junioren Relegation Nord/Nordost",
        "slug": "a-junioren-relegation-nord-nordost",
        "id": "AJR1"
      },
      {
        "name": "A-Junioren Relegation Süd/Südwest",
        "slug": "a-junioren-relegation-sud-sudwest",
        "id": "AJR2"
      },
      {
        "name": "Abstiegsrelegation Westfalenliga",
        "slug": "abstiegsrelegation-westfalenliga",
        "id": "VLWR"
      },
      {
        "name": "Abstiegsrunde Landesliga Schleswig-Holstein",
        "slug": "abstiegsrunde-landesliga-schleswig-holstein",
        "id": "SHP2"
      },
      {
        "name": "Abstiegsrunde Rheinlandliga",
        "slug": "abstiegsrunde-rheinlandliga",
        "id": "RRHL"
      },
      {
        "name": "Aufstiegsrunde zur 2. Bundesliga",
        "slug": "aufstiegsrunde-zur-2-bundesliga",
        "id": "A2BL"
      },
      {
        "name": "Aufstiegsrunde zur 3. Liga",
        "slug": "aufstiegsrunde-zur-3-liga",
        "id": "AR3L"
      },
      {
        "name": "Aufstiegsrunde zur Berlin-Liga",
        "slug": "aufstiegsrunde-zur-berlin-liga",
        "id": "ARBL"
      },
      {
        "name": "Aufstiegsrunde zur Bundesliga",
        "slug": "aufstiegsrunde-zur-bundesliga",
        "id": "ARL1"
      },
      {
        "name": "Aufstiegsrunde zur Hessenliga",
        "slug": "aufstiegsrunde-zur-hessenliga",
        "id": "AOLH"
      },
      {
        "name": "Aufstiegsrunde zur Landesliga Niederrhein",
        "slug": "aufstiegsrunde-zur-landesliga-niederrhein",
        "id": "LLAB"
      },
      {
        "name": "Aufstiegsrunde zur Landesliga Schleswig-Holstein",
        "slug": "aufstiegsrunde-zur-landesliga-schleswig-holstein",
        "id": "ALLS"
      },
      {
        "name": "Aufstiegsrunde zur NOFV-Oberliga",
        "slug": "aufstiegsrunde-zur-nofv-oberliga",
        "id": "NOLA"
      },
      {
        "name": "Aufstiegsrunde zur OL Hamburg/Schleswig-Holstein",
        "slug": "aufstiegsrunde-zur-ol-hamburg-schleswig-holstein",
        "id": "ARHS"
      },
      {
        "name": "Aufstiegsrunde zur Oberliga Baden-Württemberg",
        "slug": "aufstiegsrunde-zur-oberliga-baden-wurttemberg",
        "id": "AOLB"
      },
      {
        "name": "Aufstiegsrunde zur Oberliga Hamburg",
        "slug": "aufstiegsrunde-zur-oberliga-hamburg",
        "id": "ARHH"
      },
      {
        "name": "Aufstiegsrunde zur Oberliga Nord",
        "slug": "aufstiegsrunde-zur-oberliga-nord",
        "id": "ALON"
      },
      {
        "name": "Aufstiegsrunde zur Oberliga Rheinland-Pfalz/Saar",
        "slug": "aufstiegsrunde-zur-oberliga-rheinland-pfalz-saar",
        "id": "AOLR"
      },
      {
        "name": "Aufstiegsrunde zur Oberliga Schleswig-Holstein",
        "slug": "aufstiegsrunde-zur-oberliga-schleswig-holstein",
        "id": "AOLS"
      },
      {
        "name": "Aufstiegsrunde zur Oberliga Westfalen",
        "slug": "aufstiegsrunde-zur-oberliga-westfalen",
        "id": "AOLW"
      },
      {
        "name": "Aufstiegsrunde zur Regionalliga Nord",
        "slug": "aufstiegsrunde-zur-regionalliga-nord",
        "id": "ARRN"
      },
      {
        "name": "Aufstiegsrunde zur Regionalliga Nordost",
        "slug": "aufstiegsrunde-zur-regionalliga-nordost",
        "id": "ARRO"
      },
      {
        "name": "Aufstiegsrunde zur Regionalliga Süd (- 11/12)",
        "slug": "aufstiegsrunde-zur-regionalliga-sud-11-12-",
        "id": "ARRS"
      },
      {
        "name": "Aufstiegsrunde zur Regionalliga Südwest",
        "slug": "aufstiegsrunde-zur-regionalliga-sudwest",
        "id": "RRLS"
      },
      {
        "name": "Aufstiegsrunde zur Regionalliga West",
        "slug": "aufstiegsrunde-zur-regionalliga-west",
        "id": "ARWN"
      },
      {
        "name": "Aufstiegsrunde zur Regionalliga West/Südwest (bis",
        "slug": "aufstiegsrunde-zur-regionalliga-west-sudwest-bis",
        "id": "ARRW"
      },
      {
        "name": "Aufstiegsspiele zur Westfalenliga",
        "slug": "aufstiegsspiele-zur-westfalenliga",
        "id": "VLWA"
      },
      {
        "name": "B-Junioren Relegation Nord/Nordost",
        "slug": "b-junioren-relegation-nord-nordost",
        "id": "BJ4R"
      },
      {
        "name": "B-Junioren Relegation Süd/Südwest",
        "slug": "b-junioren-relegation-sud-sudwest",
        "id": "BJ3R"
      },
      {
        "name": "Bayernliga Platzierungsspiele",
        "slug": "bayernliga-platzierungsspiele",
        "id": "PSBL"
      },
      {
        "name": "British Zone Championship",
        "slug": "british-zone-championship",
        "id": "BRZM"
      }
    ]
  },
  {
    "id": "54",
    "name": "Ghana",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier League",
        "slug": "ghana-premier-league",
        "id": "GHPL"
      }
    ]
  },
  {
    "id": "266",
    "name": "Gibraltar",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Gibraltar Football League",
        "slug": "gibraltar-football-league",
        "id": "GI1"
      },
      {
        "name": "Gibraltar U18 League",
        "slug": "gibraltar-u18-league",
        "id": "G17L"
      },
      {
        "name": "Rock Cup",
        "slug": "rock-cup",
        "id": "GIRC"
      },
      {
        "name": "Intermediate Cup",
        "slug": "intermediate-cup",
        "id": "GINC"
      },
      {
        "name": "Pepe Reyes Cup",
        "slug": "pepe-reyes-cup",
        "id": "GISC"
      },
      {
        "name": "Championship Group",
        "slug": "national-league-championship-group",
        "id": "GN1P"
      },
      {
        "name": "U18 Rock Cup",
        "slug": "u18-rock-cup",
        "id": "U18R"
      },
      {
        "name": "Interm. League",
        "slug": "gibraltar-intermediate-league",
        "id": "GIIL"
      },
      {
        "name": "Gibraltar Second Division",
        "slug": "gibraltar-second-division",
        "id": "GI2"
      },
      {
        "name": "Second Division Cup",
        "slug": "second-division-cup",
        "id": "G2DC"
      },
      {
        "name": "Gibraltar Premier Division Playoffs",
        "slug": "gibraltar-premier-division-playoffs",
        "id": "GIPL"
      },
      {
        "name": "National League Challenge Group",
        "slug": "national-league-challenge-group",
        "id": "GN2P"
      },
      {
        "name": "U17 Rock Cup",
        "slug": "u17-rock-cup",
        "id": "GI7C"
      },
      {
        "name": "Gibraltar Reserves Division",
        "slug": "gibraltar-reserves-division",
        "id": "GRD"
      }
    ]
  },
  {
    "id": "56",
    "name": "Greece",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Super League 1",
        "slug": "super-league-1",
        "id": "GR1"
      },
      {
        "name": "Super League 2",
        "slug": "super-league-2",
        "id": "GRS2"
      },
      {
        "name": "Super League U19",
        "slug": "super-league-u19",
        "id": "GR20"
      },
      {
        "name": "Kypello Elladas",
        "slug": "kypello-elladas",
        "id": "GRP"
      },
      {
        "name": "Super Cup",
        "slug": "greek-super-cup",
        "id": "GRSC"
      },
      {
        "name": "Super League Play-off",
        "slug": "super-league-play-off",
        "id": "POGR"
      },
      {
        "name": "Super League Play-out",
        "slug": "super-league-play-out",
        "id": "S1PO"
      },
      {
        "name": "Super League 5th place play-off",
        "slug": "super-league-5th-place-play-off",
        "id": "GRPL"
      },
      {
        "name": "Super League 2 Play-out",
        "slug": "super-league-2-play-out",
        "id": "S2PO"
      },
      {
        "name": "Super League 2 Play-off",
        "slug": "super-league-2-play-off",
        "id": "S2PA"
      },
      {
        "name": "G' Ethniki Play-off",
        "slug": "g-ethniki-play-off",
        "id": "GRP2"
      },
      {
        "name": "Kypello U19",
        "slug": "kypello-super-league-u19",
        "id": "G19C"
      },
      {
        "name": "Kypello Amateur",
        "slug": "kypello-elladas-amateur",
        "id": "GRP3"
      },
      {
        "name": "Super League 2 Super Cup",
        "slug": "super-league-2-super-cup",
        "id": "G2SC"
      },
      {
        "name": "Football League North",
        "slug": "football-league-north",
        "id": "GR2N"
      },
      {
        "name": "Football League South",
        "slug": "football-league-south",
        "id": "GR2S"
      },
      {
        "name": "Football League",
        "slug": "football-league",
        "id": "GR2"
      },
      {
        "name": "Football League Play-off",
        "slug": "football-league-play-off",
        "id": "GR2O"
      },
      {
        "name": "Football League Play-out",
        "slug": "football-league-play-out",
        "id": "GR2T"
      },
      {
        "name": "Relegation B' Ethniki",
        "slug": "relegation-b-ethniki",
        "id": "G2PO"
      },
      {
        "name": "Relegation Super League",
        "slug": "relegation-super-league",
        "id": "RLGR"
      }
    ]
  },
  {
    "id": "58",
    "name": "Guatemala",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "National League Apertura",
        "slug": "national-league-apertura",
        "id": "GU1A"
      },
      {
        "name": "National League Clausura",
        "slug": "national-league-clausura",
        "id": "GU1C"
      },
      {
        "name": "National League Apertura Play-Off",
        "slug": "national-league-apertura-play-off",
        "id": "GUPA"
      },
      {
        "name": "Supercopa de Guatemala",
        "slug": "supercopa-de-guatemala",
        "id": "SCGU"
      },
      {
        "name": "Liga Nacional Champions League Play-Off",
        "slug": "liga-nacional-champions-league-play-off",
        "id": "GCPL"
      },
      {
        "name": "Liga Nacional Relegation",
        "slug": "liga-nacional-relegation",
        "id": "GU1R"
      },
      {
        "name": "National League Clausura Play-Off",
        "slug": "national-league-clausura-play-off",
        "id": "GUPC"
      }
    ]
  },
  {
    "id": "66",
    "name": "Honduras",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga Nacional Apertura",
        "slug": "liga-nacional-apertura",
        "id": "HO1A"
      },
      {
        "name": "Liga Nacional Clausura",
        "slug": "liga-nacional-clausura",
        "id": "HOC1"
      },
      {
        "name": "LNPHN Apertura Playoff",
        "slug": "liga-nacional-apertura-playoff",
        "id": "HOAP"
      },
      {
        "name": "Copa Presidente de Honduras",
        "slug": "copa-presidente-de-honduras",
        "id": "CPH1"
      },
      {
        "name": "Supercopa de Honduras",
        "slug": "supercopa-de-honduras",
        "id": "HOSC"
      },
      {
        "name": "Liga Nacional Clausura Playoff",
        "slug": "liga-nacional-clausura-playoff",
        "id": "HOCP"
      }
    ]
  },
  {
    "id": "218",
    "name": "Hongkong",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Hong Kong Premier League",
        "slug": "hong-kong-premier-league",
        "id": "HGKG"
      },
      {
        "name": "Hong Kong First Division",
        "slug": "hong-kong-first-division",
        "id": "HK2L"
      },
      {
        "name": "Hong Kong Second Division",
        "slug": "hong-kong-second-division",
        "id": "HK3L"
      },
      {
        "name": "Hong Kong FA Cup",
        "slug": "hong-kong-fa-cup",
        "id": "HKFA"
      },
      {
        "name": "Senior Shield",
        "slug": "hong-kong-senior-challenge-shield",
        "id": "HKSC"
      },
      {
        "name": "Hong Kong League Cup",
        "slug": "hong-kong-league-cup",
        "id": "HLC2"
      },
      {
        "name": "Hong Kong FA Cup Jun.",
        "slug": "hong-kong-fa-cup-junior-division",
        "id": "HFA4"
      },
      {
        "name": "HKPL U22 League",
        "slug": "hong-kong-u22-league",
        "id": "HK22"
      },
      {
        "name": "Hong Kong Premier League Championship Group",
        "slug": "hong-kong-premier-league-championship-group",
        "id": "HK1M"
      },
      {
        "name": "Hong Kong Premier League Relegation Group",
        "slug": "hong-kong-premier-league-relegation-group",
        "id": "HK1A"
      },
      {
        "name": "Hong Kong First Division League Cup",
        "slug": "hong-kong-first-division-league-cup",
        "id": "HLP1"
      },
      {
        "name": "Hong Kong Sapling Cup ('15-'25)",
        "slug": "hong-kong-sapling-cup-15-25-",
        "id": "HKP2"
      },
      {
        "name": "Hong Kong Second Division League Cup",
        "slug": "hong-kong-second-division-league-cup",
        "id": "HLP2"
      },
      {
        "name": "Hong Kong U22 FA Cup",
        "slug": "hong-kong-u22-fa-cup",
        "id": "HK2F"
      }
    ]
  },
  {
    "id": "178",
    "name": "Hungary",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "NB I.",
        "slug": "nemzeti-bajnoksag",
        "id": "UNG1"
      },
      {
        "name": "NB II.",
        "slug": "nemzeti-bajnoksag-ii-",
        "id": "UN2"
      },
      {
        "name": "Magyar Kupa",
        "slug": "magyar-kupa",
        "id": "UNGP"
      },
      {
        "name": "Ness Hungary NB II - East",
        "slug": "ness-hungary-nb-ii-east",
        "id": "UNG2"
      },
      {
        "name": "Ness Hungary NB II - West",
        "slug": "ness-hungary-nb-ii-west",
        "id": "UG2W"
      },
      {
        "name": "Abstiegsrunde Nemzeti Bajnokság II",
        "slug": "abstiegsrunde-nemzeti-bajnoksag-ii",
        "id": "PHU2"
      }
    ]
  },
  {
    "id": "73",
    "name": "Iceland",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Besta deild",
        "slug": "besta-deild",
        "id": "IS1"
      },
      {
        "name": "Lengjudeild",
        "slug": "lengjudeild",
        "id": "IS2"
      },
      {
        "name": "2. deild",
        "slug": "2-deild",
        "id": "ISL3"
      },
      {
        "name": "Meistarakeppni",
        "slug": "meistarakeppni",
        "id": "ISLS"
      },
      {
        "name": "Lengjubikarinn",
        "slug": "lengjubikarinn",
        "id": "ISL"
      },
      {
        "name": "Mjólkurbikarinn",
        "slug": "mjolkurbikarinn",
        "id": "ISP"
      },
      {
        "name": "Besta Deild - Finals",
        "slug": "besta-deild-finals",
        "id": "IS1P"
      },
      {
        "name": "Relegation Besta deild",
        "slug": "relegation-besta-deild",
        "id": "IS2P"
      }
    ]
  },
  {
    "id": "67",
    "name": "India",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Indian Super League",
        "slug": "indian-super-league",
        "id": "IND1"
      },
      {
        "name": "Indian Football League",
        "slug": "indian-football-league",
        "id": "INIL"
      },
      {
        "name": "I-League 2",
        "slug": "i-league-2",
        "id": "IND2"
      },
      {
        "name": "Durand Cup",
        "slug": "durand-cup",
        "id": "INDC"
      },
      {
        "name": "Super Cup",
        "slug": "super-cup",
        "id": "INSC"
      },
      {
        "name": "Super L. Kerala Playoffs",
        "slug": "super-league-kerala-playoffs",
        "id": "INKP"
      },
      {
        "name": "RF Development League",
        "slug": "rf-development-league",
        "id": "IND4"
      },
      {
        "name": "Super League Kerala",
        "slug": "super-league-kerala",
        "id": "INR1"
      },
      {
        "name": "National Football League ('96-'07)",
        "slug": "national-football-league-96-07-",
        "id": "IN1A"
      },
      {
        "name": "I-League 3",
        "slug": "i-league-3",
        "id": "IN4L"
      },
      {
        "name": "U17 Youth League",
        "slug": "u17-youth-league",
        "id": "ID17"
      },
      {
        "name": "U17 Youth League Playoff",
        "slug": "u17-youth-league-playoff",
        "id": "I17P"
      },
      {
        "name": "Durand Cup Special Edition",
        "slug": "durand-cup-special-edition",
        "id": "IDC2"
      },
      {
        "name": "Federation Cup (77/78-2017)",
        "slug": "federation-cup-77-78-2017-",
        "id": "IFDC"
      },
      {
        "name": "Federation Cup (Special Edition)",
        "slug": "federation-cup-special-edition-",
        "id": "IFC2"
      },
      {
        "name": "Indian Super Cup (1997-2011)",
        "slug": "indian-super-cup-1997-2011-",
        "id": "ISC2"
      },
      {
        "name": "2nd Division League Playoffs",
        "slug": "2nd-division-league-playoffs",
        "id": "ILPL"
      },
      {
        "name": "2nd Division League Qualifiers",
        "slug": "2nd-division-league-qualifiers",
        "id": "IN2Q"
      },
      {
        "name": "I-League 3 Playoff",
        "slug": "i-league-3-playoff",
        "id": "IN3P"
      },
      {
        "name": "I-League Qualifiers",
        "slug": "i-league-qualifiers",
        "id": "ILQ1"
      },
      {
        "name": "Indian Football League Championship Stage",
        "slug": "indian-football-league-championship-stage",
        "id": "ILP1"
      },
      {
        "name": "Indian Football League Relegation Stage",
        "slug": "indian-football-league-relegation-stage",
        "id": "ILP2"
      },
      {
        "name": "Indian Super League Playoffs",
        "slug": "indian-super-league-playoffs",
        "id": "INDP"
      },
      {
        "name": "National Football League Meisterrunde ('97, '99)",
        "slug": "national-football-league-meisterrunde-97-99-",
        "id": "IN1P"
      },
      {
        "name": "Super Cup Qualifiers",
        "slug": "super-cup-qualifiers",
        "id": "ISCC"
      },
      {
        "name": "U17 Youth Cup",
        "slug": "u17-youth-cup",
        "id": "IYC1"
      }
    ]
  },
  {
    "id": "68",
    "name": "Indonesia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Super League",
        "slug": "super-league",
        "id": "IN1L"
      },
      {
        "name": "Championship",
        "slug": "championship",
        "id": "ILI2"
      },
      {
        "name": "Liga Nusantara",
        "slug": "liga-nusantara",
        "id": "IN3L"
      },
      {
        "name": "EPA Super League U20",
        "slug": "epa-super-league-u20",
        "id": "IN20"
      },
      {
        "name": "Nusantara Promotion Playoff",
        "slug": "liga-nusantara-promotion-playoff",
        "id": "I3P1"
      },
      {
        "name": "Nusantara Relegation",
        "slug": "liga-nusantara-relegation-playoff",
        "id": "I3P2"
      },
      {
        "name": "EPA Liga 1 U20 8 Besar",
        "slug": "epa-liga-1-u20-8-besar",
        "id": "EPPL"
      },
      {
        "name": "Piala Indonesia",
        "slug": "piala-indonesia",
        "id": "INPI"
      },
      {
        "name": "Liga 1 Indonesia Champions League Playoff",
        "slug": "liga-1-indonesia-champions-league-playoff",
        "id": "LIP2"
      },
      {
        "name": "Liga 1 Indonesia Championship Series",
        "slug": "liga-1-indonesia-championship-series",
        "id": "INP1"
      },
      {
        "name": "Liga 2 Indonesia Promotion Playoff",
        "slug": "liga-2-indonesia-promotion-playoff",
        "id": "IL2P"
      },
      {
        "name": "Liga 2 Indonesia Relegation Playoff",
        "slug": "liga-2-indonesia-relegation-playoff",
        "id": "ILP3"
      },
      {
        "name": "Indonesia President's Cup",
        "slug": "indonesia-presidents-cup",
        "id": "INPP"
      },
      {
        "name": "Piala Menpora",
        "slug": "piala-menpora",
        "id": "INP2"
      }
    ]
  },
  {
    "id": "71",
    "name": "Iran",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Persian Gulf League",
        "slug": "persian-gulf-pro-league",
        "id": "IRN1"
      },
      {
        "name": "Azadegan League",
        "slug": "azadegan-league",
        "id": "IRN2"
      },
      {
        "name": "League 2",
        "slug": "league-2",
        "id": "IRN3"
      },
      {
        "name": "Hazfi Cup",
        "slug": "hazfi-cup",
        "id": "IRNP"
      },
      {
        "name": "Iran Super Cup",
        "slug": "iran-super-cup",
        "id": "IRSC"
      },
      {
        "name": "League 2 - Playoff",
        "slug": "league-2-playoff",
        "id": "IPL2"
      },
      {
        "name": "Azadegan League (1991 - 2001)",
        "slug": "azadegan-league-1991-2001-",
        "id": "IR1H"
      },
      {
        "name": "Iran Regional League (1970-1972)",
        "slug": "iran-regional-league-1970-1972-",
        "id": "IRRL"
      },
      {
        "name": "Qods League (1989-1990)",
        "slug": "qods-league-1989-1990-",
        "id": "IR15"
      },
      {
        "name": "Takht Jamshid Cup (1973 - 1978)",
        "slug": "takht-jamshid-cup-1973-1978-",
        "id": "IR14"
      },
      {
        "name": "Azadegan League - Finals (1991 - 2001)",
        "slug": "azadegan-league-finals-1991-2001-",
        "id": "IRAF"
      },
      {
        "name": "Azadegan League Final Round (- 2015)",
        "slug": "azadegan-league-final-round-2015-",
        "id": "AZF2"
      },
      {
        "name": "Iran Asian Champion Club Play-off 1969",
        "slug": "iran-asian-champion-club-play-off-1969",
        "id": "IRP5"
      },
      {
        "name": "Iran Regional League (1970-1972) - Finals",
        "slug": "iran-regional-league-1970-1972-finals",
        "id": "IRRQ"
      },
      {
        "name": "League 2 Final Round",
        "slug": "league-2-final-round",
        "id": "I2AR"
      },
      {
        "name": "Persian Gulf Pro League Playoffs",
        "slug": "persian-gulf-pro-league-playoffs",
        "id": "IRR1"
      },
      {
        "name": "Qods League - Final Round (1989 - 1990)",
        "slug": "qods-league-final-round-1989-1990-",
        "id": "IR16"
      },
      {
        "name": "Takht Jamshid 2nd tier Play-off",
        "slug": "takht-jamshid-2nd-tier-play-off",
        "id": "IRP1"
      },
      {
        "name": "Tehran Clubs League (1920-92) - Finals",
        "slug": "tehran-clubs-league-1920-92-finals",
        "id": "IRT2"
      },
      {
        "name": "Iran Federation Special Cup (1977-1978)",
        "slug": "iran-federation-special-cup-1977-1978-",
        "id": "IRP7"
      },
      {
        "name": "Tehran Hazfi Cup (1946 - 1995)",
        "slug": "tehran-hazfi-cup-1946-1995-",
        "id": "IRN6"
      },
      {
        "name": "Tehran Clubs League (1920-1992)",
        "slug": "tehran-clubs-league-1920-1992-",
        "id": "IRTP"
      },
      {
        "name": "Tehran Super League (1993-1994)",
        "slug": "tehran-super-league-1993-1994-",
        "id": "IRP4"
      }
    ]
  },
  {
    "id": "70",
    "name": "Iraq",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Iraq Stars League",
        "slug": "iraq-stars-league",
        "id": "IRQ1"
      },
      {
        "name": "Iraq FA Cup",
        "slug": "iraq-fa-cup",
        "id": "IRQC"
      },
      {
        "name": "Iraqi Super Cup",
        "slug": "iraqi-super-cup",
        "id": "IKSC"
      }
    ]
  },
  {
    "id": "72",
    "name": "Ireland",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier Division",
        "slug": "league-of-ireland-premier-division",
        "id": "IR1"
      },
      {
        "name": "First Division",
        "slug": "league-of-ireland-first-division",
        "id": "IR2"
      },
      {
        "name": "FAI Cup",
        "slug": "fai-cup",
        "id": "IRPO"
      },
      {
        "name": "President's Cup",
        "slug": "president-of-irelands-cup",
        "id": "IRPC"
      },
      {
        "name": "Leinster Senior Cup",
        "slug": "leinster-senior-cup",
        "id": "IRLC"
      },
      {
        "name": "Munster Senior Cup",
        "slug": "munster-senior-cup",
        "id": "IRMC"
      },
      {
        "name": "League of Ireland Play-Offs",
        "slug": "league-of-ireland-play-offs",
        "id": "IR12"
      },
      {
        "name": "League of Ireland Cup",
        "slug": "league-of-ireland-cup",
        "id": "ILIP"
      }
    ]
  },
  {
    "id": "74",
    "name": "Israel",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Ligat ha'Al",
        "slug": "ligat-haal",
        "id": "ISR1"
      },
      {
        "name": "Liga Leumit",
        "slug": "liga-leumit",
        "id": "ISR2"
      },
      {
        "name": "Gvia haMedina",
        "slug": "gvia-hamedina",
        "id": "ISPO"
      },
      {
        "name": "Aluf haAlufim",
        "slug": "aluf-haalufim",
        "id": "IRLP"
      },
      {
        "name": "Leumit/Alef play-off",
        "slug": "leumit-alef-play-off",
        "id": "LEAB"
      },
      {
        "name": "Liga Leumit - Promotion Playoff",
        "slug": "liga-leumit-promotion-playoff",
        "id": "LLAU"
      },
      {
        "name": "Ligat ha'Al -  Championship round",
        "slug": "ligat-haal-championship-round",
        "id": "ISRF"
      },
      {
        "name": "Ligat ha'Al - Middle Playoff",
        "slug": "ligat-haal-middle-playoff",
        "id": "ISRP"
      },
      {
        "name": "Ligat ha'Al - Relegation round",
        "slug": "ligat-haal-relegation-round",
        "id": "ISRA"
      },
      {
        "name": "Ligat ha'Al/Leumit play-off",
        "slug": "ligat-haal-leumit-play-off",
        "id": "ISP1"
      }
    ]
  },
  {
    "id": "75",
    "name": "Italy",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Serie A",
        "slug": "serie-a",
        "id": "IT1"
      },
      {
        "name": "Serie B",
        "slug": "serie-b",
        "id": "IT2"
      },
      {
        "name": "Serie C - C",
        "slug": "serie-c-girone-c",
        "id": "IT3C"
      },
      {
        "name": "Serie C - A",
        "slug": "serie-c-girone-a",
        "id": "IT3A"
      },
      {
        "name": "Serie C - B",
        "slug": "serie-c-girone-b",
        "id": "IT3B"
      },
      {
        "name": "Serie D - B",
        "slug": "serie-d-girone-b",
        "id": "IT4B"
      },
      {
        "name": "Serie D - H",
        "slug": "serie-d-girone-h",
        "id": "IT4H"
      },
      {
        "name": "Serie D - F",
        "slug": "serie-d-girone-f",
        "id": "IT4F"
      },
      {
        "name": "Serie D - E",
        "slug": "serie-d-girone-e",
        "id": "IT4E"
      },
      {
        "name": "Serie D - D",
        "slug": "serie-d-girone-d",
        "id": "IT4D"
      },
      {
        "name": "Serie D - C",
        "slug": "serie-d-girone-c",
        "id": "IT4C"
      },
      {
        "name": "Serie D - A",
        "slug": "serie-d-girone-a",
        "id": "IT4A"
      },
      {
        "name": "Serie D - G",
        "slug": "serie-d-girone-g",
        "id": "IT4G"
      },
      {
        "name": "Serie D - I",
        "slug": "serie-d-girone-i",
        "id": "IT4I"
      },
      {
        "name": "Primavera 1",
        "slug": "primavera-1",
        "id": "IJ1"
      },
      {
        "name": "Primavera 2 - A",
        "slug": "primavera-2-a",
        "id": "IJ2A"
      },
      {
        "name": "Primavera 2 - B",
        "slug": "primavera-2-b",
        "id": "IJ2B"
      },
      {
        "name": "Under 18",
        "slug": "campionato-under-18",
        "id": "ITJ7"
      },
      {
        "name": "Under 17 - B",
        "slug": "campionato-nazionale-under-17-b",
        "id": "ITJ5"
      },
      {
        "name": "Under 17 - A",
        "slug": "campionato-under-17-a",
        "id": "ITJ4"
      },
      {
        "name": "Under 17 - C",
        "slug": "campionato-nazionale-under-17-c",
        "id": "ITJ6"
      },
      {
        "name": "Italy Cup",
        "slug": "italy-cup",
        "id": "CIT"
      },
      {
        "name": "Supercoppa Italiana",
        "slug": "supercoppa-italiana",
        "id": "SCI"
      },
      {
        "name": "Coppa Primavera",
        "slug": "coppa-italia-primavera",
        "id": "CITP"
      },
      {
        "name": "Viareggio Cup",
        "slug": "viareggio-cup",
        "id": "TDV"
      },
      {
        "name": "Coppa Serie C",
        "slug": "coppa-italia-serie-c",
        "id": "CILP"
      },
      {
        "name": "Coppa Serie D",
        "slug": "coppa-italia-serie-d",
        "id": "ITC4"
      },
      {
        "name": "Supercoppa Primavera",
        "slug": "supercoppa-primavera",
        "id": "SCIJ"
      },
      {
        "name": "Divisione Nazionale",
        "slug": "divisione-nazionale",
        "id": "DivN"
      },
      {
        "name": "Lega Pro Seconda Divisione - Girone A",
        "slug": "lega-pro-seconda-divisione-girone-a",
        "id": "IT4X"
      },
      {
        "name": "Lega Pro Seconda Divisione - Girone B",
        "slug": "lega-pro-seconda-divisione-girone-b",
        "id": "IT4Y"
      },
      {
        "name": "Lega Pro Seconda Divisione - Girone C",
        "slug": "lega-pro-seconda-divisione-girone-c",
        "id": "IT4Z"
      },
      {
        "name": "Lega Pro Seconda Divisione - Girone D",
        "slug": "lega-pro-seconda-divisione-girone-d",
        "id": "IT4V"
      },
      {
        "name": "Campionato Primavera Girone A",
        "slug": "campionato-primavera-girone-a",
        "id": "ITJ1"
      },
      {
        "name": "Campionato Primavera Girone B",
        "slug": "campionato-primavera-girone-b",
        "id": "ITJ2"
      },
      {
        "name": "Campionato Primavera Girone C",
        "slug": "campionato-primavera-girone-c",
        "id": "ITJ3"
      },
      {
        "name": "Campionato Primavera Girone D",
        "slug": "campionato-primavera-girone-d",
        "id": "ITJ0"
      },
      {
        "name": "Campionato nazionale Under 17 2020/21",
        "slug": "campionato-nazionale-under-17-2020-21",
        "id": "ITJ8"
      },
      {
        "name": "Campionato nazionale Under 18 - B",
        "slug": "campionato-nazionale-under-18-b",
        "id": "ITJ9"
      },
      {
        "name": "Campionato Primavera Fase Finale",
        "slug": "campionato-primavera-fase-finale",
        "id": "ITJE"
      },
      {
        "name": "Campionato Under 17 - Finals",
        "slug": "campionato-under-17-finals",
        "id": "ITJF"
      },
      {
        "name": "Campionato Under 18 - Finals",
        "slug": "campionato-under-18-finals",
        "id": "IT18"
      },
      {
        "name": "Divisione Nazionale Girone finale",
        "slug": "divisione-nazionale-girone-finale",
        "id": "DiNF"
      },
      {
        "name": "Meisterrunde (Serie D)",
        "slug": "meisterrunde-serie-d-",
        "id": "IT4"
      },
      {
        "name": "Play-Out Serie A",
        "slug": "play-out-serie-a",
        "id": "ITPO"
      },
      {
        "name": "Play-off Serie C",
        "slug": "play-off-serie-c",
        "id": "IT3P"
      },
      {
        "name": "Play-off/out Lega Pro 2a Divisione",
        "slug": "play-off-out-lega-pro-2a-divisione",
        "id": "IT4W"
      },
      {
        "name": "Play-off/out Primavera",
        "slug": "play-off-out-primavera",
        "id": "ITJP"
      },
      {
        "name": "Play-out Serie C",
        "slug": "play-out-serie-c",
        "id": "IT3O"
      },
      {
        "name": "Serie B Play-off",
        "slug": "serie-b-play-off",
        "id": "POSB"
      },
      {
        "name": "Serie B Play-out",
        "slug": "serie-b-play-out",
        "id": "PUSB"
      },
      {
        "name": "Serie D play-off",
        "slug": "serie-d-play-off",
        "id": "IT4P"
      },
      {
        "name": "Serie D play-out",
        "slug": "serie-d-play-out",
        "id": "IT4O"
      },
      {
        "name": "Trofeo Nazionale di Lega Armando Picchi",
        "slug": "trofeo-nazionale-di-lega-armando-picchi",
        "id": "TAP"
      },
      {
        "name": "Supercoppa 2a Divisione",
        "slug": "supercoppa-2a-divisione",
        "id": "SCC2"
      },
      {
        "name": "Supercoppa di Serie C",
        "slug": "supercoppa-di-serie-c",
        "id": "SCIC"
      },
      {
        "name": "Supercoppa Primavera 2",
        "slug": "supercoppa-primavera-2",
        "id": "SCJ2"
      },
      {
        "name": "Supercoppa Under 17",
        "slug": "supercoppa-under-17",
        "id": "IJSC"
      }
    ]
  },
  {
    "id": "76",
    "name": "Jamaica",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Jamaica Premier League",
        "slug": "jamaica-premier-league",
        "id": "JPL1"
      },
      {
        "name": "Jamaica Premier League Playoff",
        "slug": "jamaica-premier-league-playoff",
        "id": "JPP1"
      },
      {
        "name": "Jamaica Lower Table Round",
        "slug": "jamaica-lower-table-round",
        "id": "JPP2"
      }
    ]
  },
  {
    "id": "77",
    "name": "Japan",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "J1 League",
        "slug": "j1-league",
        "id": "JAP1"
      },
      {
        "name": "J2 League",
        "slug": "j2-league",
        "id": "JAP2"
      },
      {
        "name": "J3 League",
        "slug": "j3-league",
        "id": "JAP3"
      },
      {
        "name": "Japan Football League",
        "slug": "japan-football-league",
        "id": "JFL"
      },
      {
        "name": "Kanto Soccer League (Div.1)",
        "slug": "kanto-soccer-league-div-1-",
        "id": "KTOS"
      },
      {
        "name": "Kansai Soccer League (Div.1)",
        "slug": "kansai-soccer-league-div-1-",
        "id": "JPKA"
      },
      {
        "name": "Tokai Soccer League (Div.1)",
        "slug": "tokai-soccer-league-div-1-",
        "id": "TOSL"
      },
      {
        "name": "Chugoku Soccer League",
        "slug": "chugoku-soccer-league",
        "id": "JCSL"
      },
      {
        "name": "Hokushin'etsu Football League (Div.1)",
        "slug": "hokushinetsu-football-league-div-1-",
        "id": "HKSE"
      },
      {
        "name": "Hokkaido Soccer League",
        "slug": "hokkaido-soccer-league",
        "id": "HOSL"
      },
      {
        "name": "Kyushu Soccer League",
        "slug": "kyushu-soccer-league",
        "id": "JPKS"
      },
      {
        "name": "Shikoku Soccer League",
        "slug": "shikoku-soccer-league",
        "id": "SHSL"
      },
      {
        "name": "Tohoku Soccer League (Div.1)",
        "slug": "tohoku-soccer-league-div-1-",
        "id": "TOHL"
      },
      {
        "name": "Kanto Soccer League (Div.2)",
        "slug": "kanto-soccer-league-div-2-",
        "id": "J6K2"
      },
      {
        "name": "Hokushin'etsu Football League (Div.2)",
        "slug": "hokushinetsu-football-league-div-2-",
        "id": "J6H2"
      },
      {
        "name": "Kansai Soccer League (Div.2)",
        "slug": "kansai-soccer-league-div-2-",
        "id": "J6KA"
      },
      {
        "name": "Tokai Soccer League (Div.2)",
        "slug": "tokai-soccer-league-div-2-",
        "id": "J6T2"
      },
      {
        "name": "Tohoku Soccer League (Div.2 North)",
        "slug": "tohoku-soccer-league-div-2-north-",
        "id": "J6TN"
      },
      {
        "name": "Tohoku Soccer League (Div.2 South)",
        "slug": "tohoku-soccer-league-div-2-south-",
        "id": "J6TS"
      },
      {
        "name": "Takamado U18 PL West",
        "slug": "prince-takamado-u18-premier-league-west",
        "id": "J18W"
      },
      {
        "name": "Takamado U18 PL East",
        "slug": "prince-takamado-u18-premier-league-east",
        "id": "J18E"
      },
      {
        "name": "J1 Special Season",
        "slug": "j1-100-year-vision-league",
        "id": "J1YV"
      },
      {
        "name": "J2/J3 Special Season",
        "slug": "j2-j3-100-year-vision-league",
        "id": "J2J3"
      },
      {
        "name": "JFL Cup",
        "slug": "jfl-cup",
        "id": "JJFL"
      },
      {
        "name": "J1 League - First Stage ('93-'95,'97-'04,'15-'16)",
        "slug": "j1-league-first-stage-93-95-97-04-15-16-",
        "id": "JL11"
      },
      {
        "name": "J1 League - Second Stage ('93-'95,'97-'04,'15-'16)",
        "slug": "j1-league-second-stage-93-95-97-04-15-16-",
        "id": "JL12"
      },
      {
        "name": "Japan Soccer League (Div. 1) (1965-91/92)",
        "slug": "japan-soccer-league-div-1-1965-91-92-",
        "id": "JSL1"
      },
      {
        "name": "Japan Football League (1992-1998)",
        "slug": "japan-football-league-1992-1998-",
        "id": "JFL1"
      },
      {
        "name": "Japan Soccer League (Div. 2) (1972-91/92)",
        "slug": "japan-soccer-league-div-2-1972-91-92-",
        "id": "JSL2"
      },
      {
        "name": "Japan Football League (Div. 2) (1992-1993)",
        "slug": "japan-football-league-div-2-1992-1993-",
        "id": "JFL2"
      },
      {
        "name": "Emperor's Cup",
        "slug": "emperors-cup",
        "id": "JEMP"
      },
      {
        "name": "Japanese Super Cup",
        "slug": "japanese-super-cup",
        "id": "JASP"
      },
      {
        "name": "J. League Championship ('93-'95,'97-'04,'15-'16)",
        "slug": "j-league-championship-93-95-97-04-15-16-",
        "id": "SUNC"
      },
      {
        "name": "J1 qualification Play-off",
        "slug": "j1-qualification-play-off",
        "id": "J1PO"
      },
      {
        "name": "J2 qualification Play-off",
        "slug": "j2-qualification-play-off",
        "id": "JPR2"
      },
      {
        "name": "J3/JFL Play-off",
        "slug": "j3-jfl-play-off",
        "id": "JPR3"
      },
      {
        "name": "JFL/Regional Leagues Playoff",
        "slug": "jfl-regional-leagues-playoff",
        "id": "JFLR"
      },
      {
        "name": "Japan Football League Championship (2014-2016)",
        "slug": "japan-football-league-championship-2014-2016-",
        "id": "JFLC"
      },
      {
        "name": "Japanese Regional Football Champions League",
        "slug": "japanese-regional-football-champions-league",
        "id": "JRCL"
      },
      {
        "name": "Relegation JSL / J1 League ('65-'83, '98, '04-'08)",
        "slug": "relegation-jsl-j1-league-65-83-98-04-08-",
        "id": "JARE"
      },
      {
        "name": "Relegation Regional Leagues (jap.)",
        "slug": "relegation-regional-leagues-jap-",
        "id": "JRLR"
      },
      {
        "name": "J. League Cup",
        "slug": "j-league-cup",
        "id": "JAPC"
      },
      {
        "name": "J. Youth League",
        "slug": "j-youth-league",
        "id": "J1YL"
      },
      {
        "name": "All Japan Senior Football Championship",
        "slug": "all-japan-senior-football-championship",
        "id": "SKJN"
      },
      {
        "name": "Prince Takamado U18 Premier League Championship",
        "slug": "prince-takamado-u18-premier-league-championship",
        "id": "J18C"
      }
    ]
  },
  {
    "id": "78",
    "name": "Jordan",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Jordanian Pro League",
        "slug": "jordanian-pro-league",
        "id": "JO1L"
      },
      {
        "name": "Jordan Super Cup",
        "slug": "jordan-super-cup",
        "id": "JOSC"
      }
    ]
  },
  {
    "id": "81",
    "name": "Kazakhstan",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier Liga",
        "slug": "premier-liga",
        "id": "KAS1"
      },
      {
        "name": "Pervaya Liga",
        "slug": "pervaya-liga",
        "id": "KAS2"
      },
      {
        "name": "Kazakhstan Cup",
        "slug": "kazakhstan-cup",
        "id": "KAZP"
      },
      {
        "name": "Kasachischer Supercup",
        "slug": "kasachischer-supercup",
        "id": "KASC"
      },
      {
        "name": "Premier League Relegation-Playoff",
        "slug": "premier-league-relegation-playoff",
        "id": "KAZA"
      },
      {
        "name": "QJ League",
        "slug": "qj-league",
        "id": "KAJ1"
      },
      {
        "name": "Cup of Kazakhstan (1996 - 2001)",
        "slug": "cup-of-kazakhstan-1996-2001-",
        "id": "KAP2"
      },
      {
        "name": "Premier League Championship-Playoff",
        "slug": "premier-league-championship-playoff",
        "id": "KAZM"
      },
      {
        "name": "Relegation Premier Liga",
        "slug": "relegation-premier-liga",
        "id": "KASR"
      },
      {
        "name": "QFL League Cup",
        "slug": "qfl-league-cup",
        "id": "QFLC"
      }
    ]
  },
  {
    "id": "87",
    "name": "Korea, South",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "K League 1",
        "slug": "k-league-1",
        "id": "RSK1"
      },
      {
        "name": "K League 2",
        "slug": "k-league-2",
        "id": "RSK2"
      },
      {
        "name": "K3 League",
        "slug": "k3-league",
        "id": "K3L"
      },
      {
        "name": "K4 League",
        "slug": "k4-league",
        "id": "K4L"
      },
      {
        "name": "Korean Super Cup",
        "slug": "korean-super-cup",
        "id": "KSC1"
      },
      {
        "name": "K3·K4 Championship",
        "slug": "k3-middot-k4-championship",
        "id": "KRC3"
      },
      {
        "name": "K League - First Stage ('84,'86,'95,'96,'04-'06)",
        "slug": "k-league-first-stage-84-86-95-96-04-06-",
        "id": "KLS1"
      },
      {
        "name": "K League - Second Stage ('84,'86,'95,'96,'04-'06)",
        "slug": "k-league-second-stage-84-86-95-96-04-06-",
        "id": "KLS2"
      },
      {
        "name": "Korea National League (2011-2019)",
        "slug": "korea-national-league-2011-2019-",
        "id": "RKNL"
      },
      {
        "name": "Korea National League - First Stage (2003-2010)",
        "slug": "korea-national-league-first-stage-2003-2010-",
        "id": "KNL1"
      },
      {
        "name": "Korea National League - Second Stage (2003-2010)",
        "slug": "korea-national-league-second-stage-2003-2010-",
        "id": "KNL2"
      },
      {
        "name": "Korea Cup",
        "slug": "korea-cup",
        "id": "RKPO"
      },
      {
        "name": "K League 1 Final A",
        "slug": "k-league-1-final-a",
        "id": "RSKM"
      },
      {
        "name": "K League 1 Final B",
        "slug": "k-league-1-final-b",
        "id": "RSKA"
      },
      {
        "name": "K League 1 Promotion Playoff",
        "slug": "k-league-1-promotion-playoff",
        "id": "KREG"
      },
      {
        "name": "K League Championship ('84,'86,'95-'00,'04-'11)",
        "slug": "k-league-championship-84-86-95-00-04-11-",
        "id": "KREL"
      },
      {
        "name": "K3 League Championship-Playoff",
        "slug": "k3-league-championship-playoff",
        "id": "K3MP"
      },
      {
        "name": "K4 League promotion playoff",
        "slug": "k4-league-promotion-playoff",
        "id": "K4MP"
      },
      {
        "name": "Korea National League Championship (2003-2019)",
        "slug": "korea-national-league-championship-2003-2019-",
        "id": "KNPL"
      },
      {
        "name": "K League Cup ('92-'02,'04-'11)",
        "slug": "k-league-cup-92-02-04-11-",
        "id": "KLCP"
      },
      {
        "name": "Korea National League Cup (2003-2019)",
        "slug": "korea-national-league-cup-2003-2019-",
        "id": "KNLP"
      },
      {
        "name": "K League U18 Championship",
        "slug": "k-league-u18-championship",
        "id": "K18C"
      }
    ]
  },
  {
    "id": "244",
    "name": "Kosovo",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Superliga e Kosovës",
        "slug": "superliga-e-kosoves",
        "id": "KO1"
      },
      {
        "name": "Kupa e Kosovës",
        "slug": "kupa-e-kosoves",
        "id": "KOP1"
      },
      {
        "name": "Superkupa e Kosovës",
        "slug": "superkupa-e-kosoves",
        "id": "SKKO"
      },
      {
        "name": "Relegation Superliga e Kosovës",
        "slug": "relegation-superliga-e-kosoves",
        "id": "KO1R"
      }
    ]
  },
  {
    "id": "90",
    "name": "Kyrgyzstan",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Jogorku Liga",
        "slug": "jogorku-liga",
        "id": "KG1L"
      },
      {
        "name": "Kyrgyzstan Cup",
        "slug": "kyrgyzstan-cup",
        "id": "KGPO"
      },
      {
        "name": "Kyrgyzstan Super Cup",
        "slug": "kyrgyzstan-super-cup",
        "id": "KRSC"
      }
    ]
  },
  {
    "id": "91",
    "name": "Laos",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Lao League 1",
        "slug": "lao-league-1",
        "id": "LAO1"
      },
      {
        "name": "Prime Minister Cup",
        "slug": "prime-minister-cup",
        "id": "LAP1"
      }
    ]
  },
  {
    "id": "92",
    "name": "Latvia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Virsliga",
        "slug": "virsliga",
        "id": "LET1"
      },
      {
        "name": "Futbola Pirmā līga",
        "slug": "futbola-pirma-liga",
        "id": "LET2"
      },
      {
        "name": "U-19 Elites Grupa",
        "slug": "u-19-elites-grupa",
        "id": "LT19"
      },
      {
        "name": "Latvian Cup",
        "slug": "latvian-cup",
        "id": "LETP"
      },
      {
        "name": "Relegation Virsliga",
        "slug": "relegation-virsliga",
        "id": "LETA"
      },
      {
        "name": "Virsliga - Meisterrunde",
        "slug": "virsliga-meisterrunde",
        "id": "LETM"
      }
    ]
  },
  {
    "id": "94",
    "name": "Lebanon",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Lebanese Premier League",
        "slug": "lebanese-premier-league",
        "id": "LIB1"
      },
      {
        "name": "Lebanese Premier League Championship round",
        "slug": "lebanese-premier-league-championship-round",
        "id": "LB1M"
      },
      {
        "name": "Lebanese Premier League Relegation Group",
        "slug": "lebanese-premier-league-relegation-group",
        "id": "LB1A"
      }
    ]
  },
  {
    "id": "96",
    "name": "Libya",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Libyan Premier League",
        "slug": "libyan-premier-league",
        "id": "LPL"
      },
      {
        "name": "Libya Championship Playoff",
        "slug": "libya-championship-playoff",
        "id": "LPL3"
      },
      {
        "name": "Libya Qualification Playoff",
        "slug": "libya-qualification-playoff",
        "id": "LPL2"
      },
      {
        "name": "Libya Relegation Playoff",
        "slug": "libya-relegation-playoff",
        "id": "LPL1"
      }
    ]
  },
  {
    "id": "97",
    "name": "Liechtenstein",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "FL-Cup",
        "slug": "liechtensteiner-cup",
        "id": "LIEP"
      }
    ]
  },
  {
    "id": "98",
    "name": "Lithuania",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Toplyga",
        "slug": "toplyga",
        "id": "LI1"
      },
      {
        "name": "I Lyga",
        "slug": "i-lyga",
        "id": "LTU2"
      },
      {
        "name": "Lithuanian Cup",
        "slug": "lithuanian-cup",
        "id": "LTVP"
      },
      {
        "name": "Lithuanian Supercup",
        "slug": "lithuanian-supercup",
        "id": "LTSC"
      },
      {
        "name": "A Lyga - Championship Round",
        "slug": "a-lyga-championship-round",
        "id": "LIM"
      },
      {
        "name": "A Lyga Transitional Round",
        "slug": "a-lyga-transitional-round",
        "id": "LT1U"
      },
      {
        "name": "Litauischer Pokal Übergangsrunde",
        "slug": "litauischer-pokal-ubergangsrunde",
        "id": "LTP2"
      },
      {
        "name": "Relegation A Lyga",
        "slug": "relegation-a-lyga",
        "id": "L1RL"
      }
    ]
  },
  {
    "id": "99",
    "name": "Luxembourg",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "BGL Ligue",
        "slug": "bgl-ligue",
        "id": "LUX1"
      },
      {
        "name": "Ehrenpromotion",
        "slug": "ehrenpromotion",
        "id": "LUX2"
      },
      {
        "name": "Coupe de Luxembourg",
        "slug": "coupe-de-luxembourg",
        "id": "LUXP"
      },
      {
        "name": "Coupe de la Ligue Luxemburg",
        "slug": "coupe-de-la-ligue-luxemburg",
        "id": "LUCL"
      },
      {
        "name": "BGL Ligue Relegation",
        "slug": "bgl-ligue-relegation",
        "id": "POLU"
      },
      {
        "name": "Ehrenpromotion Relegation",
        "slug": "ehrenpromotion-relegation",
        "id": "LURE"
      },
      {
        "name": "Nationaldivision - Abstiegsgruppe A",
        "slug": "nationaldivision-abstiegsgruppe-a",
        "id": "LUAA"
      },
      {
        "name": "Nationaldivision - Abstiegsgruppe B",
        "slug": "nationaldivision-abstiegsgruppe-b",
        "id": "LUAB"
      },
      {
        "name": "Nationaldivision - Titelgruppe",
        "slug": "nationaldivision-titelgruppe",
        "id": "LUTP"
      },
      {
        "name": "Coupe du Prince",
        "slug": "coupe-du-prince",
        "id": "LUCP"
      }
    ]
  },
  {
    "id": "103",
    "name": "Malaysia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Super League",
        "slug": "malaysia-super-league",
        "id": "MYS1"
      },
      {
        "name": "Malaysia FA Cup",
        "slug": "malaysia-fa-cup",
        "id": "MYSP"
      },
      {
        "name": "Piala Malaysia",
        "slug": "piala-malaysia",
        "id": "MYC1"
      },
      {
        "name": "MFL Challenge Cup",
        "slug": "mfl-challenge-cup",
        "id": "MLCC"
      },
      {
        "name": "Malaysia Super Cup",
        "slug": "malaysia-super-cup",
        "id": "MYSC"
      }
    ]
  },
  {
    "id": "106",
    "name": "Malta",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier League Opening Round",
        "slug": "premier-league-opening-round",
        "id": "MT1N"
      },
      {
        "name": "Premier League Closing Round",
        "slug": "premier-league-closing-round",
        "id": "MT1P"
      },
      {
        "name": "Gozo League",
        "slug": "gozo-football-league-first-division",
        "id": "GZO1"
      },
      {
        "name": "Challenge League",
        "slug": "challenge-league",
        "id": "MAL2"
      },
      {
        "name": "National Amateur League I",
        "slug": "national-amateur-league-i",
        "id": "MAL3"
      },
      {
        "name": "Jubilee Cup",
        "slug": "malta-fa-jubilee-cup",
        "id": "MAJC"
      },
      {
        "name": "Maltese FA Trophy",
        "slug": "maltese-fa-trophy",
        "id": "MALC"
      },
      {
        "name": "GFA Cup",
        "slug": "gozo-fa-cup",
        "id": "GFAC"
      },
      {
        "name": "Maltese Super Cup",
        "slug": "maltese-super-cup",
        "id": "MALS"
      },
      {
        "name": "Challenge League - Finals",
        "slug": "challenge-league-finals",
        "id": "MT2P"
      },
      {
        "name": "BOV Challenge Cup",
        "slug": "bov-challenge-cup",
        "id": "MLP2"
      },
      {
        "name": "National Amateur Cup",
        "slug": "national-amateur-cup",
        "id": "MLAC"
      },
      {
        "name": "Premier League (-2024)",
        "slug": "premier-league-2024-",
        "id": "MAL1"
      },
      {
        "name": "Premier League Final",
        "slug": "premier-league-final",
        "id": "MT1F"
      },
      {
        "name": "Challenge League Decider",
        "slug": "challenge-league-decider",
        "id": "MT3P"
      },
      {
        "name": "Championship decider",
        "slug": "championship-decider",
        "id": "MALD"
      },
      {
        "name": "Gozo Football League Finals",
        "slug": "gozo-football-league-finals",
        "id": "GZF1"
      },
      {
        "name": "National Amateur League Finals",
        "slug": "national-amateur-league-finals",
        "id": "M3P2"
      },
      {
        "name": "National Amateur League Promotion Playoff",
        "slug": "national-amateur-league-promotion-playoff",
        "id": "MTPO"
      },
      {
        "name": "Premier League Abstiegsrunde",
        "slug": "premier-league-abstiegsrunde",
        "id": "MALA"
      },
      {
        "name": "Premier League Meisterschaftsrunde",
        "slug": "premier-league-meisterschaftsrunde",
        "id": "MALM"
      }
    ]
  },
  {
    "id": "110",
    "name": "Mexico",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga MX Clausura",
        "slug": "liga-mx-clausura",
        "id": "MEX1"
      },
      {
        "name": "Liga MX Apertura",
        "slug": "liga-mx-apertura",
        "id": "MEXA"
      },
      {
        "name": "Liguilla Apertura",
        "slug": "liguilla-apertura",
        "id": "POMX"
      },
      {
        "name": "Liga Expansión MX Cl.",
        "slug": "liga-de-expansion-mx-clausura",
        "id": "MEX2"
      },
      {
        "name": "Liga Expansión MX Ap.",
        "slug": "liga-de-expansion-mx-apertura",
        "id": "MEXB"
      },
      {
        "name": "Liguilla de Expansión Apertura",
        "slug": "liguilla-de-expansion-apertura",
        "id": "MXBA"
      },
      {
        "name": "Liga MX U21 Apertura",
        "slug": "liga-mx-u21-apertura",
        "id": "M21A"
      },
      {
        "name": "Liga MX U21 Clausura",
        "slug": "liga-mx-u21-clausura",
        "id": "M21C"
      },
      {
        "name": "Liguilla MX U21 Apertura",
        "slug": "liguilla-mx-u21-apertura",
        "id": "21MA"
      },
      {
        "name": "Liga MX U19 Apertura",
        "slug": "liga-mx-u19-apertura",
        "id": "M191"
      },
      {
        "name": "Liga MX U19 Clausura",
        "slug": "liga-mx-u19-clausura",
        "id": "M192"
      },
      {
        "name": "Liguilla MX U19 Ap.",
        "slug": "liguilla-mx-u19-apertura",
        "id": "M193"
      },
      {
        "name": "Liguilla Clausura",
        "slug": "liguilla-clausura",
        "id": "POME"
      },
      {
        "name": "Liguilla de Expansión Clausura",
        "slug": "liguilla-de-expansion-clausura",
        "id": "MXBC"
      },
      {
        "name": "Liga MX Sub-20 (09/10)",
        "slug": "liga-mx-sub-20-09-10-",
        "id": "M20H"
      },
      {
        "name": "Liga MX Sub-20 Apertura (- 22/23)",
        "slug": "liga-mx-sub-20-apertura-22-23-",
        "id": "M20A"
      },
      {
        "name": "Liga MX Sub-20 Clausura (- 22/23)",
        "slug": "liga-mx-sub-20-clausura-22-23-",
        "id": "M20C"
      },
      {
        "name": "Liga MX U23 Apertura (23/24 - 24/25)",
        "slug": "liga-mx-u23-apertura-23-24-24-25-",
        "id": "M23A"
      },
      {
        "name": "Liga MX U23 Clausura (23/24 - 24/25)",
        "slug": "liga-mx-u23-clausura-23-24-24-25-",
        "id": "M23C"
      },
      {
        "name": "Liguilla MX Sub-20 Apertura (- 24/25)",
        "slug": "liguilla-mx-sub-20-apertura-24-25-",
        "id": "M2L1"
      },
      {
        "name": "Liguilla MX Sub-20 Clausura (- 24/25)",
        "slug": "liguilla-mx-sub-20-clausura-24-25-",
        "id": "M2L2"
      },
      {
        "name": "Liguilla MX U19 Clausura",
        "slug": "liguilla-mx-u19-clausura",
        "id": "M194"
      },
      {
        "name": "Liguilla MX U21 Clausura",
        "slug": "liguilla-mx-u21-clausura",
        "id": "21MC"
      },
      {
        "name": "Liguilla MX U23 Apertura (- 24/25)",
        "slug": "liguilla-mx-u23-apertura-24-25-",
        "id": "M23L"
      },
      {
        "name": "Liguilla MX U23 Clausura (- 24/25)",
        "slug": "liguilla-mx-u23-clausura-24-25-",
        "id": "M2LC"
      },
      {
        "name": "Copa MX",
        "slug": "copa-mx",
        "id": "CPMX"
      },
      {
        "name": "Copa MX Apertura (- 18/19)",
        "slug": "copa-mx-apertura-18-19-",
        "id": "MXCA"
      },
      {
        "name": "Copa MX Clausura (- 18/19)",
        "slug": "copa-mx-clausura-18-19-",
        "id": "MXCC"
      },
      {
        "name": "InterLiga (- 2010)",
        "slug": "interliga-2010-",
        "id": "MEXP"
      },
      {
        "name": "Campeón de Campeones",
        "slug": "campeon-de-campeones",
        "id": "MXSC"
      },
      {
        "name": "Supercopa MX",
        "slug": "supercopa-mx",
        "id": "SC14"
      },
      {
        "name": "Final de Expansión",
        "slug": "final-de-expansion",
        "id": "MXBF"
      },
      {
        "name": "Primera División Relegation",
        "slug": "primera-division-relegation",
        "id": "MXR1"
      }
    ]
  },
  {
    "id": "112",
    "name": "Moldova",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Super Liga",
        "slug": "super-liga",
        "id": "MO1N"
      },
      {
        "name": "Super Liga (Phase 2)",
        "slug": "super-liga-phase-2-",
        "id": "MOP2"
      },
      {
        "name": "Liga 1 (Promotion)",
        "slug": "liga-1-promotion-",
        "id": "ML1P"
      },
      {
        "name": "Moldovan Cup",
        "slug": "moldovan-cup",
        "id": "MWP1"
      },
      {
        "name": "Divizia Nationala (-2017)",
        "slug": "divizia-nationala-2017-",
        "id": "MOL1"
      },
      {
        "name": "Moldovan Super Cup",
        "slug": "moldovan-super-cup",
        "id": "MOSC"
      },
      {
        "name": "Liga 1 Play-off",
        "slug": "liga-1-play-off",
        "id": "MO1P"
      }
    ]
  },
  {
    "id": "216",
    "name": "Montenegro",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Meridianbet 1. CFL",
        "slug": "meridianbet-1-cfl",
        "id": "MNE1"
      },
      {
        "name": "2. CFL",
        "slug": "2-cfl",
        "id": "MNE2"
      },
      {
        "name": "Montenegro Cup",
        "slug": "montenegro-cup",
        "id": "MNEC"
      },
      {
        "name": "Relegation 1. CFL",
        "slug": "relegation-1-cfl",
        "id": "MNP1"
      }
    ]
  },
  {
    "id": "107",
    "name": "Morocco",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Botola Pro Inwi",
        "slug": "botola-pro-inwi",
        "id": "MAR1"
      },
      {
        "name": "Coupe du Trône Marocaine",
        "slug": "coupe-du-trone-marocaine",
        "id": "MARP"
      },
      {
        "name": "Botola Pro 1 Relegation",
        "slug": "botola-pro-1-relegation",
        "id": "MRR1"
      },
      {
        "name": "Moroccan Excellence Cup",
        "slug": "moroccan-excellence-cup",
        "id": "MEC1"
      }
    ]
  },
  {
    "id": "116",
    "name": "Myanmar",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Myanmar National League",
        "slug": "myanmar-national-league",
        "id": "MYA1"
      },
      {
        "name": "MFF Charity Cup",
        "slug": "mff-charity-cup",
        "id": "MFCC"
      }
    ]
  },
  {
    "id": "119",
    "name": "Nepal",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Nepal Super League",
        "slug": "nepal-super-league",
        "id": "NPL1"
      },
      {
        "name": "Nepal Super League Championship",
        "slug": "nepal-super-league-championship",
        "id": "NPP1"
      }
    ]
  },
  {
    "id": "122",
    "name": "Netherlands",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Eredivisie",
        "slug": "eredivisie",
        "id": "NL1"
      },
      {
        "name": "Keuken Kampioen Divisie",
        "slug": "keuken-kampioen-divisie",
        "id": "NL2"
      },
      {
        "name": "Tweede Divisie",
        "slug": "tweede-divisie",
        "id": "NTD"
      },
      {
        "name": "Derde Divisie B",
        "slug": "derde-divisie-b",
        "id": "511"
      },
      {
        "name": "Derde Divisie A",
        "slug": "derde-divisie-a",
        "id": "510"
      },
      {
        "name": "U21 Div. 1 Fall",
        "slug": "u21-division-1-fall",
        "id": "211F"
      },
      {
        "name": "U21 Div. 1 Spring",
        "slug": "u21-division-1-spring",
        "id": "211S"
      },
      {
        "name": "U21 Div. 2 Spring",
        "slug": "u21-division-2-spring",
        "id": "212S"
      },
      {
        "name": "U21 Div. 2 Fall",
        "slug": "u21-division-2-fall",
        "id": "212F"
      },
      {
        "name": "U19 Div. 1 Spring",
        "slug": "u19-division-1-spring",
        "id": "NLAJ"
      },
      {
        "name": "U19 Div. 1 Fall",
        "slug": "u19-division-1-fall",
        "id": "NLJV"
      },
      {
        "name": "U19 Div. 2 Spring",
        "slug": "u19-division-2-spring",
        "id": "NLAE"
      },
      {
        "name": "U19 Div. 2 Fall",
        "slug": "u19-division-2-fall",
        "id": "NLEV"
      },
      {
        "name": "U17 Div. 1 Spring",
        "slug": "u17-divisie-1-spring",
        "id": "NLBJ"
      },
      {
        "name": "U17 Div. 1 Fall",
        "slug": "u17-division-1-fall",
        "id": "NLVB"
      },
      {
        "name": "KNVB Beker",
        "slug": "knvb-beker",
        "id": "NLP"
      },
      {
        "name": "Johan Cruijff Schaal",
        "slug": "johan-cruijff-schaal",
        "id": "NLSC"
      },
      {
        "name": "O17 Divisie 1 Najaar Kamp.",
        "slug": "o17-divisie-1-najaar-kampioenspoule",
        "id": "7NP1"
      },
      {
        "name": "O17 Divisie 1 Najaar Deg.",
        "slug": "o17-divisie-1-najaar-degradatiepoule",
        "id": "7NP2"
      },
      {
        "name": "U21 Cup Netherlands",
        "slug": "u21-cup-netherlands",
        "id": "NLBP"
      },
      {
        "name": "U19 Cup Netherlands",
        "slug": "u19-cup-netherlands",
        "id": "NLJB"
      },
      {
        "name": "Eerste Klasse A",
        "slug": "eerste-klasse-a",
        "id": "NEKA"
      },
      {
        "name": "Eerste Klasse B",
        "slug": "eerste-klasse-b",
        "id": "NEKB"
      },
      {
        "name": "Eerste Klasse C",
        "slug": "eerste-klasse-c",
        "id": "NEKC"
      },
      {
        "name": "Eerste Klasse D",
        "slug": "eerste-klasse-d",
        "id": "NEKD"
      },
      {
        "name": "Eerste Klasse E",
        "slug": "eerste-klasse-e",
        "id": "NEKE"
      },
      {
        "name": "Eerste Klasse F",
        "slug": "eerste-klasse-f",
        "id": "NEKF"
      },
      {
        "name": "Hoofdklasse A",
        "slug": "hoofdklasse-a",
        "id": "NLHA"
      },
      {
        "name": "Hoofdklasse B",
        "slug": "hoofdklasse-b",
        "id": "NLHB"
      },
      {
        "name": "Hoofdklasse C (until 55/56)",
        "slug": "hoofdklasse-c-until-55-56-",
        "id": "NLHC"
      },
      {
        "name": "Hoofdklasse D (until 55/56)",
        "slug": "hoofdklasse-d-until-55-56-",
        "id": "NLHD"
      },
      {
        "name": "NBVB League (- 1954)",
        "slug": "nbvb-league-1954-",
        "id": "NBVB"
      },
      {
        "name": "Eerste Divisie A",
        "slug": "eerste-divisie-a",
        "id": "NEDA"
      },
      {
        "name": "Eerste Divisie B",
        "slug": "eerste-divisie-b",
        "id": "NEDB"
      },
      {
        "name": "Tweede Divisie A",
        "slug": "tweede-divisie-a",
        "id": "NTDA"
      },
      {
        "name": "Tweede Divisie B",
        "slug": "tweede-divisie-b",
        "id": "NTDB"
      },
      {
        "name": "Vierde Divisie B Saturday",
        "slug": "vierde-divisie-b-saturday",
        "id": "HBZA"
      },
      {
        "name": "Vierde Divisie B Sunday",
        "slug": "vierde-divisie-b-sunday",
        "id": "HBZO"
      },
      {
        "name": "O18 Divisie 1 Fall",
        "slug": "o18-divisie-1-fall",
        "id": "181F"
      },
      {
        "name": "O18 Divisie 1 Spring",
        "slug": "o18-divisie-1-spring",
        "id": "181S"
      },
      {
        "name": "U18 Division 2 Fall",
        "slug": "u18-division-2-fall",
        "id": "182F"
      },
      {
        "name": "U18 Division 2 Spring",
        "slug": "u18-division-2-spring",
        "id": "182S"
      },
      {
        "name": "Beloften Eredivisie - Finale",
        "slug": "beloften-eredivisie-finale",
        "id": "NLBF"
      },
      {
        "name": "Beloften nacompetitie",
        "slug": "beloften-nacompetitie",
        "id": "NLBA"
      },
      {
        "name": "Championship Play-Offs Tweede Divisie",
        "slug": "championship-play-offs-tweede-divisie",
        "id": "NLTP"
      },
      {
        "name": "Final Promotion Eerste Divisie",
        "slug": "final-promotion-eerste-divisie",
        "id": "NLFA"
      },
      {
        "name": "Final Topklasse",
        "slug": "final-topklasse",
        "id": "402"
      },
      {
        "name": "Keuken Kampioen Play-Offs",
        "slug": "keuken-kampioen-play-offs",
        "id": "PON2"
      },
      {
        "name": "Play-Off Championship Eredivisie",
        "slug": "play-off-championship-eredivisie",
        "id": "NL1P"
      },
      {
        "name": "Play-Off Championship U18 Eredivisie",
        "slug": "play-off-championship-u18-eredivisie",
        "id": "NLAP"
      },
      {
        "name": "Play-Off Participation Championship Eredivisie",
        "slug": "play-off-participation-championship-eredivisie",
        "id": "NLEM"
      },
      {
        "name": "Play-Offs Conference League",
        "slug": "play-offs-conference-league",
        "id": "PONL"
      },
      {
        "name": "Play-Offs Degradation Eerste Divisie",
        "slug": "play-offs-degradation-eerste-divisie",
        "id": "POED"
      },
      {
        "name": "Play-Offs Degradation Tweede Divisie",
        "slug": "play-offs-degradation-tweede-divisie",
        "id": "POTD"
      },
      {
        "name": "Play-Offs Promotion Derde Divisie",
        "slug": "play-offs-promotion-derde-divisie",
        "id": "NDDA"
      },
      {
        "name": "Play-Offs Promotion Tweede Divisie",
        "slug": "play-offs-promotion-tweede-divisie",
        "id": "PRTD"
      },
      {
        "name": "U17 Division 1 Championship Playoff",
        "slug": "u17-division-1-championship-playoff",
        "id": "BK17"
      },
      {
        "name": "U19 Division 1 Championship Playoff",
        "slug": "u19-division-1-championship-playoff",
        "id": "BK19"
      },
      {
        "name": "Beloften Eerste Divisie",
        "slug": "beloften-eerste-divisie",
        "id": "NLBB"
      },
      {
        "name": "Beloften Eredivisie",
        "slug": "beloften-eredivisie",
        "id": "NLBE"
      },
      {
        "name": "Beloften Preliminary Round",
        "slug": "beloften-preliminary-round",
        "id": "NLBV"
      }
    ]
  },
  {
    "id": "120",
    "name": "New Zealand",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "National League - North",
        "slug": "national-league-north",
        "id": "NNL1"
      },
      {
        "name": "National League - Central",
        "slug": "national-league-central",
        "id": "NCL1"
      },
      {
        "name": "National League - South",
        "slug": "national-league-south",
        "id": "NSL1"
      },
      {
        "name": "National League Championship",
        "slug": "national-league-championship",
        "id": "NZNL"
      },
      {
        "name": "New Zealand Premiership (- 2021)",
        "slug": "new-zealand-premiership-2021-",
        "id": "NZL1"
      },
      {
        "name": "Chatham Cup",
        "slug": "chatham-cup",
        "id": "NZP1"
      },
      {
        "name": "Charity Cup",
        "slug": "charity-cup",
        "id": "NZPO"
      },
      {
        "name": "ISPS Handa Premiership-Playoffs (- 2021)",
        "slug": "isps-handa-premiership-playoffs-2021-",
        "id": "NZLP"
      },
      {
        "name": "National League - North promotion play-off",
        "slug": "national-league-north-promotion-play-off",
        "id": "NLNP"
      },
      {
        "name": "New Zealand National League Grand Final",
        "slug": "new-zealand-national-league-grand-final",
        "id": "NNLP"
      }
    ]
  },
  {
    "id": "121",
    "name": "Nicaragua",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga Primera Apertura",
        "slug": "liga-primera-de-nicaragua-apertura",
        "id": "NC1A"
      },
      {
        "name": "Liga Primera Clausura",
        "slug": "liga-primera-de-nicaragua-clausura",
        "id": "NC1C"
      },
      {
        "name": "Copa Primera",
        "slug": "copa-primera-de-nicaragua",
        "id": "CNIC"
      },
      {
        "name": "Prim. Apertura Playoff",
        "slug": "liga-primera-de-nicaragua-apertura-playoff",
        "id": "NCP1"
      },
      {
        "name": "Liga Primera de Nicaragua Clausura Playoff",
        "slug": "liga-primera-de-nicaragua-clausura-playoff",
        "id": "NCP2"
      },
      {
        "name": "Liga Primera de Nicaragua Relegation",
        "slug": "liga-primera-de-nicaragua-relegation",
        "id": "NC1P"
      }
    ]
  },
  {
    "id": "124",
    "name": "Nigeria",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "NPFL",
        "slug": "nigeria-professional-football-league",
        "id": "NPFL"
      },
      {
        "name": "Nigeria Professional Football League Playoffs",
        "slug": "nigeria-professional-football-league-playoffs",
        "id": "NPPL"
      }
    ]
  },
  {
    "id": "100",
    "name": "North Macedonia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Prva liga",
        "slug": "prva-makedonska-fudbalska-liga",
        "id": "MAZ1"
      },
      {
        "name": "Kup na Makedonija",
        "slug": "kup-na-makedonija",
        "id": "NMAP"
      },
      {
        "name": "Relegation PMFL",
        "slug": "relegation-pmfl",
        "id": "MAZR"
      }
    ]
  },
  {
    "id": "192",
    "name": "Northern Ireland",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premiership",
        "slug": "premiership",
        "id": "NIR1"
      },
      {
        "name": "Championship",
        "slug": "championship",
        "id": "NIR2"
      },
      {
        "name": "Intermediate",
        "slug": "intermediate-league",
        "id": "NIR3"
      },
      {
        "name": "Irish League Cup",
        "slug": "irish-league-cup",
        "id": "NILC"
      },
      {
        "name": "Irish Cup",
        "slug": "irish-cup",
        "id": "NIRC"
      },
      {
        "name": "NIFL Charity Shield",
        "slug": "nifl-charity-shield",
        "id": "NSC"
      },
      {
        "name": "Playoff Premiership",
        "slug": "playoff-premiership",
        "id": "NIRF"
      },
      {
        "name": "Playout Premiership",
        "slug": "playout-premiership",
        "id": "NIRU"
      },
      {
        "name": "Playoff Championship",
        "slug": "playoff-championship",
        "id": "NIMC"
      },
      {
        "name": "Playout Championship",
        "slug": "playout-championship",
        "id": "NIAR"
      },
      {
        "name": "County Antrim Shield",
        "slug": "county-antrim-shield",
        "id": "CASH"
      },
      {
        "name": "Mid Ulster Cup",
        "slug": "mid-ulster-cup",
        "id": "MUCU"
      },
      {
        "name": "North West Cup",
        "slug": "north-west-cup",
        "id": "NWSC"
      },
      {
        "name": "Bob Radcliffe Cup",
        "slug": "bob-radcliffe-cup",
        "id": "BRCP"
      },
      {
        "name": "Craig Memorial Cup",
        "slug": "craig-memorial-cup",
        "id": "CMCU"
      },
      {
        "name": "Steel Cup",
        "slug": "steel-amp-sons-cup",
        "id": "SSCP"
      },
      {
        "name": "Abstiegsrunde Intermedia",
        "slug": "abstiegsrunde-intermedia",
        "id": "NIAI"
      },
      {
        "name": "Meisterrunde Intermedia",
        "slug": "meisterrunde-intermedia",
        "id": "NIMI"
      },
      {
        "name": "Playoff Championship",
        "slug": "playoff-championship",
        "id": "NIP2"
      },
      {
        "name": "Playoff Premiership",
        "slug": "playoff-premiership",
        "id": "NIPP"
      },
      {
        "name": "Premiership Playoff Conference League",
        "slug": "premiership-playoff-conference-league",
        "id": "NIRE"
      }
    ]
  },
  {
    "id": "125",
    "name": "Norway",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Eliteserien",
        "slug": "eliteserien",
        "id": "NO1"
      },
      {
        "name": "OBOS-ligaen",
        "slug": "obos-ligaen",
        "id": "NO2"
      },
      {
        "name": "PostNord-ligaen Avd. 2",
        "slug": "postnord-ligaen-avd-2",
        "id": "NO32"
      },
      {
        "name": "PostNord-ligaen Avd. 1",
        "slug": "postnord-ligaen-avd-1",
        "id": "NO31"
      },
      {
        "name": "Norsk Tipping-Ligaen avd. 2",
        "slug": "norsk-tipping-ligaen-avdeling-2",
        "id": "NO42"
      },
      {
        "name": "Norsk Tipping-Ligaen avd. 4",
        "slug": "norsk-tipping-ligaen-avdeling-4",
        "id": "NO44"
      },
      {
        "name": "Norsk Tipping-Ligaen avd. 5",
        "slug": "norsk-tipping-ligaen-avdeling-5",
        "id": "NO45"
      },
      {
        "name": "Norsk Tipping-Ligaen avd. 6",
        "slug": "norsk-tipping-ligaen-avdeling-6",
        "id": "NO46"
      },
      {
        "name": "Norsk Tipping-Ligaen avd. 3",
        "slug": "norsk-tipping-ligaen-avdeling-3",
        "id": "NO43"
      },
      {
        "name": "Norsk Tipping-Ligaen avd. 1",
        "slug": "norsk-tipping-ligaen-avdeling-1",
        "id": "NO41"
      },
      {
        "name": "NM-Cup",
        "slug": "nm-cup",
        "id": "NOPO"
      },
      {
        "name": "UNICEF Mesterfinale",
        "slug": "unicef-mesterfinale",
        "id": "NOSC"
      },
      {
        "name": "PostNord-ligaen Avd. 1 Sluttspill",
        "slug": "postnord-ligaen-avd-1-sluttspill",
        "id": "N3P1"
      },
      {
        "name": "PostNord-ligaen Avd. 2 Sluttspill",
        "slug": "postnord-ligaen-avd-2-sluttspill",
        "id": "N3P2"
      },
      {
        "name": "Relegation Eliteserien",
        "slug": "relegation-eliteserien",
        "id": "RTIP"
      },
      {
        "name": "Relegation OBOS-ligaen",
        "slug": "relegation-obos-ligaen",
        "id": "NO2R"
      }
    ]
  },
  {
    "id": "126",
    "name": "Oman",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Jindal League",
        "slug": "oman-jindal-league",
        "id": "OM1L"
      }
    ]
  },
  {
    "id": "130",
    "name": "Panama",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga Panameña Clausura",
        "slug": "liga-panamena-de-futbol-clausura",
        "id": "PN1C"
      },
      {
        "name": "Liga Panameña de Fútbol Apertura",
        "slug": "liga-panamena-de-futbol-apertura",
        "id": "PN1A"
      },
      {
        "name": "Supercopa de Panamá",
        "slug": "supercopa-de-panama",
        "id": "PNSC"
      },
      {
        "name": "Liga Panameña de Fútbol Apertura Playoff",
        "slug": "liga-panamena-de-futbol-apertura-playoff",
        "id": "PN1F"
      },
      {
        "name": "Liga Panameña de Fútbol Clausura Playoff",
        "slug": "liga-panamena-de-futbol-clausura-playoff",
        "id": "PNF1"
      }
    ]
  },
  {
    "id": "132",
    "name": "Paraguay",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Primera División Apertura",
        "slug": "primera-division-apertura",
        "id": "PR1A"
      },
      {
        "name": "División Intermedia",
        "slug": "division-intermedia",
        "id": "PAR2"
      },
      {
        "name": "Primera División Clausura",
        "slug": "primera-division-clausura",
        "id": "PR1C"
      },
      {
        "name": "Primera División Paraguay Playoffs",
        "slug": "primera-division-paraguay-playoffs",
        "id": "PR1P"
      }
    ]
  },
  {
    "id": "133",
    "name": "Peru",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga 1 Apertura",
        "slug": "liga-1-apertura",
        "id": "TDeA"
      },
      {
        "name": "Liga 2",
        "slug": "liga-2",
        "id": "PER2"
      },
      {
        "name": "Liga 3",
        "slug": "liga-3",
        "id": "PLI3"
      },
      {
        "name": "Liga 1 Clausura",
        "slug": "liga-1-clausura",
        "id": "TDeC"
      },
      {
        "name": "Liga 1 Liguilla A",
        "slug": "liga-1-liguilla-a",
        "id": "PEDP"
      },
      {
        "name": "Liga 1 Liguilla B",
        "slug": "liga-1-liguilla-b",
        "id": "PEDI"
      },
      {
        "name": "Torneo Descentralizado (2007 - 2013)",
        "slug": "torneo-descentralizado-2007-2013-",
        "id": "PERC"
      },
      {
        "name": "Torneo Descentralizado Segunda Fase",
        "slug": "torneo-descentralizado-segunda-fase",
        "id": "PERS"
      },
      {
        "name": "Torneo de Verano  (- 2018)",
        "slug": "torneo-de-verano-2018-",
        "id": "Inka"
      },
      {
        "name": "Copa Bicentenario",
        "slug": "copa-bicentenario",
        "id": "COBI"
      },
      {
        "name": "Copa del Inca",
        "slug": "copa-del-inca",
        "id": "PTDI"
      },
      {
        "name": "Supercopa Peruana",
        "slug": "supercopa-peruana",
        "id": "PUSC"
      },
      {
        "name": "Definición del descenso de Liga 2",
        "slug": "definicion-del-descenso-de-liga-2",
        "id": "PEP6"
      },
      {
        "name": "Liga 1 Clausura Entscheidungsspiel",
        "slug": "liga-1-clausura-entscheidungsspiel",
        "id": "PERD"
      },
      {
        "name": "Liga 1 Playoffs",
        "slug": "liga-1-playoffs",
        "id": "PERF"
      },
      {
        "name": "Liga 1 Relegation",
        "slug": "liga-1-relegation",
        "id": "PERE"
      },
      {
        "name": "Liga 2 - Grupo campeonato",
        "slug": "liga-2-grupo-campeonato",
        "id": "PEP4"
      },
      {
        "name": "Liga 2 - Grupo descenso",
        "slug": "liga-2-grupo-descenso",
        "id": "PEP5"
      },
      {
        "name": "Liga 2 Playoffs",
        "slug": "liga-2-playoffs",
        "id": "P2PL"
      },
      {
        "name": "Liga 3 - Fase final",
        "slug": "liga-3-fase-final",
        "id": "PL3F"
      },
      {
        "name": "Liga 3 Playoffs",
        "slug": "liga-3-playoffs",
        "id": "P3PL"
      },
      {
        "name": "Promoción de ascenso a Liga 2",
        "slug": "promocion-de-ascenso-a-liga-2",
        "id": "PEP3"
      },
      {
        "name": "Torneo de Verano Playoff (- 2018)",
        "slug": "torneo-de-verano-playoff-2018-",
        "id": "InkF"
      }
    ]
  },
  {
    "id": "134",
    "name": "Philippines",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "PFL",
        "slug": "philippines-football-league",
        "id": "PFL1"
      },
      {
        "name": "United Football League (-2016)",
        "slug": "united-football-league-2016-",
        "id": "PHI1"
      },
      {
        "name": "Copa Paulino Alcantara",
        "slug": "copa-paulino-alcantara",
        "id": "PHPO"
      },
      {
        "name": "United Football League Playoffs",
        "slug": "united-football-league-playoffs",
        "id": "PHIP"
      },
      {
        "name": "Philippines Football League Final Series",
        "slug": "philippines-football-league-final-series",
        "id": "PFLM"
      }
    ]
  },
  {
    "id": "135",
    "name": "Poland",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Ekstraklasa",
        "slug": "pko-bp-ekstraklasa",
        "id": "PL1"
      },
      {
        "name": "Betclic 1 Liga",
        "slug": "betclic-1-liga",
        "id": "PL2"
      },
      {
        "name": "Betclic 2 Liga",
        "slug": "betclic-2-liga",
        "id": "PL2L"
      },
      {
        "name": "Betclic 3 Liga - Group IV",
        "slug": "betclic-3-liga-group-iv",
        "id": "PL34"
      },
      {
        "name": "Betclic 3 Liga - Group I",
        "slug": "betclic-3-liga-group-i",
        "id": "PL31"
      },
      {
        "name": "Betclic 3 Liga - Group III",
        "slug": "betclic-3-liga-group-iii",
        "id": "PL33"
      },
      {
        "name": "Betclic 3 Liga - Group II",
        "slug": "betclic-3-liga-group-ii",
        "id": "PL32"
      },
      {
        "name": "Youth League POL",
        "slug": "central-youth-league",
        "id": "PLZJ"
      },
      {
        "name": "STS Polish Cup",
        "slug": "sts-polish-cup",
        "id": "POPU"
      },
      {
        "name": "Superpuchar",
        "slug": "superpuchar-polski",
        "id": "PLSC"
      },
      {
        "name": "2 Liga - East",
        "slug": "2-liga-east",
        "id": "PL3W"
      },
      {
        "name": "2 Liga - West",
        "slug": "2-liga-west",
        "id": "PL3Z"
      },
      {
        "name": "Central Youth League - East",
        "slug": "central-youth-league-east",
        "id": "PLJW"
      },
      {
        "name": "Central Youth League - West",
        "slug": "central-youth-league-west",
        "id": "PLJZ"
      },
      {
        "name": "Baraze o udzial w Ekstraklasie",
        "slug": "baraze-o-udzial-w-ekstraklasie",
        "id": "BAPO"
      },
      {
        "name": "Baraże o udział w Betclic II lidze",
        "slug": "baraze-o-udzial-w-betclic-ii-lidze",
        "id": "BA2L"
      },
      {
        "name": "Baraże o udział w CLJ",
        "slug": "baraze-o-udzial-w-clj",
        "id": "PLJR"
      },
      {
        "name": "Central Youth League - Final round",
        "slug": "central-youth-league-final-round",
        "id": "PLJF"
      },
      {
        "name": "Ekstraklasa - Championship playoff",
        "slug": "ekstraklasa-championship-playoff",
        "id": "PL1M"
      },
      {
        "name": "Ekstraklasa - Relegation playoff",
        "slug": "ekstraklasa-relegation-playoff",
        "id": "Pl1A"
      },
      {
        "name": "Promotion Playoffs 1 Liga",
        "slug": "promotion-playoffs-1-liga",
        "id": "BAPL"
      }
    ]
  },
  {
    "id": "136",
    "name": "Portugal",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga Portugal",
        "slug": "liga-portugal",
        "id": "PO1"
      },
      {
        "name": "Liga Portugal 2",
        "slug": "liga-portugal-2",
        "id": "PO2"
      },
      {
        "name": "Liga 3",
        "slug": "liga-3",
        "id": "PT3A"
      },
      {
        "name": "CP - Série D",
        "slug": "campeonato-de-portugal-serie-d",
        "id": "CPSD"
      },
      {
        "name": "CP - Série C",
        "slug": "campeonato-de-portugal-serie-c",
        "id": "CPSC"
      },
      {
        "name": "CP - Série B",
        "slug": "campeonato-de-portugal-serie-b",
        "id": "CPSB"
      },
      {
        "name": "CP - Série A",
        "slug": "campeonato-de-portugal-serie-a",
        "id": "CPSA"
      },
      {
        "name": "Liga Revelação",
        "slug": "liga-revelacao-u23",
        "id": "PT23"
      },
      {
        "name": "Taça de Portugal",
        "slug": "taca-de-portugal",
        "id": "POPO"
      },
      {
        "name": "Supertaça",
        "slug": "supertaca-candido-de-oliveira",
        "id": "POSU"
      },
      {
        "name": "Liga 3 - Relegation round",
        "slug": "liga-3-relegation-round",
        "id": "P3As"
      },
      {
        "name": "Revelação U23 - Championship",
        "slug": "liga-revelacao-u23-championship-round",
        "id": "P23C"
      },
      {
        "name": "Liga 3 - Promotion",
        "slug": "liga-3-promotion-stage",
        "id": "P3Au"
      },
      {
        "name": "Revelação U23 - Qualif. round",
        "slug": "liga-revelacao-u23-qualifikation-round",
        "id": "P23Q"
      },
      {
        "name": "Allianz Cup",
        "slug": "allianz-cup",
        "id": "POCP"
      },
      {
        "name": "Campeonato Portugal Ap. Campeão",
        "slug": "campeonato-portugal-ap-campeao",
        "id": "P2RL"
      },
      {
        "name": "Liga Revelação - Second Round",
        "slug": "liga-revelacao-second-round",
        "id": "P232"
      },
      {
        "name": "Torneio Abertura Liga Revelação U23",
        "slug": "torneio-abertura-liga-revelacao-u23",
        "id": "P23A"
      },
      {
        "name": "U-23 Cup Portugal",
        "slug": "u-23-cup-portugal",
        "id": "PTPR"
      },
      {
        "name": "Campeonato de Portugal Playoff",
        "slug": "campeonato-de-portugal-playoff",
        "id": "CPSP"
      },
      {
        "name": "Liga 3 - Finals",
        "slug": "liga-3-finals",
        "id": "3PTP"
      },
      {
        "name": "Play-Off Liga Portugal",
        "slug": "play-off-liga-portugal",
        "id": "PTRL"
      },
      {
        "name": "Play-Off Liga Portugal 2",
        "slug": "play-off-liga-portugal-2",
        "id": "POLL"
      },
      {
        "name": "Torneio Abertura Liga Revelação Sub-23 Playoff",
        "slug": "torneio-abertura-liga-revelacao-sub-23-playoff",
        "id": "P23P"
      },
      {
        "name": "Torneio Abertura Final",
        "slug": "torneio-abertura-final",
        "id": "P23F"
      }
    ]
  },
  {
    "id": "228",
    "name": "Puerto Rico",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga Puerto Rico Apertura",
        "slug": "liga-puerto-rico-apertura",
        "id": "PRA1"
      },
      {
        "name": "Liga Puerto Rico Clausura",
        "slug": "liga-puerto-rico-clausura",
        "id": "PRC1"
      },
      {
        "name": "Puerto Rico Ap. Playoff",
        "slug": "liga-puerto-rico-apertura-playoff",
        "id": "PRP1"
      },
      {
        "name": "Supercopa Puerto Rico",
        "slug": "supercopa-puerto-rico",
        "id": "PRSC"
      },
      {
        "name": "Liga Puerto Rico Clausura - Playoff",
        "slug": "liga-puerto-rico-clausura-playoff",
        "id": "PRP2"
      }
    ]
  },
  {
    "id": "137",
    "name": "Qatar",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Stars League",
        "slug": "qatar-stars-league",
        "id": "QSL"
      },
      {
        "name": "Qatari Second Division",
        "slug": "qatari-second-division",
        "id": "QU2L"
      },
      {
        "name": "Amir Cup",
        "slug": "amir-cup",
        "id": "QEC1"
      },
      {
        "name": "Qatari Stars Cup",
        "slug": "qatari-stars-cup-ooredoo-",
        "id": "QSCP"
      },
      {
        "name": "Amir Cup - Preliminary stage",
        "slug": "amir-cup-preliminary-stage",
        "id": "AMCQ"
      },
      {
        "name": "Qatari Sheikh Jassim Cup",
        "slug": "qatari-sheikh-jassim-cup",
        "id": "QSJ1"
      },
      {
        "name": "Qatar Stars League Relegation",
        "slug": "qatar-stars-league-relegation",
        "id": "QSLR"
      },
      {
        "name": "Qatar Cup",
        "slug": "qatar-cup",
        "id": "QUC1"
      }
    ]
  },
  {
    "id": "140",
    "name": "Romania",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "SuperLiga",
        "slug": "superliga",
        "id": "RO1"
      },
      {
        "name": "Liga 2",
        "slug": "liga-2",
        "id": "RO2"
      },
      {
        "name": "Romanian Cup",
        "slug": "romanian-cup",
        "id": "ROMP"
      },
      {
        "name": "Romanian Supercup",
        "slug": "romanian-supercup",
        "id": "ROMS"
      },
      {
        "name": "SuperLiga - Championship group",
        "slug": "superliga-championship-group",
        "id": "RO1C"
      },
      {
        "name": "SuperLiga - Relegation group",
        "slug": "superliga-relegation-group",
        "id": "RO1R"
      },
      {
        "name": "Liga 2 Play-Out",
        "slug": "liga-2-play-out",
        "id": "R2AO"
      },
      {
        "name": "Liga 2 Play-Off",
        "slug": "liga-2-play-off",
        "id": "R2AP"
      },
      {
        "name": "Liga II - Seria II",
        "slug": "liga-ii-seria-ii",
        "id": "RO2B"
      },
      {
        "name": "Liga II - Seria II Play-Off",
        "slug": "liga-ii-seria-ii-play-off",
        "id": "R2BP"
      },
      {
        "name": "Liga de Tineret Finals",
        "slug": "liga-de-tineret-finals",
        "id": "RO19"
      },
      {
        "name": "Liga 3 Promotion Play-Off",
        "slug": "liga-3-promotion-play-off",
        "id": "RO3F"
      },
      {
        "name": "SuperLiga - Playoff Conference League",
        "slug": "superliga-playoff-conference-league",
        "id": "ROPC"
      },
      {
        "name": "SuperLiga/Liga 2 Play-off",
        "slug": "superliga-liga-2-play-off",
        "id": "RORE"
      },
      {
        "name": "Cupa Ligii",
        "slug": "cupa-ligii",
        "id": "ROCL"
      },
      {
        "name": "Cupa de Tineret",
        "slug": "cupa-de-tineret",
        "id": "ROCJ"
      }
    ]
  },
  {
    "id": "141",
    "name": "Russia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier Liga",
        "slug": "premier-liga",
        "id": "RU1"
      },
      {
        "name": "1.Division",
        "slug": "1-division",
        "id": "RU2"
      },
      {
        "name": "2. Division A (Phase 2)",
        "slug": "2-division-a-phase-2-",
        "id": "R3D2"
      },
      {
        "name": "2. Division A (Phase 1)",
        "slug": "2-division-a-phase-1-",
        "id": "R3D1"
      },
      {
        "name": "2. Division B",
        "slug": "2-division-b",
        "id": "2DVB"
      },
      {
        "name": "U19 M-Liga",
        "slug": "u19-m-liga-since-2024-",
        "id": "RJL2"
      },
      {
        "name": "YFL U17",
        "slug": "yfl-u17",
        "id": "Y047"
      },
      {
        "name": "YFL U16",
        "slug": "yfl-u16",
        "id": "Y246"
      },
      {
        "name": "Russian Cup",
        "slug": "russian-cup",
        "id": "RUP"
      },
      {
        "name": "Russian Super Cup",
        "slug": "russian-super-cup",
        "id": "RUSS"
      },
      {
        "name": "Russian PFL Ost (-2019)",
        "slug": "russian-pfl-ost-2019-",
        "id": "RPLO"
      },
      {
        "name": "Second League Division B Gruppe 1 (-2023)",
        "slug": "second-league-division-b-gruppe-1-2023-",
        "id": "RPLS"
      },
      {
        "name": "Second League Division B Gruppe 2 (-2023)",
        "slug": "second-league-division-b-gruppe-2-2023-",
        "id": "RPLW"
      },
      {
        "name": "Second League Division B Gruppe 3 (-2023)",
        "slug": "second-league-division-b-gruppe-3-2023-",
        "id": "RPLZ"
      },
      {
        "name": "Second League Division B Gruppe 4 (-2023)",
        "slug": "second-league-division-b-gruppe-4-2023-",
        "id": "RPLU"
      },
      {
        "name": "Russian U16 Youth Football League (-2023)",
        "slug": "russian-u16-youth-football-league-2023-",
        "id": "RU16"
      },
      {
        "name": "Russian U17 Youth Football League (-2023)",
        "slug": "russian-u17-youth-football-league-2023-",
        "id": "RU17"
      },
      {
        "name": "U19 M-Liga (- 2023)",
        "slug": "u19-m-liga-2023-",
        "id": "RUJL"
      },
      {
        "name": "2. Division A Playoff 2",
        "slug": "2-division-a-playoff-2",
        "id": "R3P2"
      },
      {
        "name": "Premier Liga Abstiegs-Playoff",
        "slug": "premier-liga-abstiegs-playoff",
        "id": "RUPD"
      },
      {
        "name": "Premier Liga Meisterschafts-Playoff",
        "slug": "premier-liga-meisterschafts-playoff",
        "id": "RUPM"
      },
      {
        "name": "Relegation Premier Liga",
        "slug": "relegation-premier-liga",
        "id": "RUSR"
      },
      {
        "name": "U19 M-Liga Play-off",
        "slug": "u19-m-liga-play-off",
        "id": "RJP1"
      },
      {
        "name": "Premier Liga Cup",
        "slug": "premier-liga-cup",
        "id": "RULP"
      }
    ]
  },
  {
    "id": "144",
    "name": "San Marino",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Camp. Sammarinese",
        "slug": "campionato-sammarinese",
        "id": "SMR1"
      },
      {
        "name": "Coppa Titano",
        "slug": "coppa-titano",
        "id": "SMP1"
      },
      {
        "name": "Supercoppa San Marino",
        "slug": "supercoppa-san-marino",
        "id": "SMRS"
      },
      {
        "name": "Campionato Sammarinese Prima Fase",
        "slug": "campionato-sammarinese-prima-fase",
        "id": "CSPF"
      },
      {
        "name": "Campionato Sammarinese Seconda Fase",
        "slug": "campionato-sammarinese-seconda-fase",
        "id": "CSSF"
      },
      {
        "name": "Campionato Sammarinese Playoff",
        "slug": "campionato-sammarinese-playoff",
        "id": "SMRP"
      }
    ]
  },
  {
    "id": "146",
    "name": "Saudi Arabia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Saudi Pro League",
        "slug": "saudi-pro-league",
        "id": "SA1"
      },
      {
        "name": "Saudi First Division League",
        "slug": "saudi-first-division-league",
        "id": "SA2L"
      },
      {
        "name": "King's Cup",
        "slug": "kings-cup",
        "id": "SAKC"
      },
      {
        "name": "Saudi Super Cup",
        "slug": "saudi-super-cup",
        "id": "SASS"
      },
      {
        "name": "Saudi First Division Play-off",
        "slug": "saudi-first-division-play-off",
        "id": "SA2P"
      },
      {
        "name": "Saudi Pro League Championship Play-off",
        "slug": "saudi-pro-league-championship-play-off",
        "id": "SPLP"
      },
      {
        "name": "Saudi Pro League Relegation (- 2019)",
        "slug": "saudi-pro-league-relegation-2019-",
        "id": "SAUR"
      },
      {
        "name": "Saudi Crown Prince's Cup (1956/57 - 2017/18)",
        "slug": "saudi-crown-princes-cup-1956-57-2017-18-",
        "id": "SAUP"
      }
    ]
  },
  {
    "id": "190",
    "name": "Scotland",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premiership",
        "slug": "scottish-premiership",
        "id": "SC1"
      },
      {
        "name": "Championship",
        "slug": "scottish-championship",
        "id": "SC2"
      },
      {
        "name": "League One",
        "slug": "scottish-league-one",
        "id": "SC3"
      },
      {
        "name": "League Two",
        "slug": "scottish-league-two",
        "id": "SC4"
      },
      {
        "name": "Lowland League",
        "slug": "scottish-lowland-football-league",
        "id": "SC5L"
      },
      {
        "name": "Highland League",
        "slug": "scottish-highland-football-league",
        "id": "SC5H"
      },
      {
        "name": "SFA Cup",
        "slug": "scottish-fa-cup",
        "id": "SFA"
      },
      {
        "name": "League Cup",
        "slug": "scottish-league-cup",
        "id": "SCP"
      },
      {
        "name": "Challenge Cup",
        "slug": "scottish-challenge-cup",
        "id": "SSC"
      },
      {
        "name": "Scottish Championship Play-offs",
        "slug": "scottish-championship-play-offs",
        "id": "POFD"
      },
      {
        "name": "Scottish Highland Football League Playoff",
        "slug": "scottish-highland-football-league-playoff",
        "id": "SC5P"
      },
      {
        "name": "Scottish League One Bottom Six Split",
        "slug": "scottish-league-one-bottom-six-split",
        "id": "SC3A"
      },
      {
        "name": "Scottish League One Play-offs",
        "slug": "scottish-league-one-play-offs",
        "id": "POSD"
      },
      {
        "name": "Scottish League One Top Six Split",
        "slug": "scottish-league-one-top-six-split",
        "id": "SC3M"
      },
      {
        "name": "Scottish League Two Bottom Six Split",
        "slug": "scottish-league-two-bottom-six-split",
        "id": "SC4A"
      },
      {
        "name": "Scottish League Two Play Offs",
        "slug": "scottish-league-two-play-offs",
        "id": "SL2P"
      },
      {
        "name": "Scottish League Two Top Six Split",
        "slug": "scottish-league-two-top-six-split",
        "id": "SC4M"
      },
      {
        "name": "Scottish Premiership Play-offs",
        "slug": "scottish-premiership-play-offs",
        "id": "SC1P"
      },
      {
        "name": "Scottish Premiership Relegation Round",
        "slug": "scottish-premiership-relegation-round",
        "id": "SCPA"
      },
      {
        "name": "Scottish Premiership Top Six Split",
        "slug": "scottish-premiership-top-six-split",
        "id": "SCPM"
      }
    ]
  },
  {
    "id": "149",
    "name": "Senegal",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Ligue 1",
        "slug": "ligue-1",
        "id": "SEN1"
      }
    ]
  },
  {
    "id": "215",
    "name": "Serbia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Super liga Srbije",
        "slug": "super-liga-srbije",
        "id": "SER1"
      },
      {
        "name": "Prva liga Srbije",
        "slug": "prva-liga-srbije",
        "id": "SER2"
      },
      {
        "name": "Omladinska liga",
        "slug": "omladinska-liga-srbije",
        "id": "SB19"
      },
      {
        "name": "Kadetska liga",
        "slug": "kadetska-liga-srbije",
        "id": "SB17"
      },
      {
        "name": "Kup Srbije",
        "slug": "kup-srbije",
        "id": "SERP"
      },
      {
        "name": "Prva liga Championship round",
        "slug": "prva-liga-championship-round",
        "id": "PVCR"
      },
      {
        "name": "Prva liga Relegation round",
        "slug": "prva-liga-relegation-round",
        "id": "PVRR"
      },
      {
        "name": "Relegation SuperLiga",
        "slug": "relegation-superliga",
        "id": "RSER"
      },
      {
        "name": "Super liga Championship round",
        "slug": "super-liga-championship-round",
        "id": "SR1C"
      },
      {
        "name": "Super liga Relegation round",
        "slug": "super-liga-relegation-round",
        "id": "SR1R"
      }
    ]
  },
  {
    "id": "153",
    "name": "Singapore",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier League",
        "slug": "singapore-premier-league",
        "id": "SIN1"
      },
      {
        "name": "Premier League 2",
        "slug": "singapore-premier-league-2",
        "id": "SIN2"
      },
      {
        "name": "Singapore Cup",
        "slug": "singapore-cup",
        "id": "SINP"
      },
      {
        "name": "Singapore Community Shield",
        "slug": "singapore-community-shield",
        "id": "SPCS"
      },
      {
        "name": "S.League Championship Round",
        "slug": "s-league-championship-round",
        "id": "SIMR"
      },
      {
        "name": "S.League Relegation Round",
        "slug": "s-league-relegation-round",
        "id": "SIAR"
      },
      {
        "name": "Singapore League Cup (2007-2017)",
        "slug": "singapore-league-cup-2007-2017-",
        "id": "SINC"
      },
      {
        "name": "Prime League (1997-2017)",
        "slug": "prime-league-1997-2017-",
        "id": "SINR"
      }
    ]
  },
  {
    "id": "154",
    "name": "Slovakia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Niké Liga",
        "slug": "nike-liga",
        "id": "SLO1"
      },
      {
        "name": "MONACObet liga",
        "slug": "monacobet-liga",
        "id": "SK2"
      },
      {
        "name": "I. Liga SD",
        "slug": "i-liga-starsieho-dorastu",
        "id": "SK19"
      },
      {
        "name": "Slovnaft Cup",
        "slug": "slovnaft-cup",
        "id": "SKC"
      },
      {
        "name": "Nike Liga - Champ. G.",
        "slug": "nike-liga-championship-group",
        "id": "SLAR"
      },
      {
        "name": "Nike Liga - Releg. G.",
        "slug": "nike-liga-relegation-group",
        "id": "SLMR"
      },
      {
        "name": "Slovak Super Cup",
        "slug": "slovak-super-cup",
        "id": "SKSC"
      },
      {
        "name": "II. Liga Promotion",
        "slug": "ii-liga-promotion",
        "id": "SK2P"
      },
      {
        "name": "II. Liga Relegation",
        "slug": "ii-liga-relegation",
        "id": "SKR2"
      },
      {
        "name": "II. Liga Relegation Playoff",
        "slug": "ii-liga-relegation-playoff",
        "id": "SKRP"
      },
      {
        "name": "Nike Liga - Conference League Play-off",
        "slug": "nike-liga-conference-league-play-off",
        "id": "SWEP"
      },
      {
        "name": "Nike Liga - Relegation Play-off",
        "slug": "nike-liga-relegation-play-off",
        "id": "SWRP"
      }
    ]
  },
  {
    "id": "155",
    "name": "Slovenia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Prva Liga",
        "slug": "prva-liga",
        "id": "SL1"
      },
      {
        "name": "Druga Liga",
        "slug": "druga-liga",
        "id": "SL2"
      },
      {
        "name": "NextGen Liga",
        "slug": "nextgen-liga",
        "id": "SL19"
      },
      {
        "name": "Pokal Slovenije",
        "slug": "pokal-slovenije",
        "id": "SLP"
      },
      {
        "name": "Relegation Prva Liga",
        "slug": "relegation-prva-liga",
        "id": "POSL"
      }
    ]
  },
  {
    "id": "159",
    "name": "South Africa",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Betway Premiership",
        "slug": "betway-premiership",
        "id": "SFA1"
      },
      {
        "name": "Nedbank Cup",
        "slug": "nedbank-cup",
        "id": "NEDC"
      },
      {
        "name": "Carling Knockout",
        "slug": "carling-knockout",
        "id": "TELK"
      },
      {
        "name": "MTN8",
        "slug": "mtn8",
        "id": "SFAL"
      },
      {
        "name": "PSL Promotion-Relegation Playoff",
        "slug": "psl-promotion-relegation-playoff",
        "id": "SFAR"
      }
    ]
  },
  {
    "id": "157",
    "name": "Spain",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "LaLiga",
        "slug": "laliga",
        "id": "ES1"
      },
      {
        "name": "LaLiga2",
        "slug": "laliga2",
        "id": "ES2"
      },
      {
        "name": "Primera Federación - Gr. I",
        "slug": "primera-federacion-grupo-i",
        "id": "E3G1"
      },
      {
        "name": "Primera Federación - Gr. II",
        "slug": "primera-federacion-grupo-ii",
        "id": "E3G2"
      },
      {
        "name": "Segunda Federación - Gr. III",
        "slug": "segunda-federacion-grupo-iii",
        "id": "E4G3"
      },
      {
        "name": "Segunda Federación - Gr. V",
        "slug": "segunda-federacion-grupo-v",
        "id": "E4G5"
      },
      {
        "name": "Segunda Federación - Gr. IV",
        "slug": "segunda-federacion-grupo-iv",
        "id": "E4G4"
      },
      {
        "name": "Segunda Federación - Gr. I",
        "slug": "segunda-federacion-grupo-i",
        "id": "E4G1"
      },
      {
        "name": "Segunda Federación - Gr. II",
        "slug": "segunda-federacion-grupo-ii",
        "id": "E4G2"
      },
      {
        "name": "Copa del Rey",
        "slug": "copa-del-rey",
        "id": "CDR"
      },
      {
        "name": "Supercopa",
        "slug": "supercopa",
        "id": "SUC"
      },
      {
        "name": "Copa Federation",
        "slug": "copa-federation",
        "id": "CEF1"
      },
      {
        "name": "Segunda División B - Grupo I (- 20/21)",
        "slug": "segunda-division-b-grupo-i-20-21-",
        "id": "ES3A"
      },
      {
        "name": "Segunda División B - Grupo II (-20/21)",
        "slug": "segunda-division-b-grupo-ii-20-21-",
        "id": "ES3B"
      },
      {
        "name": "Segunda División B - Grupo III (-20/21)",
        "slug": "segunda-division-b-grupo-iii-20-21-",
        "id": "ES3C"
      },
      {
        "name": "Segunda División B - Grupo IV (-20/21)",
        "slug": "segunda-division-b-grupo-iv-20-21-",
        "id": "ES3D"
      },
      {
        "name": "Segunda División B - Grupo V (- 20/21)",
        "slug": "segunda-division-b-grupo-v-20-21-",
        "id": "ES3E"
      },
      {
        "name": "Promoción de ascenso a LaLiga",
        "slug": "promocion-de-ascenso-a-laliga",
        "id": "ES1P"
      },
      {
        "name": "Promoción de ascenso a LaLiga2",
        "slug": "promocion-de-ascenso-a-laliga2",
        "id": "ES2P"
      },
      {
        "name": "Promoción de ascenso a Primera Federación",
        "slug": "promocion-de-ascenso-a-primera-federacion",
        "id": "E3PP"
      },
      {
        "name": "Promoción de ascenso a Segunda Federación",
        "slug": "promocion-de-ascenso-a-segunda-federacion",
        "id": "E3PL"
      },
      {
        "name": "Promoción de permanencia en Segunda Federación",
        "slug": "promocion-de-permanencia-en-segunda-federacion",
        "id": "ES3P"
      },
      {
        "name": "Segunda División B - Fase de ascenso (-2021)",
        "slug": "segunda-division-b-fase-de-ascenso-2021-",
        "id": "E3FA"
      },
      {
        "name": "Segunda División B - Fase de descenso (-2021)",
        "slug": "segunda-division-b-fase-de-descenso-2021-",
        "id": "E3FD"
      },
      {
        "name": "Segunda División B - Fase intermedia (-2021)",
        "slug": "segunda-division-b-fase-intermedia-2021-",
        "id": "E3FI"
      },
      {
        "name": "Copa de Liga de Segunda División B (-1985)",
        "slug": "copa-de-liga-de-segunda-division-b-1985-",
        "id": "CDLB"
      },
      {
        "name": "Copa de la Liga (-1986)",
        "slug": "copa-de-la-liga-1986-",
        "id": "CDL1"
      },
      {
        "name": "Copa de la Liga de Segunda División (-1985)",
        "slug": "copa-de-la-liga-de-segunda-division-1985-",
        "id": "CDL2"
      }
    ]
  },
  {
    "id": "147",
    "name": "Sweden",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Allsvenskan",
        "slug": "allsvenskan",
        "id": "SE1"
      },
      {
        "name": "Superettan",
        "slug": "superettan",
        "id": "SE2"
      },
      {
        "name": "Ettan Norra",
        "slug": "ettan-norra",
        "id": "SE3N"
      },
      {
        "name": "Ettan Södra",
        "slug": "ettan-sodra",
        "id": "SE3S"
      },
      {
        "name": "Svenska Cupen",
        "slug": "svenska-cupen",
        "id": "SEC"
      },
      {
        "name": "U19 Allsvenskan",
        "slug": "u19-allsvenskan",
        "id": "SU19"
      },
      {
        "name": "U19 Allsvenskan Norra",
        "slug": "u19-allsvenskan-norra",
        "id": "JUNO"
      },
      {
        "name": "U19 Allsvenskan Södra",
        "slug": "u19-allsvenskan-sodra",
        "id": "JUS%C3%96"
      },
      {
        "name": "Supercupen",
        "slug": "supercupen",
        "id": "SES"
      },
      {
        "name": "Relegation Allsvenskan",
        "slug": "relegation-allsvenskan",
        "id": "RESE"
      },
      {
        "name": "Relegation Ettan",
        "slug": "relegation-ettan",
        "id": "REET"
      },
      {
        "name": "Relegation Superettan",
        "slug": "relegation-superettan",
        "id": "RESU"
      },
      {
        "name": "U19 Allsvenskan Slutspelet",
        "slug": "u19-allsvenskan-slutspelet",
        "id": "JUSL"
      },
      {
        "name": "U21 Allsvenskan Slutspelet",
        "slug": "u21-allsvenskan-slutspelet",
        "id": "S21P"
      },
      {
        "name": "Folksam U21 Allsvenskan Norra",
        "slug": "folksam-u21-allsvenskan-norra",
        "id": "S21N"
      },
      {
        "name": "Folksam U21 Allsvenskan Södra",
        "slug": "folksam-u21-allsvenskan-sodra",
        "id": "S21S"
      },
      {
        "name": "U21 Allsvenskan Mellersta",
        "slug": "u21-allsvenskan-mellersta",
        "id": "S21M"
      }
    ]
  },
  {
    "id": "148",
    "name": "Switzerland",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Super League",
        "slug": "super-league",
        "id": "C1"
      },
      {
        "name": "Challenge League",
        "slug": "challenge-league",
        "id": "C2"
      },
      {
        "name": "Promotion League",
        "slug": "promotion-league",
        "id": "CHPR"
      },
      {
        "name": "1. Liga gr. 1",
        "slug": "1-liga-classic-group-1",
        "id": "CHC1"
      },
      {
        "name": "1. Liga gr. 3",
        "slug": "1-liga-classic-group-3",
        "id": "CHC3"
      },
      {
        "name": "1. Liga gr. 2",
        "slug": "1-liga-classic-group-2",
        "id": "CHC2"
      },
      {
        "name": "2. Liga Inter - Gr. 1",
        "slug": "2-liga-interregional-gruppe-1",
        "id": "CIR1"
      },
      {
        "name": "2. Liga Inter - Gr. 5",
        "slug": "2-liga-interregional-gruppe-5",
        "id": "CIR5"
      },
      {
        "name": "2. Liga Inter - Gr. 2",
        "slug": "2-liga-interregional-gruppe-2",
        "id": "CIR2"
      },
      {
        "name": "2. Liga Inter - Gr. 3",
        "slug": "2-liga-interregional-gruppe-3",
        "id": "CIR3"
      },
      {
        "name": "2. Liga Inter - Gr. 4",
        "slug": "2-liga-interregional-gruppe-4",
        "id": "CIR4"
      },
      {
        "name": "U19 Elite League",
        "slug": "swiss-u19-elite-league",
        "id": "C191"
      },
      {
        "name": "U17 Elite League",
        "slug": "swiss-u17-elite-league",
        "id": "CH17"
      },
      {
        "name": "Swiss Cup",
        "slug": "swiss-cup",
        "id": "SCC"
      },
      {
        "name": "Swiss Cup qualifiers",
        "slug": "swiss-cup-qualifiers",
        "id": "SUIC"
      },
      {
        "name": "Schweizer Cup U19",
        "slug": "schweizer-cup-u19",
        "id": "C19C"
      },
      {
        "name": "Schweizer Cup U17",
        "slug": "schweizer-cup-u17",
        "id": "C17C"
      },
      {
        "name": "1. Liga Gruppe 4 (bis 99/00)",
        "slug": "1-liga-gruppe-4-bis-99-00-",
        "id": "1LG4"
      },
      {
        "name": "1. Liga group 1 (until 11/12)",
        "slug": "1-liga-group-1-until-11-12-",
        "id": "CR1"
      },
      {
        "name": "1. Liga group 2 (until 11/12)",
        "slug": "1-liga-group-2-until-11-12-",
        "id": "CR2"
      },
      {
        "name": "1. Liga group 3 (until 11/12)",
        "slug": "1-liga-group-3-until-11-12-",
        "id": "CR3"
      },
      {
        "name": "2. Liga interregional - Group 1 (- 11/12)",
        "slug": "2-liga-interregional-group-1-11-12-",
        "id": "C2I1"
      },
      {
        "name": "2. Liga interregional - Group 2 (- 11/12)",
        "slug": "2-liga-interregional-group-2-11-12-",
        "id": "C2I2"
      },
      {
        "name": "2. Liga interregional - Group 3 (- 11/12)",
        "slug": "2-liga-interregional-group-3-11-12-",
        "id": "C2I3"
      },
      {
        "name": "2. Liga interregional - Group 4 (- 11/12)",
        "slug": "2-liga-interregional-group-4-11-12-",
        "id": "C2I4"
      },
      {
        "name": "2. Liga interregional - Group 5 (- 11/12)",
        "slug": "2-liga-interregional-group-5-11-12-",
        "id": "C2I5"
      },
      {
        "name": "2. Liga interregional - Group 6 (- 11/12)",
        "slug": "2-liga-interregional-group-6-11-12-",
        "id": "C2I6"
      },
      {
        "name": "2. Liga interregional - Gruppe 6 (bis 21/22)",
        "slug": "2-liga-interregional-gruppe-6-bis-21-22-",
        "id": "CIR6"
      },
      {
        "name": "Swiss U18 Elite League (bis 22/23)",
        "slug": "swiss-u18-elite-league-bis-22-23-",
        "id": "CH18"
      },
      {
        "name": "Schweizer Ligacup (bis 81/82)",
        "slug": "schweizer-ligacup-bis-81-82-",
        "id": "SLGC"
      },
      {
        "name": "Schweizer Supercup (bis 89/90)",
        "slug": "schweizer-supercup-bis-89-90-",
        "id": "CHSU"
      },
      {
        "name": "1. Liga Playoff",
        "slug": "1-liga-playoff",
        "id": "SUIP"
      },
      {
        "name": "Auf-/Abstiegsrunde Nationalliga A/B",
        "slug": "auf-abstiegsrunde-nationalliga-a-b",
        "id": "CHAA"
      },
      {
        "name": "Challenge League Barrage",
        "slug": "challenge-league-barrage",
        "id": "CH3B"
      },
      {
        "name": "NLA - Entscheidungsspiele (bis 83/84)",
        "slug": "nla-entscheidungsspiele-bis-83-84-",
        "id": "CHAL"
      },
      {
        "name": "NLB - Entscheidungsspiele (bis 93/94)",
        "slug": "nlb-entscheidungsspiele-bis-93-94-",
        "id": "NLAB"
      },
      {
        "name": "Nationalliga A - Final round ( -2002/03)",
        "slug": "nationalliga-a-final-round-2002-03-",
        "id": "NLAF"
      },
      {
        "name": "Nationalliga B - Abstiegsrunde",
        "slug": "nationalliga-b-abstiegsrunde",
        "id": "NLBR"
      },
      {
        "name": "Promotion League - Abstiegsrunde (bis 21/22)",
        "slug": "promotion-league-abstiegsrunde-bis-21-22-",
        "id": "C3P2"
      },
      {
        "name": "Promotion League - Aufstiegsrunde (bis 21/22)",
        "slug": "promotion-league-aufstiegsrunde-bis-21-22-",
        "id": "C3P1"
      },
      {
        "name": "Promotion League - Qualification round (bis 21/22)",
        "slug": "promotion-league-qualification-round-bis-21-22-",
        "id": "C3P3"
      },
      {
        "name": "Super League Barrage",
        "slug": "super-league-barrage",
        "id": "BASU"
      },
      {
        "name": "Swiss U17 Elite Platzierungsspiele",
        "slug": "swiss-u17-elite-platzierungsspiele",
        "id": "C7PL"
      },
      {
        "name": "Swiss U17 Elite Playoffs",
        "slug": "swiss-u17-elite-playoffs",
        "id": "C17P"
      },
      {
        "name": "Swiss U17 Elite Playouts",
        "slug": "swiss-u17-elite-playouts",
        "id": "C7PO"
      },
      {
        "name": "Swiss U18 Elite Platzierungsspiele",
        "slug": "swiss-u18-elite-platzierungsspiele",
        "id": "CHP1"
      },
      {
        "name": "Swiss U18 Elite Playoffs",
        "slug": "swiss-u18-elite-playoffs",
        "id": "C18E"
      },
      {
        "name": "Swiss U18 Elite Playouts",
        "slug": "swiss-u18-elite-playouts",
        "id": "CHP2"
      },
      {
        "name": "Swiss U19 Elite Platzierungsspiele",
        "slug": "swiss-u19-elite-platzierungsspiele",
        "id": "C9PL"
      },
      {
        "name": "Swiss U19 Elite Playoffs",
        "slug": "swiss-u19-elite-playoffs",
        "id": "C9EP"
      },
      {
        "name": "Swiss U19 Elite Playouts",
        "slug": "swiss-u19-elite-playouts",
        "id": "C9PO"
      },
      {
        "name": "Schweizer Cup U18",
        "slug": "schweizer-cup-u18",
        "id": "CHUC"
      }
    ]
  },
  {
    "id": "163",
    "name": "Syria",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Syria Premier League AFC Cup Playoff",
        "slug": "syria-premier-league-afc-cup-playoff",
        "id": "SYP1"
      }
    ]
  },
  {
    "id": "165",
    "name": "Tajikistan",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Vysshaya Liga",
        "slug": "vysshaya-liga",
        "id": "TAD1"
      },
      {
        "name": "Tajik Supercup",
        "slug": "tajik-supercup",
        "id": "TADS"
      }
    ]
  },
  {
    "id": "167",
    "name": "Thailand",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Thai League",
        "slug": "thai-league",
        "id": "THA1"
      },
      {
        "name": "Thai League 2",
        "slug": "thai-league-2",
        "id": "THA2"
      },
      {
        "name": "Thai FA Cup",
        "slug": "thai-fa-cup",
        "id": "THFA"
      },
      {
        "name": "T3 Champions League",
        "slug": "thai-league-3-champions-league",
        "id": "T3LC"
      },
      {
        "name": "Thai Cup",
        "slug": "thai-cup",
        "id": "THLC"
      },
      {
        "name": "Thailand Champions Cup",
        "slug": "thailand-champions-cup",
        "id": "THCC"
      },
      {
        "name": "Thai League 2 Playoff",
        "slug": "thai-league-2-playoff",
        "id": "TH2P"
      }
    ]
  },
  {
    "id": "173",
    "name": "Tunisia",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Ligue 1",
        "slug": "ligue-1",
        "id": "TUN1"
      },
      {
        "name": "Tunisian Cup",
        "slug": "tunisian-cup",
        "id": "TUNP"
      },
      {
        "name": "Tunesischer Supercup",
        "slug": "tunesischer-supercup",
        "id": "TUSC"
      },
      {
        "name": "Ligue Professionelle 1 - Playoff",
        "slug": "ligue-professionelle-1-playoff",
        "id": "TUNM"
      },
      {
        "name": "Ligue Professionelle 1 - Playoff II",
        "slug": "ligue-professionelle-1-playoff-ii",
        "id": "TPL2"
      },
      {
        "name": "Ligue Professionelle 1 - Playout",
        "slug": "ligue-professionelle-1-playout",
        "id": "TUPL"
      },
      {
        "name": "Ligue Professionelle 1 - Relegation",
        "slug": "ligue-professionelle-1-relegation",
        "id": "TUNR"
      }
    ]
  },
  {
    "id": "174",
    "name": "Türkiye",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Süper Lig",
        "slug": "super-lig",
        "id": "TR1"
      },
      {
        "name": "1.Lig",
        "slug": "1-lig",
        "id": "TR2"
      },
      {
        "name": "2.Lig Kirmizi",
        "slug": "2-lig-kirmizi",
        "id": "TR3B"
      },
      {
        "name": "2.Lig Beyaz",
        "slug": "2-lig-beyaz",
        "id": "TR3A"
      },
      {
        "name": "3.Lig Grup 3",
        "slug": "3-lig-grup-3",
        "id": "TR4C"
      },
      {
        "name": "3.Lig Grup 2",
        "slug": "3-lig-grup-2",
        "id": "TR4B"
      },
      {
        "name": "3.Lig Grup 1",
        "slug": "3-lig-grup-1",
        "id": "TR4A"
      },
      {
        "name": "3.Lig Grup 4",
        "slug": "3-lig-grup-4",
        "id": "TR4D"
      },
      {
        "name": "U19 Süper Lig",
        "slug": "u19-super-lig",
        "id": "T191"
      },
      {
        "name": "Türkiye Kupasi",
        "slug": "turkiye-kupasi",
        "id": "TRP"
      },
      {
        "name": "TFF Süper Kupa",
        "slug": "tff-super-kupa",
        "id": "TRS"
      },
      {
        "name": "U21 1.Lig",
        "slug": "u21-1-lig",
        "id": "T212"
      },
      {
        "name": "U21 Süper Lig",
        "slug": "u21-super-lig",
        "id": "T211"
      },
      {
        "name": "1.Lig Playoff",
        "slug": "1-lig-playoff",
        "id": "POT2"
      },
      {
        "name": "2.Lig Playoff",
        "slug": "2-lig-playoff",
        "id": "TR3P"
      },
      {
        "name": "3.Lig Playoff",
        "slug": "3-lig-playoff",
        "id": "TR4P"
      },
      {
        "name": "Bölgesel Amatör Lig Playoff",
        "slug": "bolgesel-amator-lig-playoff",
        "id": "T4PL"
      },
      {
        "name": "National league relegation",
        "slug": "national-league-relegation",
        "id": "TRP4"
      },
      {
        "name": "Süper Final - Championship Round",
        "slug": "super-final-championship-round",
        "id": "POT1"
      },
      {
        "name": "Süper Final - Europa League Playoff",
        "slug": "super-final-europa-league-playoff",
        "id": "POT3"
      },
      {
        "name": "Süper Lig - Championship Finals",
        "slug": "super-lig-championship-finals",
        "id": "TRF1"
      },
      {
        "name": "Süper Lig U19 Playoff",
        "slug": "super-lig-u19-playoff",
        "id": "T19P"
      },
      {
        "name": "U19 Süper Lig Playout",
        "slug": "u19-super-lig-playout",
        "id": "T192"
      },
      {
        "name": "Süper Lig Reserves League",
        "slug": "super-lig-reserves-league",
        "id": "TRP2"
      }
    ]
  },
  {
    "id": "221",
    "name": "UdSSR",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Vyschaya Liga (- 1991)",
        "slug": "vyschaya-liga-1991-",
        "id": "SU1L"
      },
      {
        "name": "Vyschaya Liga autumn championship (- 1976)",
        "slug": "vyschaya-liga-autumn-championship-1976-",
        "id": "SU1H"
      },
      {
        "name": "Pervaya Liga (-1991)",
        "slug": "pervaya-liga-1991-",
        "id": "SU2L"
      },
      {
        "name": "Soviet Cup (- 1992)",
        "slug": "soviet-cup-1992-",
        "id": "SVP1"
      },
      {
        "name": "Vyschaya Liga Champion Round (- 1991)",
        "slug": "vyschaya-liga-champion-round-1991-",
        "id": "SU1M"
      },
      {
        "name": "Vyschaya Liga Relegation Round (- 1991)",
        "slug": "vyschaya-liga-relegation-round-1991-",
        "id": "SU1A"
      }
    ]
  },
  {
    "id": "176",
    "name": "Uganda",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Uganda Premier League",
        "slug": "uganda-premier-league",
        "id": "UGL1"
      }
    ]
  },
  {
    "id": "177",
    "name": "Ukraine",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Premier Liga",
        "slug": "premier-liga",
        "id": "UKR1"
      },
      {
        "name": "Persha Liga",
        "slug": "persha-liga",
        "id": "UKR2"
      },
      {
        "name": "Druga Liga",
        "slug": "druga-liga",
        "id": "UA3L"
      },
      {
        "name": "U19 Premier Liga",
        "slug": "u19-premier-liga",
        "id": "UA19"
      },
      {
        "name": "Ukrainian Cup",
        "slug": "ukrainian-cup",
        "id": "UKRP"
      },
      {
        "name": "Ukrainian Super Cup",
        "slug": "ukrainian-super-cup",
        "id": "UKRS"
      },
      {
        "name": "Championship playoff Vyshcha Liga",
        "slug": "championship-playoff-vyshcha-liga",
        "id": "UKRR"
      },
      {
        "name": "Druga Liga Meisterschafts-Playoff",
        "slug": "druga-liga-meisterschafts-playoff",
        "id": "UA3P"
      },
      {
        "name": "Premier Liga - Abstiegsrunde",
        "slug": "premier-liga-abstiegsrunde",
        "id": "UKRA"
      },
      {
        "name": "Premier Liga - Europa League Playoff",
        "slug": "premier-liga-europa-league-playoff",
        "id": "UKRL"
      },
      {
        "name": "Premier Liga - Final Phase",
        "slug": "premier-liga-final-phase",
        "id": "UKRM"
      },
      {
        "name": "Relegation Persha Liga",
        "slug": "relegation-persha-liga",
        "id": "UKRE"
      },
      {
        "name": "Relegation Premier Liga",
        "slug": "relegation-premier-liga",
        "id": "UARP"
      },
      {
        "name": "UPL relegation tournament",
        "slug": "upl-relegation-tournament",
        "id": "UART"
      }
    ]
  },
  {
    "id": "183",
    "name": "United Arab Emirates",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "UAE Pro League",
        "slug": "uae-pro-league",
        "id": "UAE1"
      },
      {
        "name": "UAE President's Cup",
        "slug": "uae-presidents-cup",
        "id": "UAEP"
      },
      {
        "name": "UAE Super Cup",
        "slug": "uae-super-cup",
        "id": "UASC"
      },
      {
        "name": "UAE League Cup",
        "slug": "uae-league-cup",
        "id": "UALC"
      }
    ]
  },
  {
    "id": "184",
    "name": "United States",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "MLS",
        "slug": "major-league-soccer",
        "id": "MLS1"
      },
      {
        "name": "USLC",
        "slug": "usl-championship",
        "id": "USL"
      },
      {
        "name": "MLS Next Pro",
        "slug": "mls-next-pro",
        "id": "MNP3"
      },
      {
        "name": "USL1",
        "slug": "usl-league-one",
        "id": "USC3"
      },
      {
        "name": "US Open Cup",
        "slug": "us-open-cup",
        "id": "MLSP"
      },
      {
        "name": "USL Cup",
        "slug": "usl-cup",
        "id": "USLC"
      },
      {
        "name": "USL Division One",
        "slug": "usl-division-one",
        "id": "US1L"
      },
      {
        "name": "NASL Fall Championship (2013 - 2017)",
        "slug": "nasl-fall-championship-2013-2017-",
        "id": "NAFC"
      },
      {
        "name": "NASL Spring Championship (2013 - 2017)",
        "slug": "nasl-spring-championship-2013-2017-",
        "id": "NASC"
      },
      {
        "name": "North American Soccer League (2011 - 2012)",
        "slug": "north-american-soccer-league-2011-2012-",
        "id": "USA2"
      },
      {
        "name": "USL First Division (2005 - 2009)",
        "slug": "usl-first-division-2005-2009-",
        "id": "USFD"
      },
      {
        "name": "USSF Division 2 Professional League (2010)",
        "slug": "ussf-division-2-professional-league-2010-",
        "id": "UD2L"
      },
      {
        "name": "NISA",
        "slug": "nisa",
        "id": "NIS3"
      },
      {
        "name": "NISA Fall Season (- 2021)",
        "slug": "nisa-fall-season-2021-",
        "id": "NIFS"
      },
      {
        "name": "NISA Spring Season (- 2021)",
        "slug": "nisa-spring-season-2021-",
        "id": "NISR"
      },
      {
        "name": "MLS Cup Playoffs",
        "slug": "mls-cup-playoffs",
        "id": "POUS"
      },
      {
        "name": "MLS Next Pro Playoffs",
        "slug": "mls-next-pro-playoffs",
        "id": "MNPP"
      },
      {
        "name": "MLS is Back Tournament (2020)",
        "slug": "mls-is-back-tournament-2020-",
        "id": "USSP"
      },
      {
        "name": "NASL Playoffs (2011 - 2017)",
        "slug": "nasl-playoffs-2011-2017-",
        "id": "NAPL"
      },
      {
        "name": "NISA Championship Playoffs",
        "slug": "nisa-championship-playoffs",
        "id": "NICP"
      },
      {
        "name": "NISA Fall Season Playoffs",
        "slug": "nisa-fall-season-playoffs",
        "id": "NIFP"
      },
      {
        "name": "NISA Spring Season Playoffs",
        "slug": "nisa-spring-season-playoffs",
        "id": "NISO"
      },
      {
        "name": "USL First Division Playoffs (2005 - 2009)",
        "slug": "usl-first-division-playoffs-2005-2009-",
        "id": "UFDP"
      },
      {
        "name": "USL League One Playoffs",
        "slug": "usl-league-one-playoffs",
        "id": "US3P"
      },
      {
        "name": "USL League Two Playoffs",
        "slug": "usl-league-two-playoffs",
        "id": "UL2P"
      },
      {
        "name": "USLC Playoffs",
        "slug": "uslc-playoffs",
        "id": "USLP"
      },
      {
        "name": "USSF Division 2 Professional League Playoffs",
        "slug": "ussf-division-2-professional-league-playoffs",
        "id": "UD2P"
      },
      {
        "name": "NISA Legends Cup",
        "slug": "nisa-legends-cup",
        "id": "NLCU"
      },
      {
        "name": "NCAA Division 1 Men's Soccer Championship",
        "slug": "ncaa-division-1-mens-soccer-championship",
        "id": "NCD1"
      },
      {
        "name": "MLS Reserve League",
        "slug": "mls-reserve-league",
        "id": "MLSR"
      }
    ]
  },
  {
    "id": "179",
    "name": "Uruguay",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga AUF Apertura",
        "slug": "liga-auf-apertura",
        "id": "URU1"
      },
      {
        "name": "Torneo Competencia",
        "slug": "segunda-division-torneo-competencia",
        "id": "UR2T"
      },
      {
        "name": "Segunda División",
        "slug": "segunda-division-fase-regular",
        "id": "URU2"
      },
      {
        "name": "Supercopa",
        "slug": "supercopa-uruguaya",
        "id": "URSC"
      },
      {
        "name": "Campeonato Uruguayo Especial",
        "slug": "campeonato-uruguayo-especial",
        "id": "URUE"
      },
      {
        "name": "Liga AUF Clausura",
        "slug": "liga-auf-clausura",
        "id": "URUC"
      },
      {
        "name": "Liga AUF Intermedio",
        "slug": "liga-auf-intermedio",
        "id": "URUI"
      },
      {
        "name": "Segunda División Profesional - Especial (2016)",
        "slug": "segunda-division-profesional-especial-2016-",
        "id": "URE2"
      },
      {
        "name": "Segunda División Profesional - Segunda Fase",
        "slug": "segunda-division-profesional-segunda-fase",
        "id": "UR2S"
      },
      {
        "name": "Copa AUF Uruguay",
        "slug": "copa-auf-uruguay",
        "id": "URP1"
      },
      {
        "name": "Liguilla Pre-Libertadores",
        "slug": "liguilla-pre-libertadores",
        "id": "URPL"
      },
      {
        "name": "Playoffs Liga AUF",
        "slug": "playoffs-liga-auf",
        "id": "URUP"
      },
      {
        "name": "Segunda División Play-off",
        "slug": "segunda-division-play-off",
        "id": "URU3"
      },
      {
        "name": "Copa de la Liga AUF",
        "slug": "copa-de-la-liga-auf",
        "id": "URLP"
      }
    ]
  },
  {
    "id": "180",
    "name": "Uzbekistan",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Superliga",
        "slug": "ozbekiston-superligasi",
        "id": "UZ1"
      },
      {
        "name": "O'zbekiston Pro Liga",
        "slug": "ozbekiston-pro-liga",
        "id": "UZ2L"
      },
      {
        "name": "Uzbekistan Supercup",
        "slug": "uzbekistan-supercup",
        "id": "UZSC"
      },
      {
        "name": "Uzbekistan Cup",
        "slug": "uzbekistan-cup",
        "id": "KOBU"
      },
      {
        "name": "Relegation Superligasi",
        "slug": "relegation-superligasi",
        "id": "UZR"
      },
      {
        "name": "Superligasi Championship-Playoff",
        "slug": "superligasi-championship-playoff",
        "id": "UZP1"
      },
      {
        "name": "Superligasi Relegation-Playoff",
        "slug": "superligasi-relegation-playoff",
        "id": "UZP2"
      }
    ]
  },
  {
    "id": "182",
    "name": "Venezuela",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Liga FUTVE Apertura",
        "slug": "liga-futve-apertura",
        "id": "VZ1A"
      },
      {
        "name": "Liga FUTVE 2",
        "slug": "liga-futve-2",
        "id": "VN2A"
      },
      {
        "name": "Liga FUTVE",
        "slug": "liga-futve",
        "id": "VZ1L"
      },
      {
        "name": "Liga FUTVE Clausura",
        "slug": "liga-futve-clausura",
        "id": "VZ1C"
      },
      {
        "name": "Liga FUTVE 2. Segunda Fase",
        "slug": "liga-futve-2-segunda-fase",
        "id": "VN2C"
      },
      {
        "name": "Copa Venezuela",
        "slug": "copa-venezuela",
        "id": "VEC1"
      },
      {
        "name": "Liga FUTVE Apertura. Fase Final",
        "slug": "liga-futve-apertura-fase-final",
        "id": "VZOA"
      },
      {
        "name": "Liga FUTVE 2 - Fase Final",
        "slug": "liga-futve-2-fase-final",
        "id": "VZP3"
      },
      {
        "name": "Liga FUTVE 2. Primera Fase-Octagonal",
        "slug": "liga-futve-2-primera-fase-octagonal",
        "id": "V2AP"
      },
      {
        "name": "Liga FUTVE 2. Segunda Fase-Octagonal",
        "slug": "liga-futve-2-segunda-fase-octagonal",
        "id": "V2CP"
      },
      {
        "name": "Liga FUTVE Clausura. Fase Final",
        "slug": "liga-futve-clausura-fase-final",
        "id": "VZOC"
      },
      {
        "name": "Liga FUTVE Playoffs",
        "slug": "liga-futve-playoffs",
        "id": "VZ1P"
      }
    ]
  },
  {
    "id": "185",
    "name": "Vietnam",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "V.League 1",
        "slug": "v-league-1",
        "id": "VIE1"
      },
      {
        "name": "Vietnam Cup",
        "slug": "vietnamese-cup",
        "id": "VPO1"
      },
      {
        "name": "Vietnamese Super Cup",
        "slug": "vietnamese-super-cup",
        "id": "VSCU"
      }
    ]
  },
  {
    "id": "191",
    "name": "Wales",
    "icon": "https://tmsi.akamaized.net/breadcrumb/bc-countries.svg",
    "leagues": [
      {
        "name": "Cymru Premier",
        "slug": "cymru-premier",
        "id": "WAL1"
      },
      {
        "name": "Cymru North",
        "slug": "cymru-north",
        "id": "WAL2"
      },
      {
        "name": "Cymru South",
        "slug": "cymru-south",
        "id": "WA2S"
      },
      {
        "name": "Welsh Cup",
        "slug": "welsh-cup",
        "id": "WALE"
      },
      {
        "name": "Welsh League Cup",
        "slug": "welsh-league-cup",
        "id": "WALC"
      },
      {
        "name": "Tier Two League Cup",
        "slug": "welsh-tier-two-league-cup",
        "id": "WALM"
      },
      {
        "name": "Cymru Premier Playoff",
        "slug": "cymru-premier-playoff",
        "id": "WALP"
      },
      {
        "name": "Cymru Premier Relegation Conference",
        "slug": "cymru-premier-relegation-conference",
        "id": "WALR"
      },
      {
        "name": "FAW Premier Cup",
        "slug": "faw-premier-cup",
        "id": "WLC1"
      }
    ]
  }
];